import { i as Vt, r as Be, t as Kt } from "./chunk-Bpqwac5z.js";
import { n as j, t as qt } from "./Logger-CmiOOsKC.js";
import { f as Xt } from "./tracebehavior-5_qSKjs6.js";
import { G as et, W as He, a as Yt, c as Jt, d as Qt, f as es, g as ts, i as tt, l as ss, n as ns, p as Ie, r as rs, t as fe, u as is } from "./SceneCreation-DVCYLXYF.js";
import { t as os } from "./TransitionManager-BD_yHXIb.js";
import { V as st, Y as as, i as nt, r as rt, t as cs } from "./ScriptRegistry-C3vqndus.js";
import { n as it, r as ls, t as ot } from "./boxcollider-DfK5pGI3.js";
import { d as Ft, t as Ne } from "./properties-C_pgb9zu.js";
import { a as at, t as ct } from "./AssetTypes-DUDo9FdH.js";
import { t as he } from "./Utility-CviQuQTA.js";
import { i as Ue } from "./browser-w1WAp8je.js";
import "./configdata-C580O024.js";
import { t as lt } from "./abort-qw0xAdg5.js";
import { a as hs, d as ht, f as ut, n as us, o as ds, p as fs, t as Xe, u as dt } from "./GltfSceneLoaderPlugin-g47wYMf3.js";
import { Matrix as Ze, Quaternion as we, Vector2 as xe, Vector3 as _e } from "@babylonjs/core/Maths/math.vector.js";
import { LoadAssetContainerAsync as je } from "@babylonjs/core/Loading/sceneLoader.js";
import { Color3 as ft, Color4 as Ge } from "@babylonjs/core/Maths/math.color.js";
import { TransformNode as Pt } from "@babylonjs/core/Meshes/transformNode.js";
import { Scene as ps } from "@babylonjs/core/scene.js";
import { Tools as ms } from "@babylonjs/core/Misc/tools.js";
import { DirectionalLight as gs } from "@babylonjs/core/Lights/directionalLight.js";
import { GLTFLoaderAnimationStartMode as _s } from "@babylonjs/loaders/glTF/glTFFileLoader.pure.js";
import { RetryStrategy as bs } from "@babylonjs/core/Misc/retryStrategy.js";
import { AssetContainer as vs } from "@babylonjs/core/assetContainer.js";
import { HDRCubeTexture as pt } from "@babylonjs/core/Materials/Textures/hdrCubeTexture.js";
import { FreeCamera as ys } from "@babylonjs/core/Cameras/freeCamera.js";
import { Camera as ws } from "@babylonjs/core/Cameras/camera.js";
import { RenderTargetTexture as mt } from "@babylonjs/core/Materials/Textures/renderTargetTexture.js";
import { BlurPostProcess as Ss } from "@babylonjs/core/PostProcesses/blurPostProcess.js";
import { ShaderMaterial as ks } from "@babylonjs/core/Materials/shaderMaterial.js";
import { Effect as gt } from "@babylonjs/core/Materials/effect.js";
import { CreateGround as Rs } from "@babylonjs/core/Meshes/Builders/groundBuilder.js";
import { RenderingGroup as Cs } from "@babylonjs/core/Rendering/renderingGroup.js";
var xs = /* @__PURE__ */ Kt(((f, e) => {
  (function(t) {
    typeof f == "object" && typeof e < "u" ? e.exports = t() : typeof define == "function" && define.amd ? define([], t) : (typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this).JSZip = t();
  })(function() {
    return (function t(n, s, r) {
      function i(l, g) {
        if (!s[l]) {
          if (!n[l]) {
            var p = typeof Be == "function" && Be;
            if (!g && p) return p(l, !0);
            if (o) return o(l, !0);
            var m = /* @__PURE__ */ new Error("Cannot find module '" + l + "'");
            throw m.code = "MODULE_NOT_FOUND", m;
          }
          var u = s[l] = { exports: {} };
          n[l][0].call(u.exports, function(b) {
            var h = n[l][1][b];
            return i(h || b);
          }, u, u.exports, t, n, s, r);
        }
        return s[l].exports;
      }
      for (var o = typeof Be == "function" && Be, a = 0; a < r.length; a++) i(r[a]);
      return i;
    })({
      1: [function(t, n, s) {
        "use strict";
        var r = t("./utils"), i = t("./support"), o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        s.encode = function(a) {
          for (var l, g, p, m, u, b, h, v = [], _ = 0, y = a.length, R = y, k = r.getTypeOf(a) !== "string"; _ < a.length; ) R = y - _, p = k ? (l = a[_++], g = _ < y ? a[_++] : 0, _ < y ? a[_++] : 0) : (l = a.charCodeAt(_++), g = _ < y ? a.charCodeAt(_++) : 0, _ < y ? a.charCodeAt(_++) : 0), m = l >> 2, u = (3 & l) << 4 | g >> 4, b = 1 < R ? (15 & g) << 2 | p >> 6 : 64, h = 2 < R ? 63 & p : 64, v.push(o.charAt(m) + o.charAt(u) + o.charAt(b) + o.charAt(h));
          return v.join("");
        }, s.decode = function(a) {
          var l, g, p, m, u, b, h = 0, v = 0, _ = "data:";
          if (a.substr(0, _.length) === _) throw new Error("Invalid base64 input, it looks like a data url.");
          var y, R = 3 * (a = a.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
          if (a.charAt(a.length - 1) === o.charAt(64) && R--, a.charAt(a.length - 2) === o.charAt(64) && R--, R % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
          for (y = i.uint8array ? new Uint8Array(0 | R) : new Array(0 | R); h < a.length; ) l = o.indexOf(a.charAt(h++)) << 2 | (m = o.indexOf(a.charAt(h++))) >> 4, g = (15 & m) << 4 | (u = o.indexOf(a.charAt(h++))) >> 2, p = (3 & u) << 6 | (b = o.indexOf(a.charAt(h++))), y[v++] = l, u !== 64 && (y[v++] = g), b !== 64 && (y[v++] = p);
          return y;
        };
      }, {
        "./support": 30,
        "./utils": 32
      }],
      2: [function(t, n, s) {
        "use strict";
        var r = t("./external"), i = t("./stream/DataWorker"), o = t("./stream/Crc32Probe"), a = t("./stream/DataLengthProbe");
        function l(g, p, m, u, b) {
          this.compressedSize = g, this.uncompressedSize = p, this.crc32 = m, this.compression = u, this.compressedContent = b;
        }
        l.prototype = {
          getContentWorker: function() {
            var g = new i(r.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), p = this;
            return g.on("end", function() {
              if (this.streamInfo.data_length !== p.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
            }), g;
          },
          getCompressedWorker: function() {
            return new i(r.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
          }
        }, l.createWorkerFrom = function(g, p, m) {
          return g.pipe(new o()).pipe(new a("uncompressedSize")).pipe(p.compressWorker(m)).pipe(new a("compressedSize")).withStreamInfo("compression", p);
        }, n.exports = l;
      }, {
        "./external": 6,
        "./stream/Crc32Probe": 25,
        "./stream/DataLengthProbe": 26,
        "./stream/DataWorker": 27
      }],
      3: [function(t, n, s) {
        "use strict";
        var r = t("./stream/GenericWorker");
        s.STORE = {
          magic: "\0\0",
          compressWorker: function() {
            return new r("STORE compression");
          },
          uncompressWorker: function() {
            return new r("STORE decompression");
          }
        }, s.DEFLATE = t("./flate");
      }, {
        "./flate": 7,
        "./stream/GenericWorker": 28
      }],
      4: [function(t, n, s) {
        "use strict";
        var r = t("./utils"), i = (function() {
          for (var o, a = [], l = 0; l < 256; l++) {
            o = l;
            for (var g = 0; g < 8; g++) o = 1 & o ? 3988292384 ^ o >>> 1 : o >>> 1;
            a[l] = o;
          }
          return a;
        })();
        n.exports = function(o, a) {
          return o !== void 0 && o.length ? r.getTypeOf(o) !== "string" ? (function(l, g, p, m) {
            var u = i, b = m + p;
            l ^= -1;
            for (var h = m; h < b; h++) l = l >>> 8 ^ u[255 & (l ^ g[h])];
            return -1 ^ l;
          })(0 | a, o, o.length, 0) : (function(l, g, p, m) {
            var u = i, b = m + p;
            l ^= -1;
            for (var h = m; h < b; h++) l = l >>> 8 ^ u[255 & (l ^ g.charCodeAt(h))];
            return -1 ^ l;
          })(0 | a, o, o.length, 0) : 0;
        };
      }, { "./utils": 32 }],
      5: [function(t, n, s) {
        "use strict";
        s.base64 = !1, s.binary = !1, s.dir = !1, s.createFolders = !0, s.date = null, s.compression = null, s.compressionOptions = null, s.comment = null, s.unixPermissions = null, s.dosPermissions = null;
      }, {}],
      6: [function(t, n, s) {
        "use strict";
        var r = null;
        r = typeof Promise < "u" ? Promise : t("lie"), n.exports = { Promise: r };
      }, { lie: 37 }],
      7: [function(t, n, s) {
        "use strict";
        var r = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", i = t("pako"), o = t("./utils"), a = t("./stream/GenericWorker"), l = r ? "uint8array" : "array";
        function g(p, m) {
          a.call(this, "FlateWorker/" + p), this._pako = null, this._pakoAction = p, this._pakoOptions = m, this.meta = {};
        }
        s.magic = "\b\0", o.inherits(g, a), g.prototype.processChunk = function(p) {
          this.meta = p.meta, this._pako === null && this._createPako(), this._pako.push(o.transformTo(l, p.data), !1);
        }, g.prototype.flush = function() {
          a.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
        }, g.prototype.cleanUp = function() {
          a.prototype.cleanUp.call(this), this._pako = null;
        }, g.prototype._createPako = function() {
          this._pako = new i[this._pakoAction]({
            raw: !0,
            level: this._pakoOptions.level || -1
          });
          var p = this;
          this._pako.onData = function(m) {
            p.push({
              data: m,
              meta: p.meta
            });
          };
        }, s.compressWorker = function(p) {
          return new g("Deflate", p);
        }, s.uncompressWorker = function() {
          return new g("Inflate", {});
        };
      }, {
        "./stream/GenericWorker": 28,
        "./utils": 32,
        pako: 38
      }],
      8: [function(t, n, s) {
        "use strict";
        function r(u, b) {
          var h, v = "";
          for (h = 0; h < b; h++) v += String.fromCharCode(255 & u), u >>>= 8;
          return v;
        }
        function i(u, b, h, v, _, y) {
          var R, k, x = u.file, z = u.compression, B = y !== l.utf8encode, $ = o.transformTo("string", y(x.name)), O = o.transformTo("string", l.utf8encode(x.name)), q = x.comment, J = o.transformTo("string", y(q)), C = o.transformTo("string", l.utf8encode(q)), F = O.length !== x.name.length, d = C.length !== q.length, D = "", ee = "", U = "", se = x.dir, W = x.date, Q = {
            crc32: 0,
            compressedSize: 0,
            uncompressedSize: 0
          };
          b && !h || (Q.crc32 = u.crc32, Q.compressedSize = u.compressedSize, Q.uncompressedSize = u.uncompressedSize);
          var P = 0;
          b && (P |= 8), B || !F && !d || (P |= 2048);
          var T = 0, X = 0;
          se && (T |= 16), _ === "UNIX" ? (X = 798, T |= (function(H, te) {
            var oe = H;
            return H || (oe = te ? 16893 : 33204), (65535 & oe) << 16;
          })(x.unixPermissions, se)) : (X = 20, T |= (function(H) {
            return 63 & (H || 0);
          })(x.dosPermissions)), R = W.getUTCHours(), R <<= 6, R |= W.getUTCMinutes(), R <<= 5, R |= W.getUTCSeconds() / 2, k = W.getUTCFullYear() - 1980, k <<= 4, k |= W.getUTCMonth() + 1, k <<= 5, k |= W.getUTCDate(), F && (ee = r(1, 1) + r(g($), 4) + O, D += "up" + r(ee.length, 2) + ee), d && (U = r(1, 1) + r(g(J), 4) + C, D += "uc" + r(U.length, 2) + U);
          var V = "";
          return V += `
\0`, V += r(P, 2), V += z.magic, V += r(R, 2), V += r(k, 2), V += r(Q.crc32, 4), V += r(Q.compressedSize, 4), V += r(Q.uncompressedSize, 4), V += r($.length, 2), V += r(D.length, 2), {
            fileRecord: p.LOCAL_FILE_HEADER + V + $ + D,
            dirRecord: p.CENTRAL_FILE_HEADER + r(X, 2) + V + r(J.length, 2) + "\0\0\0\0" + r(T, 4) + r(v, 4) + $ + D + J
          };
        }
        var o = t("../utils"), a = t("../stream/GenericWorker"), l = t("../utf8"), g = t("../crc32"), p = t("../signature");
        function m(u, b, h, v) {
          a.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = b, this.zipPlatform = h, this.encodeFileName = v, this.streamFiles = u, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
        }
        o.inherits(m, a), m.prototype.push = function(u) {
          var b = u.meta.percent || 0, h = this.entriesCount, v = this._sources.length;
          this.accumulate ? this.contentBuffer.push(u) : (this.bytesWritten += u.data.length, a.prototype.push.call(this, {
            data: u.data,
            meta: {
              currentFile: this.currentFile,
              percent: h ? (b + 100 * (h - v - 1)) / h : 100
            }
          }));
        }, m.prototype.openedSource = function(u) {
          this.currentSourceOffset = this.bytesWritten, this.currentFile = u.file.name;
          var b = this.streamFiles && !u.file.dir;
          if (b) {
            var h = i(u, b, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
            this.push({
              data: h.fileRecord,
              meta: { percent: 0 }
            });
          } else this.accumulate = !0;
        }, m.prototype.closedSource = function(u) {
          this.accumulate = !1;
          var b = this.streamFiles && !u.file.dir, h = i(u, b, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          if (this.dirRecords.push(h.dirRecord), b) this.push({
            data: (function(v) {
              return p.DATA_DESCRIPTOR + r(v.crc32, 4) + r(v.compressedSize, 4) + r(v.uncompressedSize, 4);
            })(u),
            meta: { percent: 100 }
          });
          else for (this.push({
            data: h.fileRecord,
            meta: { percent: 0 }
          }); this.contentBuffer.length; ) this.push(this.contentBuffer.shift());
          this.currentFile = null;
        }, m.prototype.flush = function() {
          for (var u = this.bytesWritten, b = 0; b < this.dirRecords.length; b++) this.push({
            data: this.dirRecords[b],
            meta: { percent: 100 }
          });
          var h = this.bytesWritten - u, v = (function(_, y, R, k, x) {
            var z = o.transformTo("string", x(k));
            return p.CENTRAL_DIRECTORY_END + "\0\0\0\0" + r(_, 2) + r(_, 2) + r(y, 4) + r(R, 4) + r(z.length, 2) + z;
          })(this.dirRecords.length, h, u, this.zipComment, this.encodeFileName);
          this.push({
            data: v,
            meta: { percent: 100 }
          });
        }, m.prototype.prepareNextSource = function() {
          this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
        }, m.prototype.registerPrevious = function(u) {
          this._sources.push(u);
          var b = this;
          return u.on("data", function(h) {
            b.processChunk(h);
          }), u.on("end", function() {
            b.closedSource(b.previous.streamInfo), b._sources.length ? b.prepareNextSource() : b.end();
          }), u.on("error", function(h) {
            b.error(h);
          }), this;
        }, m.prototype.resume = function() {
          return !!a.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
        }, m.prototype.error = function(u) {
          var b = this._sources;
          if (!a.prototype.error.call(this, u)) return !1;
          for (var h = 0; h < b.length; h++) try {
            b[h].error(u);
          } catch {
          }
          return !0;
        }, m.prototype.lock = function() {
          a.prototype.lock.call(this);
          for (var u = this._sources, b = 0; b < u.length; b++) u[b].lock();
        }, n.exports = m;
      }, {
        "../crc32": 4,
        "../signature": 23,
        "../stream/GenericWorker": 28,
        "../utf8": 31,
        "../utils": 32
      }],
      9: [function(t, n, s) {
        "use strict";
        var r = t("../compressions"), i = t("./ZipFileWorker");
        s.generateWorker = function(o, a, l) {
          var g = new i(a.streamFiles, l, a.platform, a.encodeFileName), p = 0;
          try {
            o.forEach(function(m, u) {
              p++;
              var b = (function(y, R) {
                var k = y || R, x = r[k];
                if (!x) throw new Error(k + " is not a valid compression method !");
                return x;
              })(u.options.compression, a.compression), h = u.options.compressionOptions || a.compressionOptions || {}, v = u.dir, _ = u.date;
              u._compressWorker(b, h).withStreamInfo("file", {
                name: m,
                dir: v,
                date: _,
                comment: u.comment || "",
                unixPermissions: u.unixPermissions,
                dosPermissions: u.dosPermissions
              }).pipe(g);
            }), g.entriesCount = p;
          } catch (m) {
            g.error(m);
          }
          return g;
        };
      }, {
        "../compressions": 3,
        "./ZipFileWorker": 8
      }],
      10: [function(t, n, s) {
        "use strict";
        function r() {
          if (!(this instanceof r)) return new r();
          if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
          this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
            var i = new r();
            for (var o in this) typeof this[o] != "function" && (i[o] = this[o]);
            return i;
          };
        }
        (r.prototype = t("./object")).loadAsync = t("./load"), r.support = t("./support"), r.defaults = t("./defaults"), r.version = "3.10.1", r.loadAsync = function(i, o) {
          return new r().loadAsync(i, o);
        }, r.external = t("./external"), n.exports = r;
      }, {
        "./defaults": 5,
        "./external": 6,
        "./load": 11,
        "./object": 15,
        "./support": 30
      }],
      11: [function(t, n, s) {
        "use strict";
        var r = t("./utils"), i = t("./external"), o = t("./utf8"), a = t("./zipEntries"), l = t("./stream/Crc32Probe"), g = t("./nodejsUtils");
        function p(m) {
          return new i.Promise(function(u, b) {
            var h = m.decompressed.getContentWorker().pipe(new l());
            h.on("error", function(v) {
              b(v);
            }).on("end", function() {
              h.streamInfo.crc32 !== m.decompressed.crc32 ? b(/* @__PURE__ */ new Error("Corrupted zip : CRC32 mismatch")) : u();
            }).resume();
          });
        }
        n.exports = function(m, u) {
          var b = this;
          return u = r.extend(u || {}, {
            base64: !1,
            checkCRC32: !1,
            optimizedBinaryString: !1,
            createFolders: !1,
            decodeFileName: o.utf8decode
          }), g.isNode && g.isStream(m) ? i.Promise.reject(/* @__PURE__ */ new Error("JSZip can't accept a stream when loading a zip file.")) : r.prepareContent("the loaded zip file", m, !0, u.optimizedBinaryString, u.base64).then(function(h) {
            var v = new a(u);
            return v.load(h), v;
          }).then(function(h) {
            var v = [i.Promise.resolve(h)], _ = h.files;
            if (u.checkCRC32) for (var y = 0; y < _.length; y++) v.push(p(_[y]));
            return i.Promise.all(v);
          }).then(function(h) {
            for (var v = h.shift(), _ = v.files, y = 0; y < _.length; y++) {
              var R = _[y], k = R.fileNameStr, x = r.resolve(R.fileNameStr);
              b.file(x, R.decompressed, {
                binary: !0,
                optimizedBinaryString: !0,
                date: R.date,
                dir: R.dir,
                comment: R.fileCommentStr.length ? R.fileCommentStr : null,
                unixPermissions: R.unixPermissions,
                dosPermissions: R.dosPermissions,
                createFolders: u.createFolders
              }), R.dir || (b.file(x).unsafeOriginalName = k);
            }
            return v.zipComment.length && (b.comment = v.zipComment), b;
          });
        };
      }, {
        "./external": 6,
        "./nodejsUtils": 14,
        "./stream/Crc32Probe": 25,
        "./utf8": 31,
        "./utils": 32,
        "./zipEntries": 33
      }],
      12: [function(t, n, s) {
        "use strict";
        var r = t("../utils"), i = t("../stream/GenericWorker");
        function o(a, l) {
          i.call(this, "Nodejs stream input adapter for " + a), this._upstreamEnded = !1, this._bindStream(l);
        }
        r.inherits(o, i), o.prototype._bindStream = function(a) {
          var l = this;
          (this._stream = a).pause(), a.on("data", function(g) {
            l.push({
              data: g,
              meta: { percent: 0 }
            });
          }).on("error", function(g) {
            l.isPaused ? this.generatedError = g : l.error(g);
          }).on("end", function() {
            l.isPaused ? l._upstreamEnded = !0 : l.end();
          });
        }, o.prototype.pause = function() {
          return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
        }, o.prototype.resume = function() {
          return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
        }, n.exports = o;
      }, {
        "../stream/GenericWorker": 28,
        "../utils": 32
      }],
      13: [function(t, n, s) {
        "use strict";
        var r = t("readable-stream").Readable;
        function i(o, a, l) {
          r.call(this, a), this._helper = o;
          var g = this;
          o.on("data", function(p, m) {
            g.push(p) || g._helper.pause(), l && l(m);
          }).on("error", function(p) {
            g.emit("error", p);
          }).on("end", function() {
            g.push(null);
          });
        }
        t("../utils").inherits(i, r), i.prototype._read = function() {
          this._helper.resume();
        }, n.exports = i;
      }, {
        "../utils": 32,
        "readable-stream": 16
      }],
      14: [function(t, n, s) {
        "use strict";
        n.exports = {
          isNode: typeof Buffer < "u",
          newBufferFrom: function(r, i) {
            if (Buffer.from && Buffer.from !== Uint8Array.from) return Buffer.from(r, i);
            if (typeof r == "number") throw new Error('The "data" argument must not be a number');
            return new Buffer(r, i);
          },
          allocBuffer: function(r) {
            if (Buffer.alloc) return Buffer.alloc(r);
            var i = new Buffer(r);
            return i.fill(0), i;
          },
          isBuffer: function(r) {
            return Buffer.isBuffer(r);
          },
          isStream: function(r) {
            return r && typeof r.on == "function" && typeof r.pause == "function" && typeof r.resume == "function";
          }
        };
      }, {}],
      15: [function(t, n, s) {
        "use strict";
        function r(k, x, z) {
          var B, $ = o.getTypeOf(x), O = o.extend(z || {}, g);
          O.date = O.date || /* @__PURE__ */ new Date(), O.compression !== null && (O.compression = O.compression.toUpperCase()), typeof O.unixPermissions == "string" && (O.unixPermissions = parseInt(O.unixPermissions, 8)), O.unixPermissions && 16384 & O.unixPermissions && (O.dir = !0), O.dosPermissions && 16 & O.dosPermissions && (O.dir = !0), O.dir && (k = _(k)), O.createFolders && (B = v(k)) && y.call(this, B, !0), z && z.binary !== void 0 || (O.binary = !($ === "string" && O.binary === !1 && O.base64 === !1)), (x instanceof p && x.uncompressedSize === 0 || O.dir || !x || x.length === 0) && (O.base64 = !1, O.binary = !0, x = "", O.compression = "STORE", $ = "string");
          var q = null;
          q = x instanceof p || x instanceof a ? x : b.isNode && b.isStream(x) ? new h(k, x) : o.prepareContent(k, x, O.binary, O.optimizedBinaryString, O.base64);
          var J = new m(k, q, O);
          this.files[k] = J;
        }
        var i = t("./utf8"), o = t("./utils"), a = t("./stream/GenericWorker"), l = t("./stream/StreamHelper"), g = t("./defaults"), p = t("./compressedObject"), m = t("./zipObject"), u = t("./generate"), b = t("./nodejsUtils"), h = t("./nodejs/NodejsStreamInputAdapter"), v = function(k) {
          k.slice(-1) === "/" && (k = k.substring(0, k.length - 1));
          var x = k.lastIndexOf("/");
          return 0 < x ? k.substring(0, x) : "";
        }, _ = function(k) {
          return k.slice(-1) !== "/" && (k += "/"), k;
        }, y = function(k, x) {
          return x = x !== void 0 ? x : g.createFolders, k = _(k), this.files[k] || r.call(this, k, null, {
            dir: !0,
            createFolders: x
          }), this.files[k];
        };
        function R(k) {
          return Object.prototype.toString.call(k) === "[object RegExp]";
        }
        n.exports = {
          load: function() {
            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
          },
          forEach: function(k) {
            var x, z, B;
            for (x in this.files) B = this.files[x], (z = x.slice(this.root.length, x.length)) && x.slice(0, this.root.length) === this.root && k(z, B);
          },
          filter: function(k) {
            var x = [];
            return this.forEach(function(z, B) {
              k(z, B) && x.push(B);
            }), x;
          },
          file: function(k, x, z) {
            if (arguments.length !== 1) return k = this.root + k, r.call(this, k, x, z), this;
            if (R(k)) {
              var B = k;
              return this.filter(function(O, q) {
                return !q.dir && B.test(O);
              });
            }
            var $ = this.files[this.root + k];
            return $ && !$.dir ? $ : null;
          },
          folder: function(k) {
            if (!k) return this;
            if (R(k)) return this.filter(function($, O) {
              return O.dir && k.test($);
            });
            var x = this.root + k, z = y.call(this, x), B = this.clone();
            return B.root = z.name, B;
          },
          remove: function(k) {
            k = this.root + k;
            var x = this.files[k];
            if (x || (k.slice(-1) !== "/" && (k += "/"), x = this.files[k]), x && !x.dir) delete this.files[k];
            else for (var z = this.filter(function($, O) {
              return O.name.slice(0, k.length) === k;
            }), B = 0; B < z.length; B++) delete this.files[z[B].name];
            return this;
          },
          generate: function() {
            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
          },
          generateInternalStream: function(k) {
            var x, z = {};
            try {
              if ((z = o.extend(k || {}, {
                streamFiles: !1,
                compression: "STORE",
                compressionOptions: null,
                type: "",
                platform: "DOS",
                comment: null,
                mimeType: "application/zip",
                encodeFileName: i.utf8encode
              })).type = z.type.toLowerCase(), z.compression = z.compression.toUpperCase(), z.type === "binarystring" && (z.type = "string"), !z.type) throw new Error("No output type specified.");
              o.checkSupport(z.type), z.platform !== "darwin" && z.platform !== "freebsd" && z.platform !== "linux" && z.platform !== "sunos" || (z.platform = "UNIX"), z.platform === "win32" && (z.platform = "DOS");
              var B = z.comment || this.comment || "";
              x = u.generateWorker(this, z, B);
            } catch ($) {
              (x = new a("error")).error($);
            }
            return new l(x, z.type || "string", z.mimeType);
          },
          generateAsync: function(k, x) {
            return this.generateInternalStream(k).accumulate(x);
          },
          generateNodeStream: function(k, x) {
            return (k = k || {}).type || (k.type = "nodebuffer"), this.generateInternalStream(k).toNodejsStream(x);
          }
        };
      }, {
        "./compressedObject": 2,
        "./defaults": 5,
        "./generate": 9,
        "./nodejs/NodejsStreamInputAdapter": 12,
        "./nodejsUtils": 14,
        "./stream/GenericWorker": 28,
        "./stream/StreamHelper": 29,
        "./utf8": 31,
        "./utils": 32,
        "./zipObject": 35
      }],
      16: [function(t, n, s) {
        "use strict";
        n.exports = t("stream");
      }, { stream: void 0 }],
      17: [function(t, n, s) {
        "use strict";
        var r = t("./DataReader");
        function i(o) {
          r.call(this, o);
          for (var a = 0; a < this.data.length; a++) o[a] = 255 & o[a];
        }
        t("../utils").inherits(i, r), i.prototype.byteAt = function(o) {
          return this.data[this.zero + o];
        }, i.prototype.lastIndexOfSignature = function(o) {
          for (var a = o.charCodeAt(0), l = o.charCodeAt(1), g = o.charCodeAt(2), p = o.charCodeAt(3), m = this.length - 4; 0 <= m; --m) if (this.data[m] === a && this.data[m + 1] === l && this.data[m + 2] === g && this.data[m + 3] === p) return m - this.zero;
          return -1;
        }, i.prototype.readAndCheckSignature = function(o) {
          var a = o.charCodeAt(0), l = o.charCodeAt(1), g = o.charCodeAt(2), p = o.charCodeAt(3), m = this.readData(4);
          return a === m[0] && l === m[1] && g === m[2] && p === m[3];
        }, i.prototype.readData = function(o) {
          if (this.checkOffset(o), o === 0) return [];
          var a = this.data.slice(this.zero + this.index, this.zero + this.index + o);
          return this.index += o, a;
        }, n.exports = i;
      }, {
        "../utils": 32,
        "./DataReader": 18
      }],
      18: [function(t, n, s) {
        "use strict";
        var r = t("../utils");
        function i(o) {
          this.data = o, this.length = o.length, this.index = 0, this.zero = 0;
        }
        i.prototype = {
          checkOffset: function(o) {
            this.checkIndex(this.index + o);
          },
          checkIndex: function(o) {
            if (this.length < this.zero + o || o < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + o + "). Corrupted zip ?");
          },
          setIndex: function(o) {
            this.checkIndex(o), this.index = o;
          },
          skip: function(o) {
            this.setIndex(this.index + o);
          },
          byteAt: function() {
          },
          readInt: function(o) {
            var a, l = 0;
            for (this.checkOffset(o), a = this.index + o - 1; a >= this.index; a--) l = (l << 8) + this.byteAt(a);
            return this.index += o, l;
          },
          readString: function(o) {
            return r.transformTo("string", this.readData(o));
          },
          readData: function() {
          },
          lastIndexOfSignature: function() {
          },
          readAndCheckSignature: function() {
          },
          readDate: function() {
            var o = this.readInt(4);
            return new Date(Date.UTC(1980 + (o >> 25 & 127), (o >> 21 & 15) - 1, o >> 16 & 31, o >> 11 & 31, o >> 5 & 63, (31 & o) << 1));
          }
        }, n.exports = i;
      }, { "../utils": 32 }],
      19: [function(t, n, s) {
        "use strict";
        var r = t("./Uint8ArrayReader");
        function i(o) {
          r.call(this, o);
        }
        t("../utils").inherits(i, r), i.prototype.readData = function(o) {
          this.checkOffset(o);
          var a = this.data.slice(this.zero + this.index, this.zero + this.index + o);
          return this.index += o, a;
        }, n.exports = i;
      }, {
        "../utils": 32,
        "./Uint8ArrayReader": 21
      }],
      20: [function(t, n, s) {
        "use strict";
        var r = t("./DataReader");
        function i(o) {
          r.call(this, o);
        }
        t("../utils").inherits(i, r), i.prototype.byteAt = function(o) {
          return this.data.charCodeAt(this.zero + o);
        }, i.prototype.lastIndexOfSignature = function(o) {
          return this.data.lastIndexOf(o) - this.zero;
        }, i.prototype.readAndCheckSignature = function(o) {
          return o === this.readData(4);
        }, i.prototype.readData = function(o) {
          this.checkOffset(o);
          var a = this.data.slice(this.zero + this.index, this.zero + this.index + o);
          return this.index += o, a;
        }, n.exports = i;
      }, {
        "../utils": 32,
        "./DataReader": 18
      }],
      21: [function(t, n, s) {
        "use strict";
        var r = t("./ArrayReader");
        function i(o) {
          r.call(this, o);
        }
        t("../utils").inherits(i, r), i.prototype.readData = function(o) {
          if (this.checkOffset(o), o === 0) return new Uint8Array(0);
          var a = this.data.subarray(this.zero + this.index, this.zero + this.index + o);
          return this.index += o, a;
        }, n.exports = i;
      }, {
        "../utils": 32,
        "./ArrayReader": 17
      }],
      22: [function(t, n, s) {
        "use strict";
        var r = t("../utils"), i = t("../support"), o = t("./ArrayReader"), a = t("./StringReader"), l = t("./NodeBufferReader"), g = t("./Uint8ArrayReader");
        n.exports = function(p) {
          var m = r.getTypeOf(p);
          return r.checkSupport(m), m !== "string" || i.uint8array ? m === "nodebuffer" ? new l(p) : i.uint8array ? new g(r.transformTo("uint8array", p)) : new o(r.transformTo("array", p)) : new a(p);
        };
      }, {
        "../support": 30,
        "../utils": 32,
        "./ArrayReader": 17,
        "./NodeBufferReader": 19,
        "./StringReader": 20,
        "./Uint8ArrayReader": 21
      }],
      23: [function(t, n, s) {
        "use strict";
        s.LOCAL_FILE_HEADER = "PK", s.CENTRAL_FILE_HEADER = "PK", s.CENTRAL_DIRECTORY_END = "PK", s.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", s.ZIP64_CENTRAL_DIRECTORY_END = "PK", s.DATA_DESCRIPTOR = "PK\x07\b";
      }, {}],
      24: [function(t, n, s) {
        "use strict";
        var r = t("./GenericWorker"), i = t("../utils");
        function o(a) {
          r.call(this, "ConvertWorker to " + a), this.destType = a;
        }
        i.inherits(o, r), o.prototype.processChunk = function(a) {
          this.push({
            data: i.transformTo(this.destType, a.data),
            meta: a.meta
          });
        }, n.exports = o;
      }, {
        "../utils": 32,
        "./GenericWorker": 28
      }],
      25: [function(t, n, s) {
        "use strict";
        var r = t("./GenericWorker"), i = t("../crc32");
        function o() {
          r.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
        }
        t("../utils").inherits(o, r), o.prototype.processChunk = function(a) {
          this.streamInfo.crc32 = i(a.data, this.streamInfo.crc32 || 0), this.push(a);
        }, n.exports = o;
      }, {
        "../crc32": 4,
        "../utils": 32,
        "./GenericWorker": 28
      }],
      26: [function(t, n, s) {
        "use strict";
        var r = t("../utils"), i = t("./GenericWorker");
        function o(a) {
          i.call(this, "DataLengthProbe for " + a), this.propName = a, this.withStreamInfo(a, 0);
        }
        r.inherits(o, i), o.prototype.processChunk = function(a) {
          if (a) {
            var l = this.streamInfo[this.propName] || 0;
            this.streamInfo[this.propName] = l + a.data.length;
          }
          i.prototype.processChunk.call(this, a);
        }, n.exports = o;
      }, {
        "../utils": 32,
        "./GenericWorker": 28
      }],
      27: [function(t, n, s) {
        "use strict";
        var r = t("../utils"), i = t("./GenericWorker");
        function o(a) {
          i.call(this, "DataWorker");
          var l = this;
          this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, a.then(function(g) {
            l.dataIsReady = !0, l.data = g, l.max = g && g.length || 0, l.type = r.getTypeOf(g), l.isPaused || l._tickAndRepeat();
          }, function(g) {
            l.error(g);
          });
        }
        r.inherits(o, i), o.prototype.cleanUp = function() {
          i.prototype.cleanUp.call(this), this.data = null;
        }, o.prototype.resume = function() {
          return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, r.delay(this._tickAndRepeat, [], this)), !0);
        }, o.prototype._tickAndRepeat = function() {
          this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (r.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
        }, o.prototype._tick = function() {
          if (this.isPaused || this.isFinished) return !1;
          var a = null, l = Math.min(this.max, this.index + 16384);
          if (this.index >= this.max) return this.end();
          switch (this.type) {
            case "string":
              a = this.data.substring(this.index, l);
              break;
            case "uint8array":
              a = this.data.subarray(this.index, l);
              break;
            case "array":
            case "nodebuffer":
              a = this.data.slice(this.index, l);
          }
          return this.index = l, this.push({
            data: a,
            meta: { percent: this.max ? this.index / this.max * 100 : 0 }
          });
        }, n.exports = o;
      }, {
        "../utils": 32,
        "./GenericWorker": 28
      }],
      28: [function(t, n, s) {
        "use strict";
        function r(i) {
          this.name = i || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
            data: [],
            end: [],
            error: []
          }, this.previous = null;
        }
        r.prototype = {
          push: function(i) {
            this.emit("data", i);
          },
          end: function() {
            if (this.isFinished) return !1;
            this.flush();
            try {
              this.emit("end"), this.cleanUp(), this.isFinished = !0;
            } catch (i) {
              this.emit("error", i);
            }
            return !0;
          },
          error: function(i) {
            return !this.isFinished && (this.isPaused ? this.generatedError = i : (this.isFinished = !0, this.emit("error", i), this.previous && this.previous.error(i), this.cleanUp()), !0);
          },
          on: function(i, o) {
            return this._listeners[i].push(o), this;
          },
          cleanUp: function() {
            this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
          },
          emit: function(i, o) {
            if (this._listeners[i]) for (var a = 0; a < this._listeners[i].length; a++) this._listeners[i][a].call(this, o);
          },
          pipe: function(i) {
            return i.registerPrevious(this);
          },
          registerPrevious: function(i) {
            if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
            this.streamInfo = i.streamInfo, this.mergeStreamInfo(), this.previous = i;
            var o = this;
            return i.on("data", function(a) {
              o.processChunk(a);
            }), i.on("end", function() {
              o.end();
            }), i.on("error", function(a) {
              o.error(a);
            }), this;
          },
          pause: function() {
            return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
          },
          resume: function() {
            if (!this.isPaused || this.isFinished) return !1;
            var i = this.isPaused = !1;
            return this.generatedError && (this.error(this.generatedError), i = !0), this.previous && this.previous.resume(), !i;
          },
          flush: function() {
          },
          processChunk: function(i) {
            this.push(i);
          },
          withStreamInfo: function(i, o) {
            return this.extraStreamInfo[i] = o, this.mergeStreamInfo(), this;
          },
          mergeStreamInfo: function() {
            for (var i in this.extraStreamInfo) Object.prototype.hasOwnProperty.call(this.extraStreamInfo, i) && (this.streamInfo[i] = this.extraStreamInfo[i]);
          },
          lock: function() {
            if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
            this.isLocked = !0, this.previous && this.previous.lock();
          },
          toString: function() {
            var i = "Worker " + this.name;
            return this.previous ? this.previous + " -> " + i : i;
          }
        }, n.exports = r;
      }, {}],
      29: [function(t, n, s) {
        "use strict";
        var r = t("../utils"), i = t("./ConvertWorker"), o = t("./GenericWorker"), a = t("../base64"), l = t("../support"), g = t("../external"), p = null;
        if (l.nodestream) try {
          p = t("../nodejs/NodejsStreamOutputAdapter");
        } catch {
        }
        function m(b, h) {
          return new g.Promise(function(v, _) {
            var y = [], R = b._internalType, k = b._outputType, x = b._mimeType;
            b.on("data", function(z, B) {
              y.push(z), h && h(B);
            }).on("error", function(z) {
              y = [], _(z);
            }).on("end", function() {
              try {
                v((function(z, B, $) {
                  switch (z) {
                    case "blob":
                      return r.newBlob(r.transformTo("arraybuffer", B), $);
                    case "base64":
                      return a.encode(B);
                    default:
                      return r.transformTo(z, B);
                  }
                })(k, (function(z, B) {
                  var $, O = 0, q = null, J = 0;
                  for ($ = 0; $ < B.length; $++) J += B[$].length;
                  switch (z) {
                    case "string":
                      return B.join("");
                    case "array":
                      return Array.prototype.concat.apply([], B);
                    case "uint8array":
                      for (q = new Uint8Array(J), $ = 0; $ < B.length; $++) q.set(B[$], O), O += B[$].length;
                      return q;
                    case "nodebuffer":
                      return Buffer.concat(B);
                    default:
                      throw new Error("concat : unsupported type '" + z + "'");
                  }
                })(R, y), x));
              } catch (z) {
                _(z);
              }
              y = [];
            }).resume();
          });
        }
        function u(b, h, v) {
          var _ = h;
          switch (h) {
            case "blob":
            case "arraybuffer":
              _ = "uint8array";
              break;
            case "base64":
              _ = "string";
          }
          try {
            this._internalType = _, this._outputType = h, this._mimeType = v, r.checkSupport(_), this._worker = b.pipe(new i(_)), b.lock();
          } catch (y) {
            this._worker = new o("error"), this._worker.error(y);
          }
        }
        u.prototype = {
          accumulate: function(b) {
            return m(this, b);
          },
          on: function(b, h) {
            var v = this;
            return b === "data" ? this._worker.on(b, function(_) {
              h.call(v, _.data, _.meta);
            }) : this._worker.on(b, function() {
              r.delay(h, arguments, v);
            }), this;
          },
          resume: function() {
            return r.delay(this._worker.resume, [], this._worker), this;
          },
          pause: function() {
            return this._worker.pause(), this;
          },
          toNodejsStream: function(b) {
            if (r.checkSupport("nodestream"), this._outputType !== "nodebuffer") throw new Error(this._outputType + " is not supported by this method");
            return new p(this, { objectMode: this._outputType !== "nodebuffer" }, b);
          }
        }, n.exports = u;
      }, {
        "../base64": 1,
        "../external": 6,
        "../nodejs/NodejsStreamOutputAdapter": 13,
        "../support": 30,
        "../utils": 32,
        "./ConvertWorker": 24,
        "./GenericWorker": 28
      }],
      30: [function(t, n, s) {
        "use strict";
        if (s.base64 = !0, s.array = !0, s.string = !0, s.arraybuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", s.nodebuffer = typeof Buffer < "u", s.uint8array = typeof Uint8Array < "u", typeof ArrayBuffer > "u") s.blob = !1;
        else {
          var r = /* @__PURE__ */ new ArrayBuffer(0);
          try {
            s.blob = new Blob([r], { type: "application/zip" }).size === 0;
          } catch {
            try {
              var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
              i.append(r), s.blob = i.getBlob("application/zip").size === 0;
            } catch {
              s.blob = !1;
            }
          }
        }
        try {
          s.nodestream = !!t("readable-stream").Readable;
        } catch {
          s.nodestream = !1;
        }
      }, { "readable-stream": 16 }],
      31: [function(t, n, s) {
        "use strict";
        for (var r = t("./utils"), i = t("./support"), o = t("./nodejsUtils"), a = t("./stream/GenericWorker"), l = new Array(256), g = 0; g < 256; g++) l[g] = 252 <= g ? 6 : 248 <= g ? 5 : 240 <= g ? 4 : 224 <= g ? 3 : 192 <= g ? 2 : 1;
        l[254] = l[254] = 1;
        function p() {
          a.call(this, "utf-8 decode"), this.leftOver = null;
        }
        function m() {
          a.call(this, "utf-8 encode");
        }
        s.utf8encode = function(u) {
          return i.nodebuffer ? o.newBufferFrom(u, "utf-8") : (function(b) {
            var h, v, _, y, R, k = b.length, x = 0;
            for (y = 0; y < k; y++) (64512 & (v = b.charCodeAt(y))) == 55296 && y + 1 < k && (64512 & (_ = b.charCodeAt(y + 1))) == 56320 && (v = 65536 + (v - 55296 << 10) + (_ - 56320), y++), x += v < 128 ? 1 : v < 2048 ? 2 : v < 65536 ? 3 : 4;
            for (h = i.uint8array ? new Uint8Array(x) : new Array(x), y = R = 0; R < x; y++) (64512 & (v = b.charCodeAt(y))) == 55296 && y + 1 < k && (64512 & (_ = b.charCodeAt(y + 1))) == 56320 && (v = 65536 + (v - 55296 << 10) + (_ - 56320), y++), v < 128 ? h[R++] = v : (v < 2048 ? h[R++] = 192 | v >>> 6 : (v < 65536 ? h[R++] = 224 | v >>> 12 : (h[R++] = 240 | v >>> 18, h[R++] = 128 | v >>> 12 & 63), h[R++] = 128 | v >>> 6 & 63), h[R++] = 128 | 63 & v);
            return h;
          })(u);
        }, s.utf8decode = function(u) {
          return i.nodebuffer ? r.transformTo("nodebuffer", u).toString("utf-8") : (function(b) {
            var h, v, _, y, R = b.length, k = new Array(2 * R);
            for (h = v = 0; h < R; ) if ((_ = b[h++]) < 128) k[v++] = _;
            else if (4 < (y = l[_])) k[v++] = 65533, h += y - 1;
            else {
              for (_ &= y === 2 ? 31 : y === 3 ? 15 : 7; 1 < y && h < R; ) _ = _ << 6 | 63 & b[h++], y--;
              1 < y ? k[v++] = 65533 : _ < 65536 ? k[v++] = _ : (_ -= 65536, k[v++] = 55296 | _ >> 10 & 1023, k[v++] = 56320 | 1023 & _);
            }
            return k.length !== v && (k.subarray ? k = k.subarray(0, v) : k.length = v), r.applyFromCharCode(k);
          })(u = r.transformTo(i.uint8array ? "uint8array" : "array", u));
        }, r.inherits(p, a), p.prototype.processChunk = function(u) {
          var b = r.transformTo(i.uint8array ? "uint8array" : "array", u.data);
          if (this.leftOver && this.leftOver.length) {
            if (i.uint8array) {
              var h = b;
              (b = new Uint8Array(h.length + this.leftOver.length)).set(this.leftOver, 0), b.set(h, this.leftOver.length);
            } else b = this.leftOver.concat(b);
            this.leftOver = null;
          }
          var v = (function(y, R) {
            var k;
            for ((R = R || y.length) > y.length && (R = y.length), k = R - 1; 0 <= k && (192 & y[k]) == 128; ) k--;
            return k < 0 || k === 0 ? R : k + l[y[k]] > R ? k : R;
          })(b), _ = b;
          v !== b.length && (i.uint8array ? (_ = b.subarray(0, v), this.leftOver = b.subarray(v, b.length)) : (_ = b.slice(0, v), this.leftOver = b.slice(v, b.length))), this.push({
            data: s.utf8decode(_),
            meta: u.meta
          });
        }, p.prototype.flush = function() {
          this.leftOver && this.leftOver.length && (this.push({
            data: s.utf8decode(this.leftOver),
            meta: {}
          }), this.leftOver = null);
        }, s.Utf8DecodeWorker = p, r.inherits(m, a), m.prototype.processChunk = function(u) {
          this.push({
            data: s.utf8encode(u.data),
            meta: u.meta
          });
        }, s.Utf8EncodeWorker = m;
      }, {
        "./nodejsUtils": 14,
        "./stream/GenericWorker": 28,
        "./support": 30,
        "./utils": 32
      }],
      32: [function(t, n, s) {
        "use strict";
        var r = t("./support"), i = t("./base64"), o = t("./nodejsUtils"), a = t("./external");
        function l(h) {
          return h;
        }
        function g(h, v) {
          for (var _ = 0; _ < h.length; ++_) v[_] = 255 & h.charCodeAt(_);
          return v;
        }
        t("setimmediate"), s.newBlob = function(h, v) {
          s.checkSupport("blob");
          try {
            return new Blob([h], { type: v });
          } catch {
            try {
              var _ = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
              return _.append(h), _.getBlob(v);
            } catch {
              throw new Error("Bug : can't construct the Blob.");
            }
          }
        };
        var p = {
          stringifyByChunk: function(h, v, _) {
            var y = [], R = 0, k = h.length;
            if (k <= _) return String.fromCharCode.apply(null, h);
            for (; R < k; ) v === "array" || v === "nodebuffer" ? y.push(String.fromCharCode.apply(null, h.slice(R, Math.min(R + _, k)))) : y.push(String.fromCharCode.apply(null, h.subarray(R, Math.min(R + _, k)))), R += _;
            return y.join("");
          },
          stringifyByChar: function(h) {
            for (var v = "", _ = 0; _ < h.length; _++) v += String.fromCharCode(h[_]);
            return v;
          },
          applyCanBeUsed: {
            uint8array: (function() {
              try {
                return r.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
              } catch {
                return !1;
              }
            })(),
            nodebuffer: (function() {
              try {
                return r.nodebuffer && String.fromCharCode.apply(null, o.allocBuffer(1)).length === 1;
              } catch {
                return !1;
              }
            })()
          }
        };
        function m(h) {
          var v = 65536, _ = s.getTypeOf(h), y = !0;
          if (_ === "uint8array" ? y = p.applyCanBeUsed.uint8array : _ === "nodebuffer" && (y = p.applyCanBeUsed.nodebuffer), y) for (; 1 < v; ) try {
            return p.stringifyByChunk(h, _, v);
          } catch {
            v = Math.floor(v / 2);
          }
          return p.stringifyByChar(h);
        }
        function u(h, v) {
          for (var _ = 0; _ < h.length; _++) v[_] = h[_];
          return v;
        }
        s.applyFromCharCode = m;
        var b = {};
        b.string = {
          string: l,
          array: function(h) {
            return g(h, new Array(h.length));
          },
          arraybuffer: function(h) {
            return b.string.uint8array(h).buffer;
          },
          uint8array: function(h) {
            return g(h, new Uint8Array(h.length));
          },
          nodebuffer: function(h) {
            return g(h, o.allocBuffer(h.length));
          }
        }, b.array = {
          string: m,
          array: l,
          arraybuffer: function(h) {
            return new Uint8Array(h).buffer;
          },
          uint8array: function(h) {
            return new Uint8Array(h);
          },
          nodebuffer: function(h) {
            return o.newBufferFrom(h);
          }
        }, b.arraybuffer = {
          string: function(h) {
            return m(new Uint8Array(h));
          },
          array: function(h) {
            return u(new Uint8Array(h), new Array(h.byteLength));
          },
          arraybuffer: l,
          uint8array: function(h) {
            return new Uint8Array(h);
          },
          nodebuffer: function(h) {
            return o.newBufferFrom(new Uint8Array(h));
          }
        }, b.uint8array = {
          string: m,
          array: function(h) {
            return u(h, new Array(h.length));
          },
          arraybuffer: function(h) {
            return h.buffer;
          },
          uint8array: l,
          nodebuffer: function(h) {
            return o.newBufferFrom(h);
          }
        }, b.nodebuffer = {
          string: m,
          array: function(h) {
            return u(h, new Array(h.length));
          },
          arraybuffer: function(h) {
            return b.nodebuffer.uint8array(h).buffer;
          },
          uint8array: function(h) {
            return u(h, new Uint8Array(h.length));
          },
          nodebuffer: l
        }, s.transformTo = function(h, v) {
          return v = v || "", h ? (s.checkSupport(h), b[s.getTypeOf(v)][h](v)) : v;
        }, s.resolve = function(h) {
          for (var v = h.split("/"), _ = [], y = 0; y < v.length; y++) {
            var R = v[y];
            R === "." || R === "" && y !== 0 && y !== v.length - 1 || (R === ".." ? _.pop() : _.push(R));
          }
          return _.join("/");
        }, s.getTypeOf = function(h) {
          return typeof h == "string" ? "string" : Object.prototype.toString.call(h) === "[object Array]" ? "array" : r.nodebuffer && o.isBuffer(h) ? "nodebuffer" : r.uint8array && h instanceof Uint8Array ? "uint8array" : r.arraybuffer && h instanceof ArrayBuffer ? "arraybuffer" : void 0;
        }, s.checkSupport = function(h) {
          if (!r[h.toLowerCase()]) throw new Error(h + " is not supported by this platform");
        }, s.MAX_VALUE_16BITS = 65535, s.MAX_VALUE_32BITS = -1, s.pretty = function(h) {
          var v, _, y = "";
          for (_ = 0; _ < (h || "").length; _++) y += "\\x" + ((v = h.charCodeAt(_)) < 16 ? "0" : "") + v.toString(16).toUpperCase();
          return y;
        }, s.delay = function(h, v, _) {
          setImmediate(function() {
            h.apply(_ || null, v || []);
          });
        }, s.inherits = function(h, v) {
          function _() {
          }
          _.prototype = v.prototype, h.prototype = new _();
        }, s.extend = function() {
          var h, v, _ = {};
          for (h = 0; h < arguments.length; h++) for (v in arguments[h]) Object.prototype.hasOwnProperty.call(arguments[h], v) && _[v] === void 0 && (_[v] = arguments[h][v]);
          return _;
        }, s.prepareContent = function(h, v, _, y, R) {
          return a.Promise.resolve(v).then(function(k) {
            return r.blob && (k instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(k)) !== -1) && typeof FileReader < "u" ? new a.Promise(function(x, z) {
              var B = new FileReader();
              B.onload = function($) {
                x($.target.result);
              }, B.onerror = function($) {
                z($.target.error);
              }, B.readAsArrayBuffer(k);
            }) : k;
          }).then(function(k) {
            var x = s.getTypeOf(k);
            return x ? (x === "arraybuffer" ? k = s.transformTo("uint8array", k) : x === "string" && (R ? k = i.decode(k) : _ && y !== !0 && (k = (function(z) {
              return g(z, r.uint8array ? new Uint8Array(z.length) : new Array(z.length));
            })(k))), k) : a.Promise.reject(/* @__PURE__ */ new Error("Can't read the data of '" + h + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
          });
        };
      }, {
        "./base64": 1,
        "./external": 6,
        "./nodejsUtils": 14,
        "./support": 30,
        setimmediate: 54
      }],
      33: [function(t, n, s) {
        "use strict";
        var r = t("./reader/readerFor"), i = t("./utils"), o = t("./signature"), a = t("./zipEntry"), l = t("./support");
        function g(p) {
          this.files = [], this.loadOptions = p;
        }
        g.prototype = {
          checkSignature: function(p) {
            if (!this.reader.readAndCheckSignature(p)) {
              this.reader.index -= 4;
              var m = this.reader.readString(4);
              throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(m) + ", expected " + i.pretty(p) + ")");
            }
          },
          isSignature: function(p, m) {
            var u = this.reader.index;
            this.reader.setIndex(p);
            var b = this.reader.readString(4) === m;
            return this.reader.setIndex(u), b;
          },
          readBlockEndOfCentral: function() {
            this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
            var p = this.reader.readData(this.zipCommentLength), m = i.transformTo(l.uint8array ? "uint8array" : "array", p);
            this.zipComment = this.loadOptions.decodeFileName(m);
          },
          readBlockZip64EndOfCentral: function() {
            this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
            for (var p, m, u, b = this.zip64EndOfCentralSize - 44; 0 < b; ) p = this.reader.readInt(2), m = this.reader.readInt(4), u = this.reader.readData(m), this.zip64ExtensibleData[p] = {
              id: p,
              length: m,
              value: u
            };
          },
          readBlockZip64EndOfCentralLocator: function() {
            if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
          },
          readLocalFiles: function() {
            var p, m;
            for (p = 0; p < this.files.length; p++) m = this.files[p], this.reader.setIndex(m.localHeaderOffset), this.checkSignature(o.LOCAL_FILE_HEADER), m.readLocalPart(this.reader), m.handleUTF8(), m.processAttributes();
          },
          readCentralDir: function() {
            var p;
            for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(o.CENTRAL_FILE_HEADER); ) (p = new a({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(p);
            if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
          },
          readEndOfCentral: function() {
            var p = this.reader.lastIndexOfSignature(o.CENTRAL_DIRECTORY_END);
            if (p < 0) throw this.isSignature(0, o.LOCAL_FILE_HEADER) ? /* @__PURE__ */ new Error("Corrupted zip: can't find end of central directory") : /* @__PURE__ */ new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
            this.reader.setIndex(p);
            var m = p;
            if (this.checkSignature(o.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
              if (this.zip64 = !0, (p = this.reader.lastIndexOfSignature(o.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
              if (this.reader.setIndex(p), this.checkSignature(o.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, o.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(o.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
              this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(o.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
            }
            var u = this.centralDirOffset + this.centralDirSize;
            this.zip64 && (u += 20, u += 12 + this.zip64EndOfCentralSize);
            var b = m - u;
            if (0 < b) this.isSignature(m, o.CENTRAL_FILE_HEADER) || (this.reader.zero = b);
            else if (b < 0) throw new Error("Corrupted zip: missing " + Math.abs(b) + " bytes.");
          },
          prepareReader: function(p) {
            this.reader = r(p);
          },
          load: function(p) {
            this.prepareReader(p), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
          }
        }, n.exports = g;
      }, {
        "./reader/readerFor": 22,
        "./signature": 23,
        "./support": 30,
        "./utils": 32,
        "./zipEntry": 34
      }],
      34: [function(t, n, s) {
        "use strict";
        var r = t("./reader/readerFor"), i = t("./utils"), o = t("./compressedObject"), a = t("./crc32"), l = t("./utf8"), g = t("./compressions"), p = t("./support");
        function m(u, b) {
          this.options = u, this.loadOptions = b;
        }
        m.prototype = {
          isEncrypted: function() {
            return (1 & this.bitFlag) == 1;
          },
          useUTF8: function() {
            return (2048 & this.bitFlag) == 2048;
          },
          readLocalPart: function(u) {
            var b, h;
            if (u.skip(22), this.fileNameLength = u.readInt(2), h = u.readInt(2), this.fileName = u.readData(this.fileNameLength), u.skip(h), this.compressedSize === -1 || this.uncompressedSize === -1) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
            if ((b = (function(v) {
              for (var _ in g) if (Object.prototype.hasOwnProperty.call(g, _) && g[_].magic === v) return g[_];
              return null;
            })(this.compressionMethod)) === null) throw new Error("Corrupted zip : compression " + i.pretty(this.compressionMethod) + " unknown (inner file : " + i.transformTo("string", this.fileName) + ")");
            this.decompressed = new o(this.compressedSize, this.uncompressedSize, this.crc32, b, u.readData(this.compressedSize));
          },
          readCentralPart: function(u) {
            this.versionMadeBy = u.readInt(2), u.skip(2), this.bitFlag = u.readInt(2), this.compressionMethod = u.readString(2), this.date = u.readDate(), this.crc32 = u.readInt(4), this.compressedSize = u.readInt(4), this.uncompressedSize = u.readInt(4);
            var b = u.readInt(2);
            if (this.extraFieldsLength = u.readInt(2), this.fileCommentLength = u.readInt(2), this.diskNumberStart = u.readInt(2), this.internalFileAttributes = u.readInt(2), this.externalFileAttributes = u.readInt(4), this.localHeaderOffset = u.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
            u.skip(b), this.readExtraFields(u), this.parseZIP64ExtraField(u), this.fileComment = u.readData(this.fileCommentLength);
          },
          processAttributes: function() {
            this.unixPermissions = null, this.dosPermissions = null;
            var u = this.versionMadeBy >> 8;
            this.dir = !!(16 & this.externalFileAttributes), u == 0 && (this.dosPermissions = 63 & this.externalFileAttributes), u == 3 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || this.fileNameStr.slice(-1) !== "/" || (this.dir = !0);
          },
          parseZIP64ExtraField: function() {
            if (this.extraFields[1]) {
              var u = r(this.extraFields[1].value);
              this.uncompressedSize === i.MAX_VALUE_32BITS && (this.uncompressedSize = u.readInt(8)), this.compressedSize === i.MAX_VALUE_32BITS && (this.compressedSize = u.readInt(8)), this.localHeaderOffset === i.MAX_VALUE_32BITS && (this.localHeaderOffset = u.readInt(8)), this.diskNumberStart === i.MAX_VALUE_32BITS && (this.diskNumberStart = u.readInt(4));
            }
          },
          readExtraFields: function(u) {
            var b, h, v, _ = u.index + this.extraFieldsLength;
            for (this.extraFields || (this.extraFields = {}); u.index + 4 < _; ) b = u.readInt(2), h = u.readInt(2), v = u.readData(h), this.extraFields[b] = {
              id: b,
              length: h,
              value: v
            };
            u.setIndex(_);
          },
          handleUTF8: function() {
            var u = p.uint8array ? "uint8array" : "array";
            if (this.useUTF8()) this.fileNameStr = l.utf8decode(this.fileName), this.fileCommentStr = l.utf8decode(this.fileComment);
            else {
              var b = this.findExtraFieldUnicodePath();
              if (b !== null) this.fileNameStr = b;
              else {
                var h = i.transformTo(u, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(h);
              }
              var v = this.findExtraFieldUnicodeComment();
              if (v !== null) this.fileCommentStr = v;
              else {
                var _ = i.transformTo(u, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(_);
              }
            }
          },
          findExtraFieldUnicodePath: function() {
            var u = this.extraFields[28789];
            if (u) {
              var b = r(u.value);
              return b.readInt(1) !== 1 || a(this.fileName) !== b.readInt(4) ? null : l.utf8decode(b.readData(u.length - 5));
            }
            return null;
          },
          findExtraFieldUnicodeComment: function() {
            var u = this.extraFields[25461];
            if (u) {
              var b = r(u.value);
              return b.readInt(1) !== 1 || a(this.fileComment) !== b.readInt(4) ? null : l.utf8decode(b.readData(u.length - 5));
            }
            return null;
          }
        }, n.exports = m;
      }, {
        "./compressedObject": 2,
        "./compressions": 3,
        "./crc32": 4,
        "./reader/readerFor": 22,
        "./support": 30,
        "./utf8": 31,
        "./utils": 32
      }],
      35: [function(t, n, s) {
        "use strict";
        function r(b, h, v) {
          this.name = b, this.dir = v.dir, this.date = v.date, this.comment = v.comment, this.unixPermissions = v.unixPermissions, this.dosPermissions = v.dosPermissions, this._data = h, this._dataBinary = v.binary, this.options = {
            compression: v.compression,
            compressionOptions: v.compressionOptions
          };
        }
        var i = t("./stream/StreamHelper"), o = t("./stream/DataWorker"), a = t("./utf8"), l = t("./compressedObject"), g = t("./stream/GenericWorker");
        r.prototype = {
          internalStream: function(b) {
            var h = null, v = "string";
            try {
              if (!b) throw new Error("No output type specified.");
              var _ = (v = b.toLowerCase()) === "string" || v === "text";
              v !== "binarystring" && v !== "text" || (v = "string"), h = this._decompressWorker();
              var y = !this._dataBinary;
              y && !_ && (h = h.pipe(new a.Utf8EncodeWorker())), !y && _ && (h = h.pipe(new a.Utf8DecodeWorker()));
            } catch (R) {
              (h = new g("error")).error(R);
            }
            return new i(h, v, "");
          },
          async: function(b, h) {
            return this.internalStream(b).accumulate(h);
          },
          nodeStream: function(b, h) {
            return this.internalStream(b || "nodebuffer").toNodejsStream(h);
          },
          _compressWorker: function(b, h) {
            if (this._data instanceof l && this._data.compression.magic === b.magic) return this._data.getCompressedWorker();
            var v = this._decompressWorker();
            return this._dataBinary || (v = v.pipe(new a.Utf8EncodeWorker())), l.createWorkerFrom(v, b, h);
          },
          _decompressWorker: function() {
            return this._data instanceof l ? this._data.getContentWorker() : this._data instanceof g ? this._data : new o(this._data);
          }
        };
        for (var p = [
          "asText",
          "asBinary",
          "asNodeBuffer",
          "asUint8Array",
          "asArrayBuffer"
        ], m = function() {
          throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
        }, u = 0; u < p.length; u++) r.prototype[p[u]] = m;
        n.exports = r;
      }, {
        "./compressedObject": 2,
        "./stream/DataWorker": 27,
        "./stream/GenericWorker": 28,
        "./stream/StreamHelper": 29,
        "./utf8": 31
      }],
      36: [function(t, n, s) {
        (function(r) {
          "use strict";
          var i, o, a = r.MutationObserver || r.WebKitMutationObserver;
          if (a) {
            var l = 0, g = new a(b), p = r.document.createTextNode("");
            g.observe(p, { characterData: !0 }), i = function() {
              p.data = l = ++l % 2;
            };
          } else if (r.setImmediate || r.MessageChannel === void 0) i = "document" in r && "onreadystatechange" in r.document.createElement("script") ? function() {
            var h = r.document.createElement("script");
            h.onreadystatechange = function() {
              b(), h.onreadystatechange = null, h.parentNode.removeChild(h), h = null;
            }, r.document.documentElement.appendChild(h);
          } : function() {
            setTimeout(b, 0);
          };
          else {
            var m = new r.MessageChannel();
            m.port1.onmessage = b, i = function() {
              m.port2.postMessage(0);
            };
          }
          var u = [];
          function b() {
            var h, v;
            o = !0;
            for (var _ = u.length; _; ) {
              for (v = u, u = [], h = -1; ++h < _; ) v[h]();
              _ = u.length;
            }
            o = !1;
          }
          n.exports = function(h) {
            u.push(h) !== 1 || o || i();
          };
        }).call(this, typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, {}],
      37: [function(t, n, s) {
        "use strict";
        var r = t("immediate");
        function i() {
        }
        var o = {}, a = ["REJECTED"], l = ["FULFILLED"], g = ["PENDING"];
        function p(_) {
          if (typeof _ != "function") throw new TypeError("resolver must be a function");
          this.state = g, this.queue = [], this.outcome = void 0, _ !== i && h(this, _);
        }
        function m(_, y, R) {
          this.promise = _, typeof y == "function" && (this.onFulfilled = y, this.callFulfilled = this.otherCallFulfilled), typeof R == "function" && (this.onRejected = R, this.callRejected = this.otherCallRejected);
        }
        function u(_, y, R) {
          r(function() {
            var k;
            try {
              k = y(R);
            } catch (x) {
              return o.reject(_, x);
            }
            k === _ ? o.reject(_, /* @__PURE__ */ new TypeError("Cannot resolve promise with itself")) : o.resolve(_, k);
          });
        }
        function b(_) {
          var y = _ && _.then;
          if (_ && (typeof _ == "object" || typeof _ == "function") && typeof y == "function") return function() {
            y.apply(_, arguments);
          };
        }
        function h(_, y) {
          var R = !1;
          function k(B) {
            R || (R = !0, o.reject(_, B));
          }
          function x(B) {
            R || (R = !0, o.resolve(_, B));
          }
          var z = v(function() {
            y(x, k);
          });
          z.status === "error" && k(z.value);
        }
        function v(_, y) {
          var R = {};
          try {
            R.value = _(y), R.status = "success";
          } catch (k) {
            R.status = "error", R.value = k;
          }
          return R;
        }
        (n.exports = p).prototype.finally = function(_) {
          if (typeof _ != "function") return this;
          var y = this.constructor;
          return this.then(function(R) {
            return y.resolve(_()).then(function() {
              return R;
            });
          }, function(R) {
            return y.resolve(_()).then(function() {
              throw R;
            });
          });
        }, p.prototype.catch = function(_) {
          return this.then(null, _);
        }, p.prototype.then = function(_, y) {
          if (typeof _ != "function" && this.state === l || typeof y != "function" && this.state === a) return this;
          var R = new this.constructor(i);
          return this.state !== g ? u(R, this.state === l ? _ : y, this.outcome) : this.queue.push(new m(R, _, y)), R;
        }, m.prototype.callFulfilled = function(_) {
          o.resolve(this.promise, _);
        }, m.prototype.otherCallFulfilled = function(_) {
          u(this.promise, this.onFulfilled, _);
        }, m.prototype.callRejected = function(_) {
          o.reject(this.promise, _);
        }, m.prototype.otherCallRejected = function(_) {
          u(this.promise, this.onRejected, _);
        }, o.resolve = function(_, y) {
          var R = v(b, y);
          if (R.status === "error") return o.reject(_, R.value);
          var k = R.value;
          if (k) h(_, k);
          else {
            _.state = l, _.outcome = y;
            for (var x = -1, z = _.queue.length; ++x < z; ) _.queue[x].callFulfilled(y);
          }
          return _;
        }, o.reject = function(_, y) {
          _.state = a, _.outcome = y;
          for (var R = -1, k = _.queue.length; ++R < k; ) _.queue[R].callRejected(y);
          return _;
        }, p.resolve = function(_) {
          return _ instanceof this ? _ : o.resolve(new this(i), _);
        }, p.reject = function(_) {
          var y = new this(i);
          return o.reject(y, _);
        }, p.all = function(_) {
          var y = this;
          if (Object.prototype.toString.call(_) !== "[object Array]") return this.reject(/* @__PURE__ */ new TypeError("must be an array"));
          var R = _.length, k = !1;
          if (!R) return this.resolve([]);
          for (var x = new Array(R), z = 0, B = -1, $ = new this(i); ++B < R; ) O(_[B], B);
          return $;
          function O(q, J) {
            y.resolve(q).then(function(C) {
              x[J] = C, ++z !== R || k || (k = !0, o.resolve($, x));
            }, function(C) {
              k || (k = !0, o.reject($, C));
            });
          }
        }, p.race = function(_) {
          var y = this;
          if (Object.prototype.toString.call(_) !== "[object Array]") return this.reject(/* @__PURE__ */ new TypeError("must be an array"));
          var R = _.length, k = !1;
          if (!R) return this.resolve([]);
          for (var x = -1, z = new this(i); ++x < R; ) B = _[x], y.resolve(B).then(function($) {
            k || (k = !0, o.resolve(z, $));
          }, function($) {
            k || (k = !0, o.reject(z, $));
          });
          var B;
          return z;
        };
      }, { immediate: 36 }],
      38: [function(t, n, s) {
        "use strict";
        var r = {};
        (0, t("./lib/utils/common").assign)(r, t("./lib/deflate"), t("./lib/inflate"), t("./lib/zlib/constants")), n.exports = r;
      }, {
        "./lib/deflate": 39,
        "./lib/inflate": 40,
        "./lib/utils/common": 41,
        "./lib/zlib/constants": 44
      }],
      39: [function(t, n, s) {
        "use strict";
        var r = t("./zlib/deflate"), i = t("./utils/common"), o = t("./utils/strings"), a = t("./zlib/messages"), l = t("./zlib/zstream"), g = Object.prototype.toString, p = 0, m = -1, u = 0, b = 8;
        function h(_) {
          if (!(this instanceof h)) return new h(_);
          this.options = i.assign({
            level: m,
            method: b,
            chunkSize: 16384,
            windowBits: 15,
            memLevel: 8,
            strategy: u,
            to: ""
          }, _ || {});
          var y = this.options;
          y.raw && 0 < y.windowBits ? y.windowBits = -y.windowBits : y.gzip && 0 < y.windowBits && y.windowBits < 16 && (y.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new l(), this.strm.avail_out = 0;
          var R = r.deflateInit2(this.strm, y.level, y.method, y.windowBits, y.memLevel, y.strategy);
          if (R !== p) throw new Error(a[R]);
          if (y.header && r.deflateSetHeader(this.strm, y.header), y.dictionary) {
            var k;
            if (k = typeof y.dictionary == "string" ? o.string2buf(y.dictionary) : g.call(y.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(y.dictionary) : y.dictionary, (R = r.deflateSetDictionary(this.strm, k)) !== p) throw new Error(a[R]);
            this._dict_set = !0;
          }
        }
        function v(_, y) {
          var R = new h(y);
          if (R.push(_, !0), R.err) throw R.msg || a[R.err];
          return R.result;
        }
        h.prototype.push = function(_, y) {
          var R, k, x = this.strm, z = this.options.chunkSize;
          if (this.ended) return !1;
          k = y === ~~y ? y : y === !0 ? 4 : 0, typeof _ == "string" ? x.input = o.string2buf(_) : g.call(_) === "[object ArrayBuffer]" ? x.input = new Uint8Array(_) : x.input = _, x.next_in = 0, x.avail_in = x.input.length;
          do {
            if (x.avail_out === 0 && (x.output = new i.Buf8(z), x.next_out = 0, x.avail_out = z), (R = r.deflate(x, k)) !== 1 && R !== p) return this.onEnd(R), !(this.ended = !0);
            x.avail_out !== 0 && (x.avail_in !== 0 || k !== 4 && k !== 2) || (this.options.to === "string" ? this.onData(o.buf2binstring(i.shrinkBuf(x.output, x.next_out))) : this.onData(i.shrinkBuf(x.output, x.next_out)));
          } while ((0 < x.avail_in || x.avail_out === 0) && R !== 1);
          return k === 4 ? (R = r.deflateEnd(this.strm), this.onEnd(R), this.ended = !0, R === p) : k !== 2 || (this.onEnd(p), !(x.avail_out = 0));
        }, h.prototype.onData = function(_) {
          this.chunks.push(_);
        }, h.prototype.onEnd = function(_) {
          _ === p && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = _, this.msg = this.strm.msg;
        }, s.Deflate = h, s.deflate = v, s.deflateRaw = function(_, y) {
          return (y = y || {}).raw = !0, v(_, y);
        }, s.gzip = function(_, y) {
          return (y = y || {}).gzip = !0, v(_, y);
        };
      }, {
        "./utils/common": 41,
        "./utils/strings": 42,
        "./zlib/deflate": 46,
        "./zlib/messages": 51,
        "./zlib/zstream": 53
      }],
      40: [function(t, n, s) {
        "use strict";
        var r = t("./zlib/inflate"), i = t("./utils/common"), o = t("./utils/strings"), a = t("./zlib/constants"), l = t("./zlib/messages"), g = t("./zlib/zstream"), p = t("./zlib/gzheader"), m = Object.prototype.toString;
        function u(h) {
          if (!(this instanceof u)) return new u(h);
          this.options = i.assign({
            chunkSize: 16384,
            windowBits: 0,
            to: ""
          }, h || {});
          var v = this.options;
          v.raw && 0 <= v.windowBits && v.windowBits < 16 && (v.windowBits = -v.windowBits, v.windowBits === 0 && (v.windowBits = -15)), !(0 <= v.windowBits && v.windowBits < 16) || h && h.windowBits || (v.windowBits += 32), 15 < v.windowBits && v.windowBits < 48 && (15 & v.windowBits) == 0 && (v.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new g(), this.strm.avail_out = 0;
          var _ = r.inflateInit2(this.strm, v.windowBits);
          if (_ !== a.Z_OK) throw new Error(l[_]);
          this.header = new p(), r.inflateGetHeader(this.strm, this.header);
        }
        function b(h, v) {
          var _ = new u(v);
          if (_.push(h, !0), _.err) throw _.msg || l[_.err];
          return _.result;
        }
        u.prototype.push = function(h, v) {
          var _, y, R, k, x, z, B = this.strm, $ = this.options.chunkSize, O = this.options.dictionary, q = !1;
          if (this.ended) return !1;
          y = v === ~~v ? v : v === !0 ? a.Z_FINISH : a.Z_NO_FLUSH, typeof h == "string" ? B.input = o.binstring2buf(h) : m.call(h) === "[object ArrayBuffer]" ? B.input = new Uint8Array(h) : B.input = h, B.next_in = 0, B.avail_in = B.input.length;
          do {
            if (B.avail_out === 0 && (B.output = new i.Buf8($), B.next_out = 0, B.avail_out = $), (_ = r.inflate(B, a.Z_NO_FLUSH)) === a.Z_NEED_DICT && O && (z = typeof O == "string" ? o.string2buf(O) : m.call(O) === "[object ArrayBuffer]" ? new Uint8Array(O) : O, _ = r.inflateSetDictionary(this.strm, z)), _ === a.Z_BUF_ERROR && q === !0 && (_ = a.Z_OK, q = !1), _ !== a.Z_STREAM_END && _ !== a.Z_OK) return this.onEnd(_), !(this.ended = !0);
            B.next_out && (B.avail_out !== 0 && _ !== a.Z_STREAM_END && (B.avail_in !== 0 || y !== a.Z_FINISH && y !== a.Z_SYNC_FLUSH) || (this.options.to === "string" ? (R = o.utf8border(B.output, B.next_out), k = B.next_out - R, x = o.buf2string(B.output, R), B.next_out = k, B.avail_out = $ - k, k && i.arraySet(B.output, B.output, R, k, 0), this.onData(x)) : this.onData(i.shrinkBuf(B.output, B.next_out)))), B.avail_in === 0 && B.avail_out === 0 && (q = !0);
          } while ((0 < B.avail_in || B.avail_out === 0) && _ !== a.Z_STREAM_END);
          return _ === a.Z_STREAM_END && (y = a.Z_FINISH), y === a.Z_FINISH ? (_ = r.inflateEnd(this.strm), this.onEnd(_), this.ended = !0, _ === a.Z_OK) : y !== a.Z_SYNC_FLUSH || (this.onEnd(a.Z_OK), !(B.avail_out = 0));
        }, u.prototype.onData = function(h) {
          this.chunks.push(h);
        }, u.prototype.onEnd = function(h) {
          h === a.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = h, this.msg = this.strm.msg;
        }, s.Inflate = u, s.inflate = b, s.inflateRaw = function(h, v) {
          return (v = v || {}).raw = !0, b(h, v);
        }, s.ungzip = b;
      }, {
        "./utils/common": 41,
        "./utils/strings": 42,
        "./zlib/constants": 44,
        "./zlib/gzheader": 47,
        "./zlib/inflate": 49,
        "./zlib/messages": 51,
        "./zlib/zstream": 53
      }],
      41: [function(t, n, s) {
        "use strict";
        var r = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
        s.assign = function(a) {
          for (var l = Array.prototype.slice.call(arguments, 1); l.length; ) {
            var g = l.shift();
            if (g) {
              if (typeof g != "object") throw new TypeError(g + "must be non-object");
              for (var p in g) g.hasOwnProperty(p) && (a[p] = g[p]);
            }
          }
          return a;
        }, s.shrinkBuf = function(a, l) {
          return a.length === l ? a : a.subarray ? a.subarray(0, l) : (a.length = l, a);
        };
        var i = {
          arraySet: function(a, l, g, p, m) {
            if (l.subarray && a.subarray) a.set(l.subarray(g, g + p), m);
            else for (var u = 0; u < p; u++) a[m + u] = l[g + u];
          },
          flattenChunks: function(a) {
            var l, g, p, m, u, b;
            for (l = p = 0, g = a.length; l < g; l++) p += a[l].length;
            for (b = new Uint8Array(p), l = m = 0, g = a.length; l < g; l++) u = a[l], b.set(u, m), m += u.length;
            return b;
          }
        }, o = {
          arraySet: function(a, l, g, p, m) {
            for (var u = 0; u < p; u++) a[m + u] = l[g + u];
          },
          flattenChunks: function(a) {
            return [].concat.apply([], a);
          }
        };
        s.setTyped = function(a) {
          a ? (s.Buf8 = Uint8Array, s.Buf16 = Uint16Array, s.Buf32 = Int32Array, s.assign(s, i)) : (s.Buf8 = Array, s.Buf16 = Array, s.Buf32 = Array, s.assign(s, o));
        }, s.setTyped(r);
      }, {}],
      42: [function(t, n, s) {
        "use strict";
        var r = t("./common"), i = !0, o = !0;
        try {
          String.fromCharCode.apply(null, [0]);
        } catch {
          i = !1;
        }
        try {
          String.fromCharCode.apply(null, new Uint8Array(1));
        } catch {
          o = !1;
        }
        for (var a = new r.Buf8(256), l = 0; l < 256; l++) a[l] = 252 <= l ? 6 : 248 <= l ? 5 : 240 <= l ? 4 : 224 <= l ? 3 : 192 <= l ? 2 : 1;
        function g(p, m) {
          if (m < 65537 && (p.subarray && o || !p.subarray && i)) return String.fromCharCode.apply(null, r.shrinkBuf(p, m));
          for (var u = "", b = 0; b < m; b++) u += String.fromCharCode(p[b]);
          return u;
        }
        a[254] = a[254] = 1, s.string2buf = function(p) {
          var m, u, b, h, v, _ = p.length, y = 0;
          for (h = 0; h < _; h++) (64512 & (u = p.charCodeAt(h))) == 55296 && h + 1 < _ && (64512 & (b = p.charCodeAt(h + 1))) == 56320 && (u = 65536 + (u - 55296 << 10) + (b - 56320), h++), y += u < 128 ? 1 : u < 2048 ? 2 : u < 65536 ? 3 : 4;
          for (m = new r.Buf8(y), h = v = 0; v < y; h++) (64512 & (u = p.charCodeAt(h))) == 55296 && h + 1 < _ && (64512 & (b = p.charCodeAt(h + 1))) == 56320 && (u = 65536 + (u - 55296 << 10) + (b - 56320), h++), u < 128 ? m[v++] = u : (u < 2048 ? m[v++] = 192 | u >>> 6 : (u < 65536 ? m[v++] = 224 | u >>> 12 : (m[v++] = 240 | u >>> 18, m[v++] = 128 | u >>> 12 & 63), m[v++] = 128 | u >>> 6 & 63), m[v++] = 128 | 63 & u);
          return m;
        }, s.buf2binstring = function(p) {
          return g(p, p.length);
        }, s.binstring2buf = function(p) {
          for (var m = new r.Buf8(p.length), u = 0, b = m.length; u < b; u++) m[u] = p.charCodeAt(u);
          return m;
        }, s.buf2string = function(p, m) {
          var u, b, h, v, _ = m || p.length, y = new Array(2 * _);
          for (u = b = 0; u < _; ) if ((h = p[u++]) < 128) y[b++] = h;
          else if (4 < (v = a[h])) y[b++] = 65533, u += v - 1;
          else {
            for (h &= v === 2 ? 31 : v === 3 ? 15 : 7; 1 < v && u < _; ) h = h << 6 | 63 & p[u++], v--;
            1 < v ? y[b++] = 65533 : h < 65536 ? y[b++] = h : (h -= 65536, y[b++] = 55296 | h >> 10 & 1023, y[b++] = 56320 | 1023 & h);
          }
          return g(y, b);
        }, s.utf8border = function(p, m) {
          var u;
          for ((m = m || p.length) > p.length && (m = p.length), u = m - 1; 0 <= u && (192 & p[u]) == 128; ) u--;
          return u < 0 || u === 0 ? m : u + a[p[u]] > m ? u : m;
        };
      }, { "./common": 41 }],
      43: [function(t, n, s) {
        "use strict";
        n.exports = function(r, i, o, a) {
          for (var l = 65535 & r | 0, g = r >>> 16 & 65535 | 0, p = 0; o !== 0; ) {
            for (o -= p = 2e3 < o ? 2e3 : o; g = g + (l = l + i[a++] | 0) | 0, --p; ) ;
            l %= 65521, g %= 65521;
          }
          return l | g << 16 | 0;
        };
      }, {}],
      44: [function(t, n, s) {
        "use strict";
        n.exports = {
          Z_NO_FLUSH: 0,
          Z_PARTIAL_FLUSH: 1,
          Z_SYNC_FLUSH: 2,
          Z_FULL_FLUSH: 3,
          Z_FINISH: 4,
          Z_BLOCK: 5,
          Z_TREES: 6,
          Z_OK: 0,
          Z_STREAM_END: 1,
          Z_NEED_DICT: 2,
          Z_ERRNO: -1,
          Z_STREAM_ERROR: -2,
          Z_DATA_ERROR: -3,
          Z_BUF_ERROR: -5,
          Z_NO_COMPRESSION: 0,
          Z_BEST_SPEED: 1,
          Z_BEST_COMPRESSION: 9,
          Z_DEFAULT_COMPRESSION: -1,
          Z_FILTERED: 1,
          Z_HUFFMAN_ONLY: 2,
          Z_RLE: 3,
          Z_FIXED: 4,
          Z_DEFAULT_STRATEGY: 0,
          Z_BINARY: 0,
          Z_TEXT: 1,
          Z_UNKNOWN: 2,
          Z_DEFLATED: 8
        };
      }, {}],
      45: [function(t, n, s) {
        "use strict";
        var r = (function() {
          for (var i, o = [], a = 0; a < 256; a++) {
            i = a;
            for (var l = 0; l < 8; l++) i = 1 & i ? 3988292384 ^ i >>> 1 : i >>> 1;
            o[a] = i;
          }
          return o;
        })();
        n.exports = function(i, o, a, l) {
          var g = r, p = l + a;
          i ^= -1;
          for (var m = l; m < p; m++) i = i >>> 8 ^ g[255 & (i ^ o[m])];
          return -1 ^ i;
        };
      }, {}],
      46: [function(t, n, s) {
        "use strict";
        var r, i = t("../utils/common"), o = t("./trees"), a = t("./adler32"), l = t("./crc32"), g = t("./messages"), p = 0, m = 4, u = 0, b = -2, h = -1, v = 4, _ = 2, y = 8, R = 9, k = 286, x = 30, z = 19, B = 2 * k + 1, $ = 15, O = 3, q = 258, J = q + O + 1, C = 42, F = 113, d = 1, D = 2, ee = 3, U = 4;
        function se(c, M) {
          return c.msg = g[M], M;
        }
        function W(c) {
          return (c << 1) - (4 < c ? 9 : 0);
        }
        function Q(c) {
          for (var M = c.length; 0 <= --M; ) c[M] = 0;
        }
        function P(c) {
          var M = c.state, I = M.pending;
          I > c.avail_out && (I = c.avail_out), I !== 0 && (i.arraySet(c.output, M.pending_buf, M.pending_out, I, c.next_out), c.next_out += I, M.pending_out += I, c.total_out += I, c.avail_out -= I, M.pending -= I, M.pending === 0 && (M.pending_out = 0));
        }
        function T(c, M) {
          o._tr_flush_block(c, 0 <= c.block_start ? c.block_start : -1, c.strstart - c.block_start, M), c.block_start = c.strstart, P(c.strm);
        }
        function X(c, M) {
          c.pending_buf[c.pending++] = M;
        }
        function V(c, M) {
          c.pending_buf[c.pending++] = M >>> 8 & 255, c.pending_buf[c.pending++] = 255 & M;
        }
        function H(c, M) {
          var I, S, w = c.max_chain_length, A = c.strstart, L = c.prev_length, N = c.nice_match, E = c.strstart > c.w_size - J ? c.strstart - (c.w_size - J) : 0, Z = c.window, K = c.w_mask, G = c.prev, Y = c.strstart + q, ae = Z[A + L - 1], re = Z[A + L];
          c.prev_length >= c.good_match && (w >>= 2), N > c.lookahead && (N = c.lookahead);
          do
            if (Z[(I = M) + L] === re && Z[I + L - 1] === ae && Z[I] === Z[A] && Z[++I] === Z[A + 1]) {
              A += 2, I++;
              do
                ;
              while (Z[++A] === Z[++I] && Z[++A] === Z[++I] && Z[++A] === Z[++I] && Z[++A] === Z[++I] && Z[++A] === Z[++I] && Z[++A] === Z[++I] && Z[++A] === Z[++I] && Z[++A] === Z[++I] && A < Y);
              if (S = q - (Y - A), A = Y - q, L < S) {
                if (c.match_start = M, N <= (L = S)) break;
                ae = Z[A + L - 1], re = Z[A + L];
              }
            }
          while ((M = G[M & K]) > E && --w != 0);
          return L <= c.lookahead ? L : c.lookahead;
        }
        function te(c) {
          var M, I, S, w, A, L, N, E, Z, K, G = c.w_size;
          do {
            if (w = c.window_size - c.lookahead - c.strstart, c.strstart >= G + (G - J)) {
              for (i.arraySet(c.window, c.window, G, G, 0), c.match_start -= G, c.strstart -= G, c.block_start -= G, M = I = c.hash_size; S = c.head[--M], c.head[M] = G <= S ? S - G : 0, --I; ) ;
              for (M = I = G; S = c.prev[--M], c.prev[M] = G <= S ? S - G : 0, --I; ) ;
              w += G;
            }
            if (c.strm.avail_in === 0) break;
            if (L = c.strm, N = c.window, E = c.strstart + c.lookahead, Z = w, K = void 0, K = L.avail_in, Z < K && (K = Z), I = K === 0 ? 0 : (L.avail_in -= K, i.arraySet(N, L.input, L.next_in, K, E), L.state.wrap === 1 ? L.adler = a(L.adler, N, K, E) : L.state.wrap === 2 && (L.adler = l(L.adler, N, K, E)), L.next_in += K, L.total_in += K, K), c.lookahead += I, c.lookahead + c.insert >= O) for (A = c.strstart - c.insert, c.ins_h = c.window[A], c.ins_h = (c.ins_h << c.hash_shift ^ c.window[A + 1]) & c.hash_mask; c.insert && (c.ins_h = (c.ins_h << c.hash_shift ^ c.window[A + O - 1]) & c.hash_mask, c.prev[A & c.w_mask] = c.head[c.ins_h], c.head[c.ins_h] = A, A++, c.insert--, !(c.lookahead + c.insert < O)); ) ;
          } while (c.lookahead < J && c.strm.avail_in !== 0);
        }
        function oe(c, M) {
          for (var I, S; ; ) {
            if (c.lookahead < J) {
              if (te(c), c.lookahead < J && M === p) return d;
              if (c.lookahead === 0) break;
            }
            if (I = 0, c.lookahead >= O && (c.ins_h = (c.ins_h << c.hash_shift ^ c.window[c.strstart + O - 1]) & c.hash_mask, I = c.prev[c.strstart & c.w_mask] = c.head[c.ins_h], c.head[c.ins_h] = c.strstart), I !== 0 && c.strstart - I <= c.w_size - J && (c.match_length = H(c, I)), c.match_length >= O) if (S = o._tr_tally(c, c.strstart - c.match_start, c.match_length - O), c.lookahead -= c.match_length, c.match_length <= c.max_lazy_match && c.lookahead >= O) {
              for (c.match_length--; c.strstart++, c.ins_h = (c.ins_h << c.hash_shift ^ c.window[c.strstart + O - 1]) & c.hash_mask, I = c.prev[c.strstart & c.w_mask] = c.head[c.ins_h], c.head[c.ins_h] = c.strstart, --c.match_length != 0; ) ;
              c.strstart++;
            } else c.strstart += c.match_length, c.match_length = 0, c.ins_h = c.window[c.strstart], c.ins_h = (c.ins_h << c.hash_shift ^ c.window[c.strstart + 1]) & c.hash_mask;
            else S = o._tr_tally(c, 0, c.window[c.strstart]), c.lookahead--, c.strstart++;
            if (S && (T(c, !1), c.strm.avail_out === 0)) return d;
          }
          return c.insert = c.strstart < O - 1 ? c.strstart : O - 1, M === m ? (T(c, !0), c.strm.avail_out === 0 ? ee : U) : c.last_lit && (T(c, !1), c.strm.avail_out === 0) ? d : D;
        }
        function ne(c, M) {
          for (var I, S, w; ; ) {
            if (c.lookahead < J) {
              if (te(c), c.lookahead < J && M === p) return d;
              if (c.lookahead === 0) break;
            }
            if (I = 0, c.lookahead >= O && (c.ins_h = (c.ins_h << c.hash_shift ^ c.window[c.strstart + O - 1]) & c.hash_mask, I = c.prev[c.strstart & c.w_mask] = c.head[c.ins_h], c.head[c.ins_h] = c.strstart), c.prev_length = c.match_length, c.prev_match = c.match_start, c.match_length = O - 1, I !== 0 && c.prev_length < c.max_lazy_match && c.strstart - I <= c.w_size - J && (c.match_length = H(c, I), c.match_length <= 5 && (c.strategy === 1 || c.match_length === O && 4096 < c.strstart - c.match_start) && (c.match_length = O - 1)), c.prev_length >= O && c.match_length <= c.prev_length) {
              for (w = c.strstart + c.lookahead - O, S = o._tr_tally(c, c.strstart - 1 - c.prev_match, c.prev_length - O), c.lookahead -= c.prev_length - 1, c.prev_length -= 2; ++c.strstart <= w && (c.ins_h = (c.ins_h << c.hash_shift ^ c.window[c.strstart + O - 1]) & c.hash_mask, I = c.prev[c.strstart & c.w_mask] = c.head[c.ins_h], c.head[c.ins_h] = c.strstart), --c.prev_length != 0; ) ;
              if (c.match_available = 0, c.match_length = O - 1, c.strstart++, S && (T(c, !1), c.strm.avail_out === 0)) return d;
            } else if (c.match_available) {
              if ((S = o._tr_tally(c, 0, c.window[c.strstart - 1])) && T(c, !1), c.strstart++, c.lookahead--, c.strm.avail_out === 0) return d;
            } else c.match_available = 1, c.strstart++, c.lookahead--;
          }
          return c.match_available && (S = o._tr_tally(c, 0, c.window[c.strstart - 1]), c.match_available = 0), c.insert = c.strstart < O - 1 ? c.strstart : O - 1, M === m ? (T(c, !0), c.strm.avail_out === 0 ? ee : U) : c.last_lit && (T(c, !1), c.strm.avail_out === 0) ? d : D;
        }
        function ie(c, M, I, S, w) {
          this.good_length = c, this.max_lazy = M, this.nice_length = I, this.max_chain = S, this.func = w;
        }
        function ue() {
          this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = y, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(2 * B), this.dyn_dtree = new i.Buf16(2 * (2 * x + 1)), this.bl_tree = new i.Buf16(2 * (2 * z + 1)), Q(this.dyn_ltree), Q(this.dyn_dtree), Q(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16($ + 1), this.heap = new i.Buf16(2 * k + 1), Q(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(2 * k + 1), Q(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
        }
        function ce(c) {
          var M;
          return c && c.state ? (c.total_in = c.total_out = 0, c.data_type = _, (M = c.state).pending = 0, M.pending_out = 0, M.wrap < 0 && (M.wrap = -M.wrap), M.status = M.wrap ? C : F, c.adler = M.wrap === 2 ? 0 : 1, M.last_flush = p, o._tr_init(M), u) : se(c, b);
        }
        function me(c) {
          var M = ce(c);
          return M === u && (function(I) {
            I.window_size = 2 * I.w_size, Q(I.head), I.max_lazy_match = r[I.level].max_lazy, I.good_match = r[I.level].good_length, I.nice_match = r[I.level].nice_length, I.max_chain_length = r[I.level].max_chain, I.strstart = 0, I.block_start = 0, I.lookahead = 0, I.insert = 0, I.match_length = I.prev_length = O - 1, I.match_available = 0, I.ins_h = 0;
          })(c.state), M;
        }
        function pe(c, M, I, S, w, A) {
          if (!c) return b;
          var L = 1;
          if (M === h && (M = 6), S < 0 ? (L = 0, S = -S) : 15 < S && (L = 2, S -= 16), w < 1 || R < w || I !== y || S < 8 || 15 < S || M < 0 || 9 < M || A < 0 || v < A) return se(c, b);
          S === 8 && (S = 9);
          var N = new ue();
          return (c.state = N).strm = c, N.wrap = L, N.gzhead = null, N.w_bits = S, N.w_size = 1 << N.w_bits, N.w_mask = N.w_size - 1, N.hash_bits = w + 7, N.hash_size = 1 << N.hash_bits, N.hash_mask = N.hash_size - 1, N.hash_shift = ~~((N.hash_bits + O - 1) / O), N.window = new i.Buf8(2 * N.w_size), N.head = new i.Buf16(N.hash_size), N.prev = new i.Buf16(N.w_size), N.lit_bufsize = 1 << w + 6, N.pending_buf_size = 4 * N.lit_bufsize, N.pending_buf = new i.Buf8(N.pending_buf_size), N.d_buf = 1 * N.lit_bufsize, N.l_buf = 3 * N.lit_bufsize, N.level = M, N.strategy = A, N.method = I, me(c);
        }
        r = [
          new ie(0, 0, 0, 0, function(c, M) {
            var I = 65535;
            for (I > c.pending_buf_size - 5 && (I = c.pending_buf_size - 5); ; ) {
              if (c.lookahead <= 1) {
                if (te(c), c.lookahead === 0 && M === p) return d;
                if (c.lookahead === 0) break;
              }
              c.strstart += c.lookahead, c.lookahead = 0;
              var S = c.block_start + I;
              if ((c.strstart === 0 || c.strstart >= S) && (c.lookahead = c.strstart - S, c.strstart = S, T(c, !1), c.strm.avail_out === 0) || c.strstart - c.block_start >= c.w_size - J && (T(c, !1), c.strm.avail_out === 0)) return d;
            }
            return c.insert = 0, M === m ? (T(c, !0), c.strm.avail_out === 0 ? ee : U) : (c.strstart > c.block_start && T(c, !1), d);
          }),
          new ie(4, 4, 8, 4, oe),
          new ie(4, 5, 16, 8, oe),
          new ie(4, 6, 32, 32, oe),
          new ie(4, 4, 16, 16, ne),
          new ie(8, 16, 32, 32, ne),
          new ie(8, 16, 128, 128, ne),
          new ie(8, 32, 128, 256, ne),
          new ie(32, 128, 258, 1024, ne),
          new ie(32, 258, 258, 4096, ne)
        ], s.deflateInit = function(c, M) {
          return pe(c, M, y, 15, 8, 0);
        }, s.deflateInit2 = pe, s.deflateReset = me, s.deflateResetKeep = ce, s.deflateSetHeader = function(c, M) {
          return c && c.state ? c.state.wrap !== 2 ? b : (c.state.gzhead = M, u) : b;
        }, s.deflate = function(c, M) {
          var I, S, w, A;
          if (!c || !c.state || 5 < M || M < 0) return c ? se(c, b) : b;
          if (S = c.state, !c.output || !c.input && c.avail_in !== 0 || S.status === 666 && M !== m) return se(c, c.avail_out === 0 ? -5 : b);
          if (S.strm = c, I = S.last_flush, S.last_flush = M, S.status === C) if (S.wrap === 2) c.adler = 0, X(S, 31), X(S, 139), X(S, 8), S.gzhead ? (X(S, (S.gzhead.text ? 1 : 0) + (S.gzhead.hcrc ? 2 : 0) + (S.gzhead.extra ? 4 : 0) + (S.gzhead.name ? 8 : 0) + (S.gzhead.comment ? 16 : 0)), X(S, 255 & S.gzhead.time), X(S, S.gzhead.time >> 8 & 255), X(S, S.gzhead.time >> 16 & 255), X(S, S.gzhead.time >> 24 & 255), X(S, S.level === 9 ? 2 : 2 <= S.strategy || S.level < 2 ? 4 : 0), X(S, 255 & S.gzhead.os), S.gzhead.extra && S.gzhead.extra.length && (X(S, 255 & S.gzhead.extra.length), X(S, S.gzhead.extra.length >> 8 & 255)), S.gzhead.hcrc && (c.adler = l(c.adler, S.pending_buf, S.pending, 0)), S.gzindex = 0, S.status = 69) : (X(S, 0), X(S, 0), X(S, 0), X(S, 0), X(S, 0), X(S, S.level === 9 ? 2 : 2 <= S.strategy || S.level < 2 ? 4 : 0), X(S, 3), S.status = F);
          else {
            var L = y + (S.w_bits - 8 << 4) << 8;
            L |= (2 <= S.strategy || S.level < 2 ? 0 : S.level < 6 ? 1 : S.level === 6 ? 2 : 3) << 6, S.strstart !== 0 && (L |= 32), L += 31 - L % 31, S.status = F, V(S, L), S.strstart !== 0 && (V(S, c.adler >>> 16), V(S, 65535 & c.adler)), c.adler = 1;
          }
          if (S.status === 69) if (S.gzhead.extra) {
            for (w = S.pending; S.gzindex < (65535 & S.gzhead.extra.length) && (S.pending !== S.pending_buf_size || (S.gzhead.hcrc && S.pending > w && (c.adler = l(c.adler, S.pending_buf, S.pending - w, w)), P(c), w = S.pending, S.pending !== S.pending_buf_size)); ) X(S, 255 & S.gzhead.extra[S.gzindex]), S.gzindex++;
            S.gzhead.hcrc && S.pending > w && (c.adler = l(c.adler, S.pending_buf, S.pending - w, w)), S.gzindex === S.gzhead.extra.length && (S.gzindex = 0, S.status = 73);
          } else S.status = 73;
          if (S.status === 73) if (S.gzhead.name) {
            w = S.pending;
            do {
              if (S.pending === S.pending_buf_size && (S.gzhead.hcrc && S.pending > w && (c.adler = l(c.adler, S.pending_buf, S.pending - w, w)), P(c), w = S.pending, S.pending === S.pending_buf_size)) {
                A = 1;
                break;
              }
              A = S.gzindex < S.gzhead.name.length ? 255 & S.gzhead.name.charCodeAt(S.gzindex++) : 0, X(S, A);
            } while (A !== 0);
            S.gzhead.hcrc && S.pending > w && (c.adler = l(c.adler, S.pending_buf, S.pending - w, w)), A === 0 && (S.gzindex = 0, S.status = 91);
          } else S.status = 91;
          if (S.status === 91) if (S.gzhead.comment) {
            w = S.pending;
            do {
              if (S.pending === S.pending_buf_size && (S.gzhead.hcrc && S.pending > w && (c.adler = l(c.adler, S.pending_buf, S.pending - w, w)), P(c), w = S.pending, S.pending === S.pending_buf_size)) {
                A = 1;
                break;
              }
              A = S.gzindex < S.gzhead.comment.length ? 255 & S.gzhead.comment.charCodeAt(S.gzindex++) : 0, X(S, A);
            } while (A !== 0);
            S.gzhead.hcrc && S.pending > w && (c.adler = l(c.adler, S.pending_buf, S.pending - w, w)), A === 0 && (S.status = 103);
          } else S.status = 103;
          if (S.status === 103 && (S.gzhead.hcrc ? (S.pending + 2 > S.pending_buf_size && P(c), S.pending + 2 <= S.pending_buf_size && (X(S, 255 & c.adler), X(S, c.adler >> 8 & 255), c.adler = 0, S.status = F)) : S.status = F), S.pending !== 0) {
            if (P(c), c.avail_out === 0) return S.last_flush = -1, u;
          } else if (c.avail_in === 0 && W(M) <= W(I) && M !== m) return se(c, -5);
          if (S.status === 666 && c.avail_in !== 0) return se(c, -5);
          if (c.avail_in !== 0 || S.lookahead !== 0 || M !== p && S.status !== 666) {
            var N = S.strategy === 2 ? (function(E, Z) {
              for (var K; ; ) {
                if (E.lookahead === 0 && (te(E), E.lookahead === 0)) {
                  if (Z === p) return d;
                  break;
                }
                if (E.match_length = 0, K = o._tr_tally(E, 0, E.window[E.strstart]), E.lookahead--, E.strstart++, K && (T(E, !1), E.strm.avail_out === 0)) return d;
              }
              return E.insert = 0, Z === m ? (T(E, !0), E.strm.avail_out === 0 ? ee : U) : E.last_lit && (T(E, !1), E.strm.avail_out === 0) ? d : D;
            })(S, M) : S.strategy === 3 ? (function(E, Z) {
              for (var K, G, Y, ae, re = E.window; ; ) {
                if (E.lookahead <= q) {
                  if (te(E), E.lookahead <= q && Z === p) return d;
                  if (E.lookahead === 0) break;
                }
                if (E.match_length = 0, E.lookahead >= O && 0 < E.strstart && (G = re[Y = E.strstart - 1]) === re[++Y] && G === re[++Y] && G === re[++Y]) {
                  ae = E.strstart + q;
                  do
                    ;
                  while (G === re[++Y] && G === re[++Y] && G === re[++Y] && G === re[++Y] && G === re[++Y] && G === re[++Y] && G === re[++Y] && G === re[++Y] && Y < ae);
                  E.match_length = q - (ae - Y), E.match_length > E.lookahead && (E.match_length = E.lookahead);
                }
                if (E.match_length >= O ? (K = o._tr_tally(E, 1, E.match_length - O), E.lookahead -= E.match_length, E.strstart += E.match_length, E.match_length = 0) : (K = o._tr_tally(E, 0, E.window[E.strstart]), E.lookahead--, E.strstart++), K && (T(E, !1), E.strm.avail_out === 0)) return d;
              }
              return E.insert = 0, Z === m ? (T(E, !0), E.strm.avail_out === 0 ? ee : U) : E.last_lit && (T(E, !1), E.strm.avail_out === 0) ? d : D;
            })(S, M) : r[S.level].func(S, M);
            if (N !== ee && N !== U || (S.status = 666), N === d || N === ee) return c.avail_out === 0 && (S.last_flush = -1), u;
            if (N === D && (M === 1 ? o._tr_align(S) : M !== 5 && (o._tr_stored_block(S, 0, 0, !1), M === 3 && (Q(S.head), S.lookahead === 0 && (S.strstart = 0, S.block_start = 0, S.insert = 0))), P(c), c.avail_out === 0)) return S.last_flush = -1, u;
          }
          return M !== m ? u : S.wrap <= 0 ? 1 : (S.wrap === 2 ? (X(S, 255 & c.adler), X(S, c.adler >> 8 & 255), X(S, c.adler >> 16 & 255), X(S, c.adler >> 24 & 255), X(S, 255 & c.total_in), X(S, c.total_in >> 8 & 255), X(S, c.total_in >> 16 & 255), X(S, c.total_in >> 24 & 255)) : (V(S, c.adler >>> 16), V(S, 65535 & c.adler)), P(c), 0 < S.wrap && (S.wrap = -S.wrap), S.pending !== 0 ? u : 1);
        }, s.deflateEnd = function(c) {
          var M;
          return c && c.state ? (M = c.state.status) !== C && M !== 69 && M !== 73 && M !== 91 && M !== 103 && M !== F && M !== 666 ? se(c, b) : (c.state = null, M === F ? se(c, -3) : u) : b;
        }, s.deflateSetDictionary = function(c, M) {
          var I, S, w, A, L, N, E, Z, K = M.length;
          if (!c || !c.state || (A = (I = c.state).wrap) === 2 || A === 1 && I.status !== C || I.lookahead) return b;
          for (A === 1 && (c.adler = a(c.adler, M, K, 0)), I.wrap = 0, K >= I.w_size && (A === 0 && (Q(I.head), I.strstart = 0, I.block_start = 0, I.insert = 0), Z = new i.Buf8(I.w_size), i.arraySet(Z, M, K - I.w_size, I.w_size, 0), M = Z, K = I.w_size), L = c.avail_in, N = c.next_in, E = c.input, c.avail_in = K, c.next_in = 0, c.input = M, te(I); I.lookahead >= O; ) {
            for (S = I.strstart, w = I.lookahead - (O - 1); I.ins_h = (I.ins_h << I.hash_shift ^ I.window[S + O - 1]) & I.hash_mask, I.prev[S & I.w_mask] = I.head[I.ins_h], I.head[I.ins_h] = S, S++, --w; ) ;
            I.strstart = S, I.lookahead = O - 1, te(I);
          }
          return I.strstart += I.lookahead, I.block_start = I.strstart, I.insert = I.lookahead, I.lookahead = 0, I.match_length = I.prev_length = O - 1, I.match_available = 0, c.next_in = N, c.input = E, c.avail_in = L, I.wrap = A, u;
        }, s.deflateInfo = "pako deflate (from Nodeca project)";
      }, {
        "../utils/common": 41,
        "./adler32": 43,
        "./crc32": 45,
        "./messages": 51,
        "./trees": 52
      }],
      47: [function(t, n, s) {
        "use strict";
        n.exports = function() {
          this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
        };
      }, {}],
      48: [function(t, n, s) {
        "use strict";
        n.exports = function(r, i) {
          var o = r.state, a = r.next_in, l, g, p, m, u, b, h, v, _, y, R, k, x, z, B, $, O, q, J, C, F, d = r.input, D;
          l = a + (r.avail_in - 5), g = r.next_out, D = r.output, p = g - (i - r.avail_out), m = g + (r.avail_out - 257), u = o.dmax, b = o.wsize, h = o.whave, v = o.wnext, _ = o.window, y = o.hold, R = o.bits, k = o.lencode, x = o.distcode, z = (1 << o.lenbits) - 1, B = (1 << o.distbits) - 1;
          e: do {
            R < 15 && (y += d[a++] << R, R += 8, y += d[a++] << R, R += 8), $ = k[y & z];
            t: for (; ; ) {
              if (y >>>= O = $ >>> 24, R -= O, (O = $ >>> 16 & 255) === 0) D[g++] = 65535 & $;
              else {
                if (!(16 & O)) {
                  if ((64 & O) == 0) {
                    $ = k[(65535 & $) + (y & (1 << O) - 1)];
                    continue t;
                  }
                  if (32 & O) {
                    o.mode = 12;
                    break e;
                  }
                  r.msg = "invalid literal/length code", o.mode = 30;
                  break e;
                }
                q = 65535 & $, (O &= 15) && (R < O && (y += d[a++] << R, R += 8), q += y & (1 << O) - 1, y >>>= O, R -= O), R < 15 && (y += d[a++] << R, R += 8, y += d[a++] << R, R += 8), $ = x[y & B];
                s: for (; ; ) {
                  if (y >>>= O = $ >>> 24, R -= O, !(16 & (O = $ >>> 16 & 255))) {
                    if ((64 & O) == 0) {
                      $ = x[(65535 & $) + (y & (1 << O) - 1)];
                      continue s;
                    }
                    r.msg = "invalid distance code", o.mode = 30;
                    break e;
                  }
                  if (J = 65535 & $, R < (O &= 15) && (y += d[a++] << R, (R += 8) < O && (y += d[a++] << R, R += 8)), u < (J += y & (1 << O) - 1)) {
                    r.msg = "invalid distance too far back", o.mode = 30;
                    break e;
                  }
                  if (y >>>= O, R -= O, (O = g - p) < J) {
                    if (h < (O = J - O) && o.sane) {
                      r.msg = "invalid distance too far back", o.mode = 30;
                      break e;
                    }
                    if (F = _, (C = 0) === v) {
                      if (C += b - O, O < q) {
                        for (q -= O; D[g++] = _[C++], --O; ) ;
                        C = g - J, F = D;
                      }
                    } else if (v < O) {
                      if (C += b + v - O, (O -= v) < q) {
                        for (q -= O; D[g++] = _[C++], --O; ) ;
                        if (C = 0, v < q) {
                          for (q -= O = v; D[g++] = _[C++], --O; ) ;
                          C = g - J, F = D;
                        }
                      }
                    } else if (C += v - O, O < q) {
                      for (q -= O; D[g++] = _[C++], --O; ) ;
                      C = g - J, F = D;
                    }
                    for (; 2 < q; ) D[g++] = F[C++], D[g++] = F[C++], D[g++] = F[C++], q -= 3;
                    q && (D[g++] = F[C++], 1 < q && (D[g++] = F[C++]));
                  } else {
                    for (C = g - J; D[g++] = D[C++], D[g++] = D[C++], D[g++] = D[C++], 2 < (q -= 3); ) ;
                    q && (D[g++] = D[C++], 1 < q && (D[g++] = D[C++]));
                  }
                  break;
                }
              }
              break;
            }
          } while (a < l && g < m);
          a -= q = R >> 3, y &= (1 << (R -= q << 3)) - 1, r.next_in = a, r.next_out = g, r.avail_in = a < l ? l - a + 5 : 5 - (a - l), r.avail_out = g < m ? m - g + 257 : 257 - (g - m), o.hold = y, o.bits = R;
        };
      }, {}],
      49: [function(t, n, s) {
        "use strict";
        var r = t("../utils/common"), i = t("./adler32"), o = t("./crc32"), a = t("./inffast"), l = t("./inftrees"), g = 1, p = 2, m = 0, u = -2, b = 1, h = 852, v = 592;
        function _(C) {
          return (C >>> 24 & 255) + (C >>> 8 & 65280) + ((65280 & C) << 8) + ((255 & C) << 24);
        }
        function y() {
          this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new r.Buf16(320), this.work = new r.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
        }
        function R(C) {
          var F;
          return C && C.state ? (F = C.state, C.total_in = C.total_out = F.total = 0, C.msg = "", F.wrap && (C.adler = 1 & F.wrap), F.mode = b, F.last = 0, F.havedict = 0, F.dmax = 32768, F.head = null, F.hold = 0, F.bits = 0, F.lencode = F.lendyn = new r.Buf32(h), F.distcode = F.distdyn = new r.Buf32(v), F.sane = 1, F.back = -1, m) : u;
        }
        function k(C) {
          var F;
          return C && C.state ? ((F = C.state).wsize = 0, F.whave = 0, F.wnext = 0, R(C)) : u;
        }
        function x(C, F) {
          var d, D;
          return C && C.state ? (D = C.state, F < 0 ? (d = 0, F = -F) : (d = 1 + (F >> 4), F < 48 && (F &= 15)), F && (F < 8 || 15 < F) ? u : (D.window !== null && D.wbits !== F && (D.window = null), D.wrap = d, D.wbits = F, k(C))) : u;
        }
        function z(C, F) {
          var d, D;
          return C ? (D = new y(), (C.state = D).window = null, (d = x(C, F)) !== m && (C.state = null), d) : u;
        }
        var B, $, O = !0;
        function q(C) {
          if (O) {
            var F;
            for (B = new r.Buf32(512), $ = new r.Buf32(32), F = 0; F < 144; ) C.lens[F++] = 8;
            for (; F < 256; ) C.lens[F++] = 9;
            for (; F < 280; ) C.lens[F++] = 7;
            for (; F < 288; ) C.lens[F++] = 8;
            for (l(g, C.lens, 0, 288, B, 0, C.work, { bits: 9 }), F = 0; F < 32; ) C.lens[F++] = 5;
            l(p, C.lens, 0, 32, $, 0, C.work, { bits: 5 }), O = !1;
          }
          C.lencode = B, C.lenbits = 9, C.distcode = $, C.distbits = 5;
        }
        function J(C, F, d, D) {
          var ee, U = C.state;
          return U.window === null && (U.wsize = 1 << U.wbits, U.wnext = 0, U.whave = 0, U.window = new r.Buf8(U.wsize)), D >= U.wsize ? (r.arraySet(U.window, F, d - U.wsize, U.wsize, 0), U.wnext = 0, U.whave = U.wsize) : (D < (ee = U.wsize - U.wnext) && (ee = D), r.arraySet(U.window, F, d - D, ee, U.wnext), (D -= ee) ? (r.arraySet(U.window, F, d - D, D, 0), U.wnext = D, U.whave = U.wsize) : (U.wnext += ee, U.wnext === U.wsize && (U.wnext = 0), U.whave < U.wsize && (U.whave += ee))), 0;
        }
        s.inflateReset = k, s.inflateReset2 = x, s.inflateResetKeep = R, s.inflateInit = function(C) {
          return z(C, 15);
        }, s.inflateInit2 = z, s.inflate = function(C, F) {
          var d, D, ee, U, se, W, Q, P, T, X, V, H, te, oe, ne, ie, ue, ce, me, pe, c, M, I, S, w = 0, A = new r.Buf8(4), L = [
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
          ];
          if (!C || !C.state || !C.output || !C.input && C.avail_in !== 0) return u;
          (d = C.state).mode === 12 && (d.mode = 13), se = C.next_out, ee = C.output, Q = C.avail_out, U = C.next_in, D = C.input, W = C.avail_in, P = d.hold, T = d.bits, X = W, V = Q, M = m;
          e: for (; ; ) switch (d.mode) {
            case b:
              if (d.wrap === 0) {
                d.mode = 13;
                break;
              }
              for (; T < 16; ) {
                if (W === 0) break e;
                W--, P += D[U++] << T, T += 8;
              }
              if (2 & d.wrap && P === 35615) {
                A[d.check = 0] = 255 & P, A[1] = P >>> 8 & 255, d.check = o(d.check, A, 2, 0), T = P = 0, d.mode = 2;
                break;
              }
              if (d.flags = 0, d.head && (d.head.done = !1), !(1 & d.wrap) || (((255 & P) << 8) + (P >> 8)) % 31) {
                C.msg = "incorrect header check", d.mode = 30;
                break;
              }
              if ((15 & P) != 8) {
                C.msg = "unknown compression method", d.mode = 30;
                break;
              }
              if (T -= 4, c = 8 + (15 & (P >>>= 4)), d.wbits === 0) d.wbits = c;
              else if (c > d.wbits) {
                C.msg = "invalid window size", d.mode = 30;
                break;
              }
              d.dmax = 1 << c, C.adler = d.check = 1, d.mode = 512 & P ? 10 : 12, T = P = 0;
              break;
            case 2:
              for (; T < 16; ) {
                if (W === 0) break e;
                W--, P += D[U++] << T, T += 8;
              }
              if (d.flags = P, (255 & d.flags) != 8) {
                C.msg = "unknown compression method", d.mode = 30;
                break;
              }
              if (57344 & d.flags) {
                C.msg = "unknown header flags set", d.mode = 30;
                break;
              }
              d.head && (d.head.text = P >> 8 & 1), 512 & d.flags && (A[0] = 255 & P, A[1] = P >>> 8 & 255, d.check = o(d.check, A, 2, 0)), T = P = 0, d.mode = 3;
            case 3:
              for (; T < 32; ) {
                if (W === 0) break e;
                W--, P += D[U++] << T, T += 8;
              }
              d.head && (d.head.time = P), 512 & d.flags && (A[0] = 255 & P, A[1] = P >>> 8 & 255, A[2] = P >>> 16 & 255, A[3] = P >>> 24 & 255, d.check = o(d.check, A, 4, 0)), T = P = 0, d.mode = 4;
            case 4:
              for (; T < 16; ) {
                if (W === 0) break e;
                W--, P += D[U++] << T, T += 8;
              }
              d.head && (d.head.xflags = 255 & P, d.head.os = P >> 8), 512 & d.flags && (A[0] = 255 & P, A[1] = P >>> 8 & 255, d.check = o(d.check, A, 2, 0)), T = P = 0, d.mode = 5;
            case 5:
              if (1024 & d.flags) {
                for (; T < 16; ) {
                  if (W === 0) break e;
                  W--, P += D[U++] << T, T += 8;
                }
                d.length = P, d.head && (d.head.extra_len = P), 512 & d.flags && (A[0] = 255 & P, A[1] = P >>> 8 & 255, d.check = o(d.check, A, 2, 0)), T = P = 0;
              } else d.head && (d.head.extra = null);
              d.mode = 6;
            case 6:
              if (1024 & d.flags && (W < (H = d.length) && (H = W), H && (d.head && (c = d.head.extra_len - d.length, d.head.extra || (d.head.extra = new Array(d.head.extra_len)), r.arraySet(d.head.extra, D, U, H, c)), 512 & d.flags && (d.check = o(d.check, D, H, U)), W -= H, U += H, d.length -= H), d.length)) break e;
              d.length = 0, d.mode = 7;
            case 7:
              if (2048 & d.flags) {
                if (W === 0) break e;
                for (H = 0; c = D[U + H++], d.head && c && d.length < 65536 && (d.head.name += String.fromCharCode(c)), c && H < W; ) ;
                if (512 & d.flags && (d.check = o(d.check, D, H, U)), W -= H, U += H, c) break e;
              } else d.head && (d.head.name = null);
              d.length = 0, d.mode = 8;
            case 8:
              if (4096 & d.flags) {
                if (W === 0) break e;
                for (H = 0; c = D[U + H++], d.head && c && d.length < 65536 && (d.head.comment += String.fromCharCode(c)), c && H < W; ) ;
                if (512 & d.flags && (d.check = o(d.check, D, H, U)), W -= H, U += H, c) break e;
              } else d.head && (d.head.comment = null);
              d.mode = 9;
            case 9:
              if (512 & d.flags) {
                for (; T < 16; ) {
                  if (W === 0) break e;
                  W--, P += D[U++] << T, T += 8;
                }
                if (P !== (65535 & d.check)) {
                  C.msg = "header crc mismatch", d.mode = 30;
                  break;
                }
                T = P = 0;
              }
              d.head && (d.head.hcrc = d.flags >> 9 & 1, d.head.done = !0), C.adler = d.check = 0, d.mode = 12;
              break;
            case 10:
              for (; T < 32; ) {
                if (W === 0) break e;
                W--, P += D[U++] << T, T += 8;
              }
              C.adler = d.check = _(P), T = P = 0, d.mode = 11;
            case 11:
              if (d.havedict === 0) return C.next_out = se, C.avail_out = Q, C.next_in = U, C.avail_in = W, d.hold = P, d.bits = T, 2;
              C.adler = d.check = 1, d.mode = 12;
            case 12:
              if (F === 5 || F === 6) break e;
            case 13:
              if (d.last) {
                P >>>= 7 & T, T -= 7 & T, d.mode = 27;
                break;
              }
              for (; T < 3; ) {
                if (W === 0) break e;
                W--, P += D[U++] << T, T += 8;
              }
              switch (d.last = 1 & P, T -= 1, 3 & (P >>>= 1)) {
                case 0:
                  d.mode = 14;
                  break;
                case 1:
                  if (q(d), d.mode = 20, F !== 6) break;
                  P >>>= 2, T -= 2;
                  break e;
                case 2:
                  d.mode = 17;
                  break;
                case 3:
                  C.msg = "invalid block type", d.mode = 30;
              }
              P >>>= 2, T -= 2;
              break;
            case 14:
              for (P >>>= 7 & T, T -= 7 & T; T < 32; ) {
                if (W === 0) break e;
                W--, P += D[U++] << T, T += 8;
              }
              if ((65535 & P) != (P >>> 16 ^ 65535)) {
                C.msg = "invalid stored block lengths", d.mode = 30;
                break;
              }
              if (d.length = 65535 & P, T = P = 0, d.mode = 15, F === 6) break e;
            case 15:
              d.mode = 16;
            case 16:
              if (H = d.length) {
                if (W < H && (H = W), Q < H && (H = Q), H === 0) break e;
                r.arraySet(ee, D, U, H, se), W -= H, U += H, Q -= H, se += H, d.length -= H;
                break;
              }
              d.mode = 12;
              break;
            case 17:
              for (; T < 14; ) {
                if (W === 0) break e;
                W--, P += D[U++] << T, T += 8;
              }
              if (d.nlen = 257 + (31 & P), P >>>= 5, T -= 5, d.ndist = 1 + (31 & P), P >>>= 5, T -= 5, d.ncode = 4 + (15 & P), P >>>= 4, T -= 4, 286 < d.nlen || 30 < d.ndist) {
                C.msg = "too many length or distance symbols", d.mode = 30;
                break;
              }
              d.have = 0, d.mode = 18;
            case 18:
              for (; d.have < d.ncode; ) {
                for (; T < 3; ) {
                  if (W === 0) break e;
                  W--, P += D[U++] << T, T += 8;
                }
                d.lens[L[d.have++]] = 7 & P, P >>>= 3, T -= 3;
              }
              for (; d.have < 19; ) d.lens[L[d.have++]] = 0;
              if (d.lencode = d.lendyn, d.lenbits = 7, I = { bits: d.lenbits }, M = l(0, d.lens, 0, 19, d.lencode, 0, d.work, I), d.lenbits = I.bits, M) {
                C.msg = "invalid code lengths set", d.mode = 30;
                break;
              }
              d.have = 0, d.mode = 19;
            case 19:
              for (; d.have < d.nlen + d.ndist; ) {
                for (; ie = (w = d.lencode[P & (1 << d.lenbits) - 1]) >>> 16 & 255, ue = 65535 & w, !((ne = w >>> 24) <= T); ) {
                  if (W === 0) break e;
                  W--, P += D[U++] << T, T += 8;
                }
                if (ue < 16) P >>>= ne, T -= ne, d.lens[d.have++] = ue;
                else {
                  if (ue === 16) {
                    for (S = ne + 2; T < S; ) {
                      if (W === 0) break e;
                      W--, P += D[U++] << T, T += 8;
                    }
                    if (P >>>= ne, T -= ne, d.have === 0) {
                      C.msg = "invalid bit length repeat", d.mode = 30;
                      break;
                    }
                    c = d.lens[d.have - 1], H = 3 + (3 & P), P >>>= 2, T -= 2;
                  } else if (ue === 17) {
                    for (S = ne + 3; T < S; ) {
                      if (W === 0) break e;
                      W--, P += D[U++] << T, T += 8;
                    }
                    T -= ne, c = 0, H = 3 + (7 & (P >>>= ne)), P >>>= 3, T -= 3;
                  } else {
                    for (S = ne + 7; T < S; ) {
                      if (W === 0) break e;
                      W--, P += D[U++] << T, T += 8;
                    }
                    T -= ne, c = 0, H = 11 + (127 & (P >>>= ne)), P >>>= 7, T -= 7;
                  }
                  if (d.have + H > d.nlen + d.ndist) {
                    C.msg = "invalid bit length repeat", d.mode = 30;
                    break;
                  }
                  for (; H--; ) d.lens[d.have++] = c;
                }
              }
              if (d.mode === 30) break;
              if (d.lens[256] === 0) {
                C.msg = "invalid code -- missing end-of-block", d.mode = 30;
                break;
              }
              if (d.lenbits = 9, I = { bits: d.lenbits }, M = l(g, d.lens, 0, d.nlen, d.lencode, 0, d.work, I), d.lenbits = I.bits, M) {
                C.msg = "invalid literal/lengths set", d.mode = 30;
                break;
              }
              if (d.distbits = 6, d.distcode = d.distdyn, I = { bits: d.distbits }, M = l(p, d.lens, d.nlen, d.ndist, d.distcode, 0, d.work, I), d.distbits = I.bits, M) {
                C.msg = "invalid distances set", d.mode = 30;
                break;
              }
              if (d.mode = 20, F === 6) break e;
            case 20:
              d.mode = 21;
            case 21:
              if (6 <= W && 258 <= Q) {
                C.next_out = se, C.avail_out = Q, C.next_in = U, C.avail_in = W, d.hold = P, d.bits = T, a(C, V), se = C.next_out, ee = C.output, Q = C.avail_out, U = C.next_in, D = C.input, W = C.avail_in, P = d.hold, T = d.bits, d.mode === 12 && (d.back = -1);
                break;
              }
              for (d.back = 0; ie = (w = d.lencode[P & (1 << d.lenbits) - 1]) >>> 16 & 255, ue = 65535 & w, !((ne = w >>> 24) <= T); ) {
                if (W === 0) break e;
                W--, P += D[U++] << T, T += 8;
              }
              if (ie && (240 & ie) == 0) {
                for (ce = ne, me = ie, pe = ue; ie = (w = d.lencode[pe + ((P & (1 << ce + me) - 1) >> ce)]) >>> 16 & 255, ue = 65535 & w, !(ce + (ne = w >>> 24) <= T); ) {
                  if (W === 0) break e;
                  W--, P += D[U++] << T, T += 8;
                }
                P >>>= ce, T -= ce, d.back += ce;
              }
              if (P >>>= ne, T -= ne, d.back += ne, d.length = ue, ie === 0) {
                d.mode = 26;
                break;
              }
              if (32 & ie) {
                d.back = -1, d.mode = 12;
                break;
              }
              if (64 & ie) {
                C.msg = "invalid literal/length code", d.mode = 30;
                break;
              }
              d.extra = 15 & ie, d.mode = 22;
            case 22:
              if (d.extra) {
                for (S = d.extra; T < S; ) {
                  if (W === 0) break e;
                  W--, P += D[U++] << T, T += 8;
                }
                d.length += P & (1 << d.extra) - 1, P >>>= d.extra, T -= d.extra, d.back += d.extra;
              }
              d.was = d.length, d.mode = 23;
            case 23:
              for (; ie = (w = d.distcode[P & (1 << d.distbits) - 1]) >>> 16 & 255, ue = 65535 & w, !((ne = w >>> 24) <= T); ) {
                if (W === 0) break e;
                W--, P += D[U++] << T, T += 8;
              }
              if ((240 & ie) == 0) {
                for (ce = ne, me = ie, pe = ue; ie = (w = d.distcode[pe + ((P & (1 << ce + me) - 1) >> ce)]) >>> 16 & 255, ue = 65535 & w, !(ce + (ne = w >>> 24) <= T); ) {
                  if (W === 0) break e;
                  W--, P += D[U++] << T, T += 8;
                }
                P >>>= ce, T -= ce, d.back += ce;
              }
              if (P >>>= ne, T -= ne, d.back += ne, 64 & ie) {
                C.msg = "invalid distance code", d.mode = 30;
                break;
              }
              d.offset = ue, d.extra = 15 & ie, d.mode = 24;
            case 24:
              if (d.extra) {
                for (S = d.extra; T < S; ) {
                  if (W === 0) break e;
                  W--, P += D[U++] << T, T += 8;
                }
                d.offset += P & (1 << d.extra) - 1, P >>>= d.extra, T -= d.extra, d.back += d.extra;
              }
              if (d.offset > d.dmax) {
                C.msg = "invalid distance too far back", d.mode = 30;
                break;
              }
              d.mode = 25;
            case 25:
              if (Q === 0) break e;
              if (H = V - Q, d.offset > H) {
                if ((H = d.offset - H) > d.whave && d.sane) {
                  C.msg = "invalid distance too far back", d.mode = 30;
                  break;
                }
                te = H > d.wnext ? (H -= d.wnext, d.wsize - H) : d.wnext - H, H > d.length && (H = d.length), oe = d.window;
              } else oe = ee, te = se - d.offset, H = d.length;
              for (Q < H && (H = Q), Q -= H, d.length -= H; ee[se++] = oe[te++], --H; ) ;
              d.length === 0 && (d.mode = 21);
              break;
            case 26:
              if (Q === 0) break e;
              ee[se++] = d.length, Q--, d.mode = 21;
              break;
            case 27:
              if (d.wrap) {
                for (; T < 32; ) {
                  if (W === 0) break e;
                  W--, P |= D[U++] << T, T += 8;
                }
                if (V -= Q, C.total_out += V, d.total += V, V && (C.adler = d.check = d.flags ? o(d.check, ee, V, se - V) : i(d.check, ee, V, se - V)), V = Q, (d.flags ? P : _(P)) !== d.check) {
                  C.msg = "incorrect data check", d.mode = 30;
                  break;
                }
                T = P = 0;
              }
              d.mode = 28;
            case 28:
              if (d.wrap && d.flags) {
                for (; T < 32; ) {
                  if (W === 0) break e;
                  W--, P += D[U++] << T, T += 8;
                }
                if (P !== (4294967295 & d.total)) {
                  C.msg = "incorrect length check", d.mode = 30;
                  break;
                }
                T = P = 0;
              }
              d.mode = 29;
            case 29:
              M = 1;
              break e;
            case 30:
              M = -3;
              break e;
            case 31:
              return -4;
            default:
              return u;
          }
          return C.next_out = se, C.avail_out = Q, C.next_in = U, C.avail_in = W, d.hold = P, d.bits = T, (d.wsize || V !== C.avail_out && d.mode < 30 && (d.mode < 27 || F !== 4)) && J(C, C.output, C.next_out, V - C.avail_out) ? (d.mode = 31, -4) : (X -= C.avail_in, V -= C.avail_out, C.total_in += X, C.total_out += V, d.total += V, d.wrap && V && (C.adler = d.check = d.flags ? o(d.check, ee, V, C.next_out - V) : i(d.check, ee, V, C.next_out - V)), C.data_type = d.bits + (d.last ? 64 : 0) + (d.mode === 12 ? 128 : 0) + (d.mode === 20 || d.mode === 15 ? 256 : 0), (X == 0 && V === 0 || F === 4) && M === m && (M = -5), M);
        }, s.inflateEnd = function(C) {
          if (!C || !C.state) return u;
          var F = C.state;
          return F.window && (F.window = null), C.state = null, m;
        }, s.inflateGetHeader = function(C, F) {
          var d;
          return C && C.state ? (2 & (d = C.state).wrap) == 0 ? u : ((d.head = F).done = !1, m) : u;
        }, s.inflateSetDictionary = function(C, F) {
          var d, D = F.length;
          return C && C.state ? (d = C.state).wrap !== 0 && d.mode !== 11 ? u : d.mode === 11 && i(1, F, D, 0) !== d.check ? -3 : J(C, F, D, D) ? (d.mode = 31, -4) : (d.havedict = 1, m) : u;
        }, s.inflateInfo = "pako inflate (from Nodeca project)";
      }, {
        "../utils/common": 41,
        "./adler32": 43,
        "./crc32": 45,
        "./inffast": 48,
        "./inftrees": 50
      }],
      50: [function(t, n, s) {
        "use strict";
        var r = t("../utils/common"), i = [
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          13,
          15,
          17,
          19,
          23,
          27,
          31,
          35,
          43,
          51,
          59,
          67,
          83,
          99,
          115,
          131,
          163,
          195,
          227,
          258,
          0,
          0
        ], o = [
          16,
          16,
          16,
          16,
          16,
          16,
          16,
          16,
          17,
          17,
          17,
          17,
          18,
          18,
          18,
          18,
          19,
          19,
          19,
          19,
          20,
          20,
          20,
          20,
          21,
          21,
          21,
          21,
          16,
          72,
          78
        ], a = [
          1,
          2,
          3,
          4,
          5,
          7,
          9,
          13,
          17,
          25,
          33,
          49,
          65,
          97,
          129,
          193,
          257,
          385,
          513,
          769,
          1025,
          1537,
          2049,
          3073,
          4097,
          6145,
          8193,
          12289,
          16385,
          24577,
          0,
          0
        ], l = [
          16,
          16,
          16,
          16,
          17,
          17,
          18,
          18,
          19,
          19,
          20,
          20,
          21,
          21,
          22,
          22,
          23,
          23,
          24,
          24,
          25,
          25,
          26,
          26,
          27,
          27,
          28,
          28,
          29,
          29,
          64,
          64
        ];
        n.exports = function(g, p, m, u, b, h, v, _) {
          var y, R, k, x, z, B, $, O, q, J = _.bits, C = 0, F = 0, d = 0, D = 0, ee = 0, U = 0, se = 0, W = 0, Q = 0, P = 0, T = null, X = 0, V = new r.Buf16(16), H = new r.Buf16(16), te = null, oe = 0;
          for (C = 0; C <= 15; C++) V[C] = 0;
          for (F = 0; F < u; F++) V[p[m + F]]++;
          for (ee = J, D = 15; 1 <= D && V[D] === 0; D--) ;
          if (D < ee && (ee = D), D === 0) return b[h++] = 20971520, b[h++] = 20971520, _.bits = 1, 0;
          for (d = 1; d < D && V[d] === 0; d++) ;
          for (ee < d && (ee = d), C = W = 1; C <= 15; C++) if (W <<= 1, (W -= V[C]) < 0) return -1;
          if (0 < W && (g === 0 || D !== 1)) return -1;
          for (H[1] = 0, C = 1; C < 15; C++) H[C + 1] = H[C] + V[C];
          for (F = 0; F < u; F++) p[m + F] !== 0 && (v[H[p[m + F]]++] = F);
          if (B = g === 0 ? (T = te = v, 19) : g === 1 ? (T = i, X -= 257, te = o, oe -= 257, 256) : (T = a, te = l, -1), C = d, z = h, se = F = P = 0, k = -1, x = (Q = 1 << (U = ee)) - 1, g === 1 && 852 < Q || g === 2 && 592 < Q) return 1;
          for (; ; ) {
            for ($ = C - se, q = v[F] < B ? (O = 0, v[F]) : v[F] > B ? (O = te[oe + v[F]], T[X + v[F]]) : (O = 96, 0), y = 1 << C - se, d = R = 1 << U; b[z + (P >> se) + (R -= y)] = $ << 24 | O << 16 | q | 0, R !== 0; ) ;
            for (y = 1 << C - 1; P & y; ) y >>= 1;
            if (y !== 0 ? (P &= y - 1, P += y) : P = 0, F++, --V[C] == 0) {
              if (C === D) break;
              C = p[m + v[F]];
            }
            if (ee < C && (P & x) !== k) {
              for (se === 0 && (se = ee), z += d, W = 1 << (U = C - se); U + se < D && !((W -= V[U + se]) <= 0); ) U++, W <<= 1;
              if (Q += 1 << U, g === 1 && 852 < Q || g === 2 && 592 < Q) return 1;
              b[k = P & x] = ee << 24 | U << 16 | z - h | 0;
            }
          }
          return P !== 0 && (b[z + P] = C - se << 24 | 4194304), _.bits = ee, 0;
        };
      }, { "../utils/common": 41 }],
      51: [function(t, n, s) {
        "use strict";
        n.exports = {
          2: "need dictionary",
          1: "stream end",
          0: "",
          "-1": "file error",
          "-2": "stream error",
          "-3": "data error",
          "-4": "insufficient memory",
          "-5": "buffer error",
          "-6": "incompatible version"
        };
      }, {}],
      52: [function(t, n, s) {
        "use strict";
        var r = t("../utils/common"), i = 0, o = 1;
        function a(w) {
          for (var A = w.length; 0 <= --A; ) w[A] = 0;
        }
        var l = 0, g = 29, p = 256, m = p + 1 + g, u = 30, b = 19, h = 2 * m + 1, v = 15, _ = 16, y = 7, R = 256, k = 16, x = 17, z = 18, B = [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          2,
          2,
          2,
          2,
          3,
          3,
          3,
          3,
          4,
          4,
          4,
          4,
          5,
          5,
          5,
          5,
          0
        ], $ = [
          0,
          0,
          0,
          0,
          1,
          1,
          2,
          2,
          3,
          3,
          4,
          4,
          5,
          5,
          6,
          6,
          7,
          7,
          8,
          8,
          9,
          9,
          10,
          10,
          11,
          11,
          12,
          12,
          13,
          13
        ], O = [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          2,
          3,
          7
        ], q = [
          16,
          17,
          18,
          0,
          8,
          7,
          9,
          6,
          10,
          5,
          11,
          4,
          12,
          3,
          13,
          2,
          14,
          1,
          15
        ], J = new Array(2 * (m + 2));
        a(J);
        var C = new Array(2 * u);
        a(C);
        var F = new Array(512);
        a(F);
        var d = new Array(256);
        a(d);
        var D = new Array(g);
        a(D);
        var ee, U, se, W = new Array(u);
        function Q(w, A, L, N, E) {
          this.static_tree = w, this.extra_bits = A, this.extra_base = L, this.elems = N, this.max_length = E, this.has_stree = w && w.length;
        }
        function P(w, A) {
          this.dyn_tree = w, this.max_code = 0, this.stat_desc = A;
        }
        function T(w) {
          return w < 256 ? F[w] : F[256 + (w >>> 7)];
        }
        function X(w, A) {
          w.pending_buf[w.pending++] = 255 & A, w.pending_buf[w.pending++] = A >>> 8 & 255;
        }
        function V(w, A, L) {
          w.bi_valid > _ - L ? (w.bi_buf |= A << w.bi_valid & 65535, X(w, w.bi_buf), w.bi_buf = A >> _ - w.bi_valid, w.bi_valid += L - _) : (w.bi_buf |= A << w.bi_valid & 65535, w.bi_valid += L);
        }
        function H(w, A, L) {
          V(w, L[2 * A], L[2 * A + 1]);
        }
        function te(w, A) {
          for (var L = 0; L |= 1 & w, w >>>= 1, L <<= 1, 0 < --A; ) ;
          return L >>> 1;
        }
        function oe(w, A, L) {
          var N, E, Z = new Array(v + 1), K = 0;
          for (N = 1; N <= v; N++) Z[N] = K = K + L[N - 1] << 1;
          for (E = 0; E <= A; E++) {
            var G = w[2 * E + 1];
            G !== 0 && (w[2 * E] = te(Z[G]++, G));
          }
        }
        function ne(w) {
          var A;
          for (A = 0; A < m; A++) w.dyn_ltree[2 * A] = 0;
          for (A = 0; A < u; A++) w.dyn_dtree[2 * A] = 0;
          for (A = 0; A < b; A++) w.bl_tree[2 * A] = 0;
          w.dyn_ltree[2 * R] = 1, w.opt_len = w.static_len = 0, w.last_lit = w.matches = 0;
        }
        function ie(w) {
          8 < w.bi_valid ? X(w, w.bi_buf) : 0 < w.bi_valid && (w.pending_buf[w.pending++] = w.bi_buf), w.bi_buf = 0, w.bi_valid = 0;
        }
        function ue(w, A, L, N) {
          var E = 2 * A, Z = 2 * L;
          return w[E] < w[Z] || w[E] === w[Z] && N[A] <= N[L];
        }
        function ce(w, A, L) {
          for (var N = w.heap[L], E = L << 1; E <= w.heap_len && (E < w.heap_len && ue(A, w.heap[E + 1], w.heap[E], w.depth) && E++, !ue(A, N, w.heap[E], w.depth)); ) w.heap[L] = w.heap[E], L = E, E <<= 1;
          w.heap[L] = N;
        }
        function me(w, A, L) {
          var N, E, Z, K, G = 0;
          if (w.last_lit !== 0) for (; N = w.pending_buf[w.d_buf + 2 * G] << 8 | w.pending_buf[w.d_buf + 2 * G + 1], E = w.pending_buf[w.l_buf + G], G++, N === 0 ? H(w, E, A) : (H(w, (Z = d[E]) + p + 1, A), (K = B[Z]) !== 0 && V(w, E -= D[Z], K), H(w, Z = T(--N), L), (K = $[Z]) !== 0 && V(w, N -= W[Z], K)), G < w.last_lit; ) ;
          H(w, R, A);
        }
        function pe(w, A) {
          var L, N, E, Z = A.dyn_tree, K = A.stat_desc.static_tree, G = A.stat_desc.has_stree, Y = A.stat_desc.elems, ae = -1;
          for (w.heap_len = 0, w.heap_max = h, L = 0; L < Y; L++) Z[2 * L] !== 0 ? (w.heap[++w.heap_len] = ae = L, w.depth[L] = 0) : Z[2 * L + 1] = 0;
          for (; w.heap_len < 2; ) Z[2 * (E = w.heap[++w.heap_len] = ae < 2 ? ++ae : 0)] = 1, w.depth[E] = 0, w.opt_len--, G && (w.static_len -= K[2 * E + 1]);
          for (A.max_code = ae, L = w.heap_len >> 1; 1 <= L; L--) ce(w, Z, L);
          for (E = Y; L = w.heap[1], w.heap[1] = w.heap[w.heap_len--], ce(w, Z, 1), N = w.heap[1], w.heap[--w.heap_max] = L, w.heap[--w.heap_max] = N, Z[2 * E] = Z[2 * L] + Z[2 * N], w.depth[E] = (w.depth[L] >= w.depth[N] ? w.depth[L] : w.depth[N]) + 1, Z[2 * L + 1] = Z[2 * N + 1] = E, w.heap[1] = E++, ce(w, Z, 1), 2 <= w.heap_len; ) ;
          w.heap[--w.heap_max] = w.heap[1], (function(re, de) {
            var ke, ge, Re, le, Fe, Le, be = de.dyn_tree, Je = de.max_code, Ht = de.stat_desc.static_tree, Zt = de.stat_desc.has_stree, Gt = de.stat_desc.extra_bits, Qe = de.stat_desc.extra_base, Ce = de.stat_desc.max_length, Pe = 0;
            for (le = 0; le <= v; le++) re.bl_count[le] = 0;
            for (be[2 * re.heap[re.heap_max] + 1] = 0, ke = re.heap_max + 1; ke < h; ke++) Ce < (le = be[2 * be[2 * (ge = re.heap[ke]) + 1] + 1] + 1) && (le = Ce, Pe++), be[2 * ge + 1] = le, Je < ge || (re.bl_count[le]++, Fe = 0, Qe <= ge && (Fe = Gt[ge - Qe]), Le = be[2 * ge], re.opt_len += Le * (le + Fe), Zt && (re.static_len += Le * (Ht[2 * ge + 1] + Fe)));
            if (Pe !== 0) {
              do {
                for (le = Ce - 1; re.bl_count[le] === 0; ) le--;
                re.bl_count[le]--, re.bl_count[le + 1] += 2, re.bl_count[Ce]--, Pe -= 2;
              } while (0 < Pe);
              for (le = Ce; le !== 0; le--) for (ge = re.bl_count[le]; ge !== 0; ) Je < (Re = re.heap[--ke]) || (be[2 * Re + 1] !== le && (re.opt_len += (le - be[2 * Re + 1]) * be[2 * Re], be[2 * Re + 1] = le), ge--);
            }
          })(w, A), oe(Z, ae, w.bl_count);
        }
        function c(w, A, L) {
          var N, E, Z = -1, K = A[1], G = 0, Y = 7, ae = 4;
          for (K === 0 && (Y = 138, ae = 3), A[2 * (L + 1) + 1] = 65535, N = 0; N <= L; N++) E = K, K = A[2 * (N + 1) + 1], ++G < Y && E === K || (G < ae ? w.bl_tree[2 * E] += G : E !== 0 ? (E !== Z && w.bl_tree[2 * E]++, w.bl_tree[2 * k]++) : G <= 10 ? w.bl_tree[2 * x]++ : w.bl_tree[2 * z]++, Z = E, ae = (G = 0) === K ? (Y = 138, 3) : E === K ? (Y = 6, 3) : (Y = 7, 4));
        }
        function M(w, A, L) {
          var N, E, Z = -1, K = A[1], G = 0, Y = 7, ae = 4;
          for (K === 0 && (Y = 138, ae = 3), N = 0; N <= L; N++) if (E = K, K = A[2 * (N + 1) + 1], !(++G < Y && E === K)) {
            if (G < ae) for (; H(w, E, w.bl_tree), --G != 0; ) ;
            else E !== 0 ? (E !== Z && (H(w, E, w.bl_tree), G--), H(w, k, w.bl_tree), V(w, G - 3, 2)) : G <= 10 ? (H(w, x, w.bl_tree), V(w, G - 3, 3)) : (H(w, z, w.bl_tree), V(w, G - 11, 7));
            Z = E, ae = (G = 0) === K ? (Y = 138, 3) : E === K ? (Y = 6, 3) : (Y = 7, 4);
          }
        }
        a(W);
        var I = !1;
        function S(w, A, L, N) {
          V(w, (l << 1) + (N ? 1 : 0), 3), (function(E, Z, K, G) {
            ie(E), G && (X(E, K), X(E, ~K)), r.arraySet(E.pending_buf, E.window, Z, K, E.pending), E.pending += K;
          })(w, A, L, !0);
        }
        s._tr_init = function(w) {
          I || ((function() {
            var A, L, N, E, Z, K = new Array(v + 1);
            for (E = N = 0; E < g - 1; E++) for (D[E] = N, A = 0; A < 1 << B[E]; A++) d[N++] = E;
            for (d[N - 1] = E, E = Z = 0; E < 16; E++) for (W[E] = Z, A = 0; A < 1 << $[E]; A++) F[Z++] = E;
            for (Z >>= 7; E < u; E++) for (W[E] = Z << 7, A = 0; A < 1 << $[E] - 7; A++) F[256 + Z++] = E;
            for (L = 0; L <= v; L++) K[L] = 0;
            for (A = 0; A <= 143; ) J[2 * A + 1] = 8, A++, K[8]++;
            for (; A <= 255; ) J[2 * A + 1] = 9, A++, K[9]++;
            for (; A <= 279; ) J[2 * A + 1] = 7, A++, K[7]++;
            for (; A <= 287; ) J[2 * A + 1] = 8, A++, K[8]++;
            for (oe(J, m + 1, K), A = 0; A < u; A++) C[2 * A + 1] = 5, C[2 * A] = te(A, 5);
            ee = new Q(J, B, p + 1, m, v), U = new Q(C, $, 0, u, v), se = new Q(new Array(0), O, 0, b, y);
          })(), I = !0), w.l_desc = new P(w.dyn_ltree, ee), w.d_desc = new P(w.dyn_dtree, U), w.bl_desc = new P(w.bl_tree, se), w.bi_buf = 0, w.bi_valid = 0, ne(w);
        }, s._tr_stored_block = S, s._tr_flush_block = function(w, A, L, N) {
          var E, Z, K = 0;
          0 < w.level ? (w.strm.data_type === 2 && (w.strm.data_type = (function(G) {
            var Y, ae = 4093624447;
            for (Y = 0; Y <= 31; Y++, ae >>>= 1) if (1 & ae && G.dyn_ltree[2 * Y] !== 0) return i;
            if (G.dyn_ltree[18] !== 0 || G.dyn_ltree[20] !== 0 || G.dyn_ltree[26] !== 0) return o;
            for (Y = 32; Y < p; Y++) if (G.dyn_ltree[2 * Y] !== 0) return o;
            return i;
          })(w)), pe(w, w.l_desc), pe(w, w.d_desc), K = (function(G) {
            var Y;
            for (c(G, G.dyn_ltree, G.l_desc.max_code), c(G, G.dyn_dtree, G.d_desc.max_code), pe(G, G.bl_desc), Y = b - 1; 3 <= Y && G.bl_tree[2 * q[Y] + 1] === 0; Y--) ;
            return G.opt_len += 3 * (Y + 1) + 5 + 5 + 4, Y;
          })(w), E = w.opt_len + 3 + 7 >>> 3, (Z = w.static_len + 3 + 7 >>> 3) <= E && (E = Z)) : E = Z = L + 5, L + 4 <= E && A !== -1 ? S(w, A, L, N) : w.strategy === 4 || Z === E ? (V(w, 2 + (N ? 1 : 0), 3), me(w, J, C)) : (V(w, 4 + (N ? 1 : 0), 3), (function(G, Y, ae, re) {
            var de;
            for (V(G, Y - 257, 5), V(G, ae - 1, 5), V(G, re - 4, 4), de = 0; de < re; de++) V(G, G.bl_tree[2 * q[de] + 1], 3);
            M(G, G.dyn_ltree, Y - 1), M(G, G.dyn_dtree, ae - 1);
          })(w, w.l_desc.max_code + 1, w.d_desc.max_code + 1, K + 1), me(w, w.dyn_ltree, w.dyn_dtree)), ne(w), N && ie(w);
        }, s._tr_tally = function(w, A, L) {
          return w.pending_buf[w.d_buf + 2 * w.last_lit] = A >>> 8 & 255, w.pending_buf[w.d_buf + 2 * w.last_lit + 1] = 255 & A, w.pending_buf[w.l_buf + w.last_lit] = 255 & L, w.last_lit++, A === 0 ? w.dyn_ltree[2 * L]++ : (w.matches++, A--, w.dyn_ltree[2 * (d[L] + p + 1)]++, w.dyn_dtree[2 * T(A)]++), w.last_lit === w.lit_bufsize - 1;
        }, s._tr_align = function(w) {
          V(w, 2, 3), H(w, R, J), (function(A) {
            A.bi_valid === 16 ? (X(A, A.bi_buf), A.bi_buf = 0, A.bi_valid = 0) : 8 <= A.bi_valid && (A.pending_buf[A.pending++] = 255 & A.bi_buf, A.bi_buf >>= 8, A.bi_valid -= 8);
          })(w);
        };
      }, { "../utils/common": 41 }],
      53: [function(t, n, s) {
        "use strict";
        n.exports = function() {
          this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
        };
      }, {}],
      54: [function(t, n, s) {
        (function(r) {
          (function(i, o) {
            "use strict";
            if (!i.setImmediate) {
              var a, l, g, p, m = 1, u = {}, b = !1, h = i.document, v = Object.getPrototypeOf && Object.getPrototypeOf(i);
              v = v && v.setTimeout ? v : i, a = {}.toString.call(i.process) === "[object process]" ? function(k) {
                process.nextTick(function() {
                  y(k);
                });
              } : (function() {
                if (i.postMessage && !i.importScripts) {
                  var k = !0, x = i.onmessage;
                  return i.onmessage = function() {
                    k = !1;
                  }, i.postMessage("", "*"), i.onmessage = x, k;
                }
              })() ? (p = "setImmediate$" + Math.random() + "$", i.addEventListener ? i.addEventListener("message", R, !1) : i.attachEvent("onmessage", R), function(k) {
                i.postMessage(p + k, "*");
              }) : i.MessageChannel ? ((g = new MessageChannel()).port1.onmessage = function(k) {
                y(k.data);
              }, function(k) {
                g.port2.postMessage(k);
              }) : h && "onreadystatechange" in h.createElement("script") ? (l = h.documentElement, function(k) {
                var x = h.createElement("script");
                x.onreadystatechange = function() {
                  y(k), x.onreadystatechange = null, l.removeChild(x), x = null;
                }, l.appendChild(x);
              }) : function(k) {
                setTimeout(y, 0, k);
              }, v.setImmediate = function(k) {
                typeof k != "function" && (k = new Function("" + k));
                for (var x = new Array(arguments.length - 1), z = 0; z < x.length; z++) x[z] = arguments[z + 1];
                return u[m] = {
                  callback: k,
                  args: x
                }, a(m), m++;
              }, v.clearImmediate = _;
            }
            function _(k) {
              delete u[k];
            }
            function y(k) {
              if (b) setTimeout(y, 0, k);
              else {
                var x = u[k];
                if (x) {
                  b = !0;
                  try {
                    (function(z) {
                      var B = z.callback, $ = z.args;
                      switch ($.length) {
                        case 0:
                          B();
                          break;
                        case 1:
                          B($[0]);
                          break;
                        case 2:
                          B($[0], $[1]);
                          break;
                        case 3:
                          B($[0], $[1], $[2]);
                          break;
                        default:
                          B.apply(o, $);
                      }
                    })(x);
                  } finally {
                    _(k), b = !1;
                  }
                }
              }
            }
            function R(k) {
              k.source === i && typeof k.data == "string" && k.data.indexOf(p) === 0 && y(+k.data.slice(p.length));
            }
          })(typeof self > "u" ? r === void 0 ? this : r : self);
        }).call(this, typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, {}]
    }, {}, [10])(10);
  });
})), Te = /* @__PURE__ */ Vt(xs(), 1), _t = 1e4, As = class {
  waiting = /* @__PURE__ */ new Set();
  beat() {
    for (const f of [...this.waiting]) f();
  }
  listen(f) {
    return this.waiting.add(f), () => {
      this.waiting.delete(f);
    };
  }
}, Es = "An asset";
function Os(f, e, t, n) {
  return new Promise((s, r) => {
    let i = !1, o = 0, a, l = null;
    const g = () => o === 0 || a !== void 0 && o < a;
    let p = n?.listen(() => {
      o === 0 && l !== null && b();
    });
    const m = () => {
      if (i) return;
      i = !0, l = null, p?.();
      const y = _t / 1e3;
      let R;
      try {
        R = e();
      } catch {
        R = Es;
      }
      const k = o > 0 ? `${R} stopped arriving after ${bt(o)}${a !== void 0 ? ` of ${bt(a)}` : ""}, nothing for ${y}s — treating as failed.` : `${R} sent nothing in ${y}s — treating as failed.`;
      j.warn(`[DownloadStall] ${k}`), r(new Error(k));
    }, u = () => {
      l !== null && clearTimeout(l), l = null;
    }, b = () => {
      u(), l = setTimeout(m, _t);
    };
    b();
    const h = (y, R) => {
      if (i) return;
      const k = y !== void 0 && y > o, x = R !== void 0 && R > (a ?? 0);
      if (k && (o = y, p?.(), p = void 0, n?.beat()), R !== void 0 && R > 0 && (a = R), !g()) {
        u();
        return;
      }
      y !== void 0 && !k && !x || b();
    }, v = (y) => {
      i || (i = !0, u(), p?.(), r(y));
    };
    let _;
    try {
      _ = f(h);
    } catch (y) {
      v(y);
      return;
    }
    _.then((y) => {
      if (i) {
        t?.(y);
        return;
      }
      i = !0, u(), p?.(), s(y);
    }, v);
  });
}
function bt(f) {
  return f >= 1e5 ? `${(f / 1e6).toFixed(1)} MB` : `${Math.round(f / 1e3)} KB`;
}
function Ve(f) {
  return typeof f == "string" && (f.startsWith("./assets/") || f.startsWith("assets/"));
}
function hr(f) {
  return typeof f == "string" && f.startsWith("/") && !f.startsWith("//");
}
var ur = [
  "bakedFrom",
  "meshPath",
  "videoPath",
  "imagePath",
  "texturePath",
  "modelPath",
  "audioPath",
  "src"
], dr = [
  {
    parent: "texture",
    key: "path"
  },
  {
    parent: "texture",
    key: "src"
  },
  {
    parent: "material",
    key: "texturePath"
  }
];
function Ts(f, e) {
  return f["@type"] === "Provenance" && (e === "decisions" || e === "assets");
}
function $e(f) {
  return f ? { onProgress: (e) => f(e.loaded, e.lengthComputable ? e.total : void 0) } : {};
}
ms.DefaultRetryStrategy = bs.ExponentialBackoff(0, 0);
function ze(f, e) {
  if (!f) return f;
  const t = f.startsWith("./"), n = t ? f.slice(2) : f, s = e.get(n);
  return s ? t ? `./${s}` : s : f;
}
function Bt(f, e) {
  if (e.size === 0) return;
  const t = (n) => {
    if (Array.isArray(n)) for (let s = 0; s < n.length; s++) {
      const r = n[s];
      Ve(r) ? n[s] = ze(r, e) : t(r);
    }
    else if (n && typeof n == "object") {
      const s = n;
      for (const r of Object.keys(s)) {
        if (Ts(s, r)) continue;
        const i = s[r];
        Ve(i) ? s[r] = ze(i, e) : t(i);
      }
    }
  };
  t(f);
}
async function Fs(f, e, t) {
  const n = new Set(t.values()), s = /* @__PURE__ */ new Set();
  for (const r of f) for (const i of r.behaviors ?? []) {
    const { "@type": o, sheets: a } = i;
    if (!(o !== "Properties" || !Array.isArray(a)))
      for (const l of a) {
        const g = Ve(l) ? l.replace(/^\.\//, "") : void 0;
        g && n.has(g) && s.add(g);
      }
  }
  for (const r of s) {
    const i = e.getAsset(r);
    if (!i) continue;
    let o;
    try {
      o = JSON.parse(await i.text());
    } catch {
      j.warn(`[ResourceManager] Sheet ${r} is not JSON; the asset paths inside it were not remapped`);
      continue;
    }
    const a = JSON.stringify(o);
    Bt(o, t);
    const l = JSON.stringify(o);
    l !== a && e.addAsset(r, new Blob([l], { type: i.type }));
  }
}
var It = "|", Ps = It + "allMaterials", Bs = class Ke {
  assets;
  json;
  info;
  blobHashes = /* @__PURE__ */ new WeakMap();
  dedupBlobs = /* @__PURE__ */ new WeakSet();
  containerCache = /* @__PURE__ */ new Map();
  downloads = new As();
  containerRefCount = /* @__PURE__ */ new Map();
  settledContainers = /* @__PURE__ */ new WeakMap();
  _orphaned = [];
  urlToAssetKey = /* @__PURE__ */ new Map();
  usedSceneFolders = /* @__PURE__ */ new Set();
  sourceToSceneFolder = /* @__PURE__ */ new Map();
  assetBaseUrls = /* @__PURE__ */ new Map();
  assetUrls = /* @__PURE__ */ new Map();
  assetSourceUrls = /* @__PURE__ */ new Map();
  assetNames = /* @__PURE__ */ new Map();
  storedFolderFiles = /* @__PURE__ */ new Map();
  constructor() {
    this.assets = /* @__PURE__ */ new Map();
  }
  computeBlobHash(e) {
    let t = this.blobHashes.get(e);
    return t || (t = e.arrayBuffer().then((n) => crypto.subtle.digest("SHA-256", n)).then((n) => Array.from(new Uint8Array(n), (s) => s.toString(16).padStart(2, "0")).join("")), t.catch(() => this.blobHashes.delete(e)), this.blobHashes.set(e, t)), t;
  }
  async addAssetWithDedup(e, t) {
    for (const [o, a] of this.assets)
      if (!(a.size !== t.size || o !== e && !this.dedupBlobs.has(a)) && (a === t || await this.computeBlobHash(a) === await this.computeBlobHash(t)) && this.assets.get(o) === a)
        return j.debug(`[ResourceManager] Deduplicated asset: ${e} -> ${o}`), o;
    const n = e.lastIndexOf("."), [s, r] = n > e.lastIndexOf("/") ? [e.slice(0, n), e.slice(n)] : [e, ""];
    let i = e;
    for (let o = 2; this.assets.has(i) || this.assetUrls.has(i.replace("./", "")); o++) i = `${s}-${o}${r}`;
    return this.assets.set(i, t), this.dedupBlobs.add(t), j.debug(`[ResourceManager] Added new asset: ${i} (${t.size} bytes)`), i;
  }
  setJson(e, t) {
    this.json = e, t && (this.info = t);
  }
  addAsset(e, t) {
    this._evictIfReplaced(e, t), this.assets.set(e, t);
  }
  _evictIfReplaced(e, t) {
    const n = this.assets.get(e);
    if (!(!n || n === t))
      for (const s of this._containerKeyVariants(e)) {
        const r = this.containerCache.get(s), i = (this.containerRefCount.get(s) ?? 0) > 0;
        this.containerCache.delete(s), this.containerRefCount.delete(s), i ? this._orphaned.push(r) : r.then((o) => o.dispose()).catch(() => {
        });
      }
  }
  _containerKeyVariants(e) {
    const t = this.containerKey(e), n = t + It;
    return [...this.containerCache.keys()].filter((s) => s === t || s.startsWith(n));
  }
  _evictContainer(e) {
    for (const t of this._containerKeyVariants(e)) {
      const n = this.containerCache.get(t);
      this.containerRefCount.delete(t), this.containerCache.delete(t), n.then((s) => s.dispose()).catch(() => {
      });
    }
  }
  mergeSceneAssets(e, t, n) {
    const s = n ? this.sourceToSceneFolder.get(n) : void 0, r = s ?? this.allocateSceneFolder(t);
    n && !s && this.sourceToSceneFolder.set(n, r);
    const i = /* @__PURE__ */ new Map();
    for (const [o, a] of e) {
      const l = `assets/${r}/${o.replace(/^assets\//, "")}`;
      s || this.assets.set(l, a);
      const g = this.assetNames.get(o.replace("./", ""));
      g && this.assetNames.set(l, g), i.set(o, l);
    }
    return j.log(`[ResourceManager] ${s ? "Reused" : "Merged"} ${e.size} subasset(s) under assets/${r}/`), i;
  }
  allocateSceneFolder(e) {
    const t = e.replace(/\.[^/.]+$/, "").replace(/[^A-Za-z0-9._-]+/g, "_"), n = t.length > 0 ? t : "scene";
    let s = n, r = 2;
    for (; this.usedSceneFolders.has(s) || this.assetSubfolderExists(s); ) s = `${n}-${r++}`;
    return this.usedSceneFolders.add(s), s;
  }
  assetSubfolderExists(e) {
    const t = `assets/${e}/`;
    for (const n of this.assets.keys()) if (n.startsWith(t)) return !0;
    return !1;
  }
  registerUrlMapping(e, t) {
    this.urlToAssetKey.set(e, t);
  }
  resolveUrlToAssetKey(e) {
    return this.urlToAssetKey.get(e);
  }
  registerAssetUrl(e, t) {
    !e || !t || this.assetUrls.set(e.replace("./", ""), t);
  }
  resolveAssetUrl(e) {
    if (!(!e || !this.isLocal(e)))
      return this.assetUrls.get(e.replace("./", ""));
  }
  registerAssetSourceUrl(e, t) {
    !e || !t || this.assetSourceUrls.set(e.replace("./", ""), t);
  }
  getAssetSourceUrl(e) {
    if (e)
      return this.assetSourceUrls.get(e.replace("./", ""));
  }
  async recordStoredFiles(e, t) {
    const n = await Promise.all([...t].map(async ([r, i]) => [
      r,
      i.uri,
      await vt(i.blob)
    ]));
    let s = this.storedFolderFiles.get(e);
    s || (s = /* @__PURE__ */ new Map(), this.storedFolderFiles.set(e, s));
    for (const [r, i, o] of n)
      o === void 0 ? s.delete(r) : s.set(r, {
        uri: i,
        sha256: o
      }), this.registerAssetUrl(i, new URL(i, e).href);
  }
  forgetStoredFiles(e) {
    for (const t of e === void 0 ? [...this.storedFolderFiles.keys()] : [e]) {
      for (const { uri: n } of this.storedFolderFiles.get(t)?.values() ?? []) this.assetUrls.get(n) === new URL(n, t).href && this.assetUrls.delete(n);
      this.storedFolderFiles.delete(t);
    }
  }
  hasStoredFiles(e) {
    return (this.storedFolderFiles.get(e)?.size ?? 0) > 0;
  }
  async storedFileFor(e, t, n) {
    const s = this.storedFolderFiles.get(e)?.get(t);
    if (s)
      return await vt(n) === s.sha256 ? s.uri : void 0;
  }
  storedUriIn(e, t) {
    return this.storedFolderFiles.get(e)?.get(t)?.uri;
  }
  registerAssetName(e, t) {
    !e || !t || this.assetNames.set(e.replace("./", ""), t);
  }
  getAssetName(e) {
    if (e)
      return this.assetNames.get(e.replace("./", ""));
  }
  registerAssetBaseUrl(e, t) {
    t && this.assetBaseUrls.set(e.replace("./", ""), t);
  }
  getAssetBaseUrl(e) {
    const t = this.urlToAssetKey.get(e) ?? e.replace("./", "");
    return this.assetBaseUrls.get(t);
  }
  static canonicalRelPath(e) {
    let t = e;
    try {
      t = decodeURIComponent(e);
    } catch {
    }
    const n = [];
    for (const s of t.replace(/\\/g, "/").split("/"))
      if (!(s === "" || s === ".")) {
        if (s === ".." && n.length > 0 && n[n.length - 1] !== "..") {
          n.pop();
          continue;
        }
        n.push(s);
      }
    return n.join("/");
  }
  registerSiblingAssets(e) {
    for (const [t, n] of e) {
      const s = Ke.canonicalRelPath(t), r = s.startsWith("assets/") ? s : `assets/${s}`, i = this.assets.get(r);
      i && i !== n && j.warn(`[ResourceManager] Sibling asset overwrites an existing blob: ${r} — a previously imported asset referencing it will resolve to the new content`), this.assets.set(r, n), this.urlToAssetKey.set(s, r);
    }
    e.size > 0 && j.log(`[ResourceManager] Registered ${e.size} sibling asset(s)`);
  }
  resolveExternalAssetBlob(e) {
    const t = Ke.canonicalRelPath(e), n = this.getAsset(`assets/${t}`) ?? this.getAsset(t);
    if (n) return n;
    const s = t.split("/").pop();
    if (!s || s === t) return;
    const r = this.getAsset(`assets/${s}`) ?? this.getAsset(s);
    if (r) {
      const i = `/${s}`;
      let o = 0;
      for (const a of this.assets.keys()) a.endsWith(i) && o++;
      o > 1 && j.warn(`[ResourceManager] Ambiguous basename fallback for "${t}": ${o} registered assets end in "${s}" — resolved to an arbitrary one`);
    }
    return r;
  }
  createGltfExternalRefResolver(e, t) {
    const n = this.urlToAssetKey.get(e) ?? e.replace("./", ""), s = this.assetBaseUrls.get(n), r = t.substring(0, t.lastIndexOf("/") + 1), i = [];
    return {
      preprocessUrlAsync: async (l) => {
        if (l === t || l.startsWith("data:") || !l.startsWith(r)) return l;
        const g = l.substring(r.length), p = this.resolveExternalAssetBlob(g);
        if (p) {
          const m = URL.createObjectURL(p);
          return i.push(m), m;
        }
        return s ? s + g : (j.warn(`[ResourceManager] Unresolved external reference: ${g} (from ${n})`), l);
      },
      dispose: () => {
        for (const l of i) URL.revokeObjectURL(l);
        i.length = 0;
      }
    };
  }
  static removeAssetsPrefix(e) {
    for (const t of ["./assets/", "assets/"]) if (e.startsWith(t)) return e.slice(t.length);
    return e;
  }
  async createTraceBlob(e) {
    if (!this.json) throw new Error("Missing json");
    const { createZipBlob: t, deflateLevelForPath: n } = await import("./zipWriter-BfmByHdK.js").then((o) => o.i);
    j.log("Adding assets to zip file:", this.assets.size);
    const s = await Promise.all([...this.assets].map(async ([o, a]) => ({
      path: `assets/${o}`,
      data: new Uint8Array(await a.arrayBuffer()),
      level: n(o)
    })));
    this.info ? (s.push({
      path: "models.json",
      data: Ue(JSON.stringify(this.json, null, 2)),
      level: 6
    }), s.push({
      path: "info.json",
      data: Ue(JSON.stringify(this.info, null, 2)),
      level: 6
    })) : s.push({
      path: "scene.json",
      data: Ue(JSON.stringify(this.json, null, 2)),
      level: 6
    });
    const r = await t(s, e), i = s.reduce((o, a) => o + a.data.length, 0);
    return j.log(`[ResourceManager] Archive: ${s.length} entries, ${i} bytes raw → ${r.size} bytes packed (${i > 0 ? Math.round(r.size / i * 100) : 100}%)`), r;
  }
  async loadAssetsFromZip(e) {
    try {
      const t = await Te.default.loadAsync(e), n = [];
      t.forEach((s, r) => {
        s.toLowerCase().startsWith("assets/") && n.push(r.async("blob").then((i) => {
          const o = s.replace(/^Assets\//i, "assets/");
          this.assets.set(o, i);
        }));
      }), await Promise.all(n), j.log("All assets loaded successfully");
    } catch (t) {
      j.error("Error loading assets from zip:", t);
    }
  }
  isLocal(e) {
    return e.startsWith("/") ? !1 : !e.startsWith("http");
  }
  getAsset(e) {
    const t = this.assets.get(e.replace("./", ""));
    if (t) return t;
    const n = this.urlToAssetKey.get(e);
    return n ? this.assets.get(n) : void 0;
  }
  createAssetURL(e) {
    const t = this.getAsset(e);
    return t ? URL.createObjectURL(t) : (j.error(`Asset not found for path: ${e}`), null);
  }
  containerKey(e) {
    const t = e.replace("./", "");
    return this.isLocal(t) ? this.urlToAssetKey.get(t) ?? t : t;
  }
  containerCacheKey(e, t) {
    return t?.allMaterials ? e + Ps : e;
  }
  getOrLoadContainer(e, t, n, s) {
    const r = this.containerKey(e), i = this.containerCacheKey(r, s), o = this.containerCache.get(i);
    if (o)
      return this.containerRefCount.set(i, (this.containerRefCount.get(i) || 0) + 1), j.debug(`[ResourceManager] Container cache hit: ${i}`), o;
    const a = Os((l) => this._loadContainer(r, e, t, n, s, l), () => `[ResourceManager] Container "${e}"`, (l) => l.dispose(), this.downloads);
    return this.containerCache.set(i, a), this.containerRefCount.set(i, 1), a.then((l) => this.settledContainers.set(a, l), () => {
    }), a.catch(() => {
      this.containerCache.get(i) === a && (this.containerCache.delete(i), this.containerRefCount.delete(i), j.debug(`[ResourceManager] Evicted failed container load: ${i}`));
    }), a;
  }
  peekLoadedContainer(e, t) {
    const n = this.containerCache.get(this.containerCacheKey(this.containerKey(e), t));
    return n ? this.settledContainers.get(n) : void 0;
  }
  async _loadContainer(e, t, n, s, r, i) {
    const o = s ?? `.${he.getFileExtensionFromSrc(e) || "glb"}`, a = this._gltfPluginOptions(r);
    if (!this.isLocal(t)) {
      const p = this.getAsset(t);
      if (p) {
        const u = await this._loadContainerFromBlob(p, t, o, n, a, i);
        return j.debug(`[ResourceManager] Loaded container from cache for URL: ${t}`), u;
      }
      const m = await je(t, n, {
        pluginExtension: o,
        ...a ? { pluginOptions: { gltf: a } } : {},
        ...$e(i)
      });
      return j.debug(`[ResourceManager] Loaded remote container: ${e}`), m;
    }
    const l = this.getAsset(e);
    if (!l) {
      const p = this.resolveAssetUrl(t) ?? this.resolveAssetUrl(e);
      if (p) {
        const m = await je(p, n, {
          pluginExtension: o,
          ...a ? { pluginOptions: { gltf: a } } : {},
          ...$e(i)
        });
        return j.debug(`[ResourceManager] Loaded folder container: ${e} → ${p}`), m;
      }
      throw new Error(`[ResourceManager] Asset not found: ${e}`);
    }
    const g = await this._loadContainerFromBlob(l, e, o, n, a, i);
    return j.debug(`[ResourceManager] Loaded container: ${e}`), g;
  }
  _gltfPluginOptions(e) {
    return {
      animationStartMode: _s.NONE,
      ...e?.allMaterials ? { loadAllMaterials: !0 } : {}
    };
  }
  async _loadContainerFromBlob(e, t, n, s, r, i) {
    const o = URL.createObjectURL(e), a = n === ".gltf" || n === ".glb" ? this.createGltfExternalRefResolver(t, o) : void 0, l = a || r ? {
      ...r,
      ...a ? { preprocessUrlAsync: a.preprocessUrlAsync } : {}
    } : void 0;
    try {
      return await je(o, s, {
        pluginExtension: n,
        ...l ? { pluginOptions: { gltf: l } } : {},
        ...$e(i)
      });
    } finally {
      URL.revokeObjectURL(o), a?.dispose();
    }
  }
  releaseContainer(e, t) {
    const n = this.containerCacheKey(this.containerKey(e), t), s = this.containerRefCount.get(n);
    if (s !== void 0)
      if (s <= 1) {
        this.containerRefCount.delete(n);
        const r = this.containerCache.get(n);
        this.containerCache.delete(n), r?.then((i) => i.dispose()).catch(() => {
        }), j.debug(`[ResourceManager] Disposed container: ${n}`);
      } else this.containerRefCount.set(n, s - 1);
  }
  getAssetEntries() {
    return [...this.assets.entries()];
  }
  get assetCount() {
    return this.assets.size;
  }
  removeAsset(e) {
    if (!this.assets.get(e)) return !1;
    this.assets.delete(e), this.assetBaseUrls.delete(e.replace("./", "")), this.assetUrls.delete(e.replace("./", "")), this.assetSourceUrls.delete(e.replace("./", "")), this.assetNames.delete(e.replace("./", ""));
    for (const [t, n] of this.urlToAssetKey) if (n === e) {
      this.urlToAssetKey.delete(t);
      break;
    }
    return this._evictContainer(e), j.debug(`[ResourceManager] Removed asset: ${e}`), !0;
  }
  clearAssets() {
    this.assets.clear(), this.sourceToSceneFolder.clear(), this.urlToAssetKey.clear(), this.usedSceneFolders.clear(), this.assetBaseUrls.clear(), this.assetUrls.clear(), this.assetSourceUrls.clear(), this.assetNames.clear();
    for (const e of [...this.containerCache.values(), ...this._orphaned]) e.then((t) => t.dispose()).catch(() => {
    });
    this.containerCache.clear(), this.containerRefCount.clear(), this._orphaned.length = 0, j.log("All assets cleared");
  }
};
async function vt(f) {
  if (!globalThis.crypto?.subtle) return;
  const e = await crypto.subtle.digest("SHA-256", await f.arrayBuffer());
  return Array.from(new Uint8Array(e), (t) => t.toString(16).padStart(2, "0")).join("");
}
var ye = 1e-5, yt = 0, wt = 1;
function Is(f) {
  return f.some((e) => (e.behaviors ?? []).some(Js));
}
function zs(f) {
  if (!Is(f)) return;
  const e = new Ds(f);
  js(f, e, Ms(f, e));
}
var Ds = class {
  _byPath = /* @__PURE__ */ new Map();
  _byName = /* @__PURE__ */ new Map();
  _byTransform = /* @__PURE__ */ new Map();
  constructor(f) {
    this._nodes = f;
    for (const e of f) {
      this._byPath.set(this.pathOf(e), e);
      const t = this._byName.get(e.name);
      t ? t.push(e) : this._byName.set(e.name, [e]), this._byTransform.set(e.transform, e);
    }
  }
  pathOf(f) {
    const e = [];
    let t = f.transform;
    for (; t; )
      e.unshift(t.name), t = t.parent;
    return e.join("/");
  }
  resolve(f) {
    if (!f) return;
    const e = this._byPath.get(f);
    if (e) return e;
    const t = f.split("/").filter(Boolean).pop(), n = t ? this._byName.get(t) : void 0;
    return n?.length === 1 ? n[0] : void 0;
  }
  nodeFor(f) {
    return f ? this._byTransform.get(f) : void 0;
  }
  ancestorWhere(f, e) {
    let t = f;
    for (; t; ) {
      if (e(t)) return t;
      t = this.nodeFor(t.transform.parent);
    }
  }
  requiredLocalPosition(f, e) {
    return this.positionIn(f, this.nodeFor(e.transform.parent));
  }
  positionIn(f, e) {
    const t = this.worldPositionOf(f);
    return e ? (this.refresh(e.transform), _e.TransformCoordinates(t, Ze.Invert(e.transform.getWorldMatrix()))) : t;
  }
  worldPositionOf(f) {
    return this.refresh(f.transform), f.transform.getAbsolutePosition().clone();
  }
  refresh(f) {
    const e = [];
    let t = f;
    for (; t; )
      e.unshift(t), t = t.parent;
    for (const n of e) n.computeWorldMatrix(!0);
  }
};
function Ms(f, e) {
  const t = [];
  for (const n of f) {
    const s = (n.behaviors ?? []).find((o) => o["@type"] === "Properties" && Array.isArray(o.props));
    if (!s) continue;
    const r = [...s.properties ?? []], i = new Set(r.map((o) => o.name));
    for (const o of s.props ?? []) {
      const a = Ls(o.property);
      if (!a) {
        o.property?.startsWith("Cycler.") || j.warn(`[LegacyConstraints] "${o.label ?? o.property}" addresses ${o.property} — no equivalent control, dropped`);
        continue;
      }
      const l = e.resolve(o.obj);
      if (!l) {
        j.warn(`[LegacyConstraints] "${o.label ?? o.property}" targets ${o.obj}, which is not in the scene — dropped`);
        continue;
      }
      const g = zt(o.label ?? o.property ?? "property", i);
      i.add(g);
      const p = Lt(l.transform, a);
      r.push(Ns(g, o.label, p, a)), Ks(l, a, `{${g}}`);
      const m = {
        ...a,
        property: g,
        node: l,
        owner: n
      };
      Mt(l, m, e), t.push(m);
    }
    delete s.props, s.properties = r;
  }
  return t;
}
function Ls(f) {
  const e = /^Transform\.local(Scale|Position)\.([xyz])$/.exec(f ?? "");
  if (e)
    return {
      kind: e[1] === "Scale" ? "scale" : "position",
      axis: {
        x: 0,
        y: 1,
        z: 2
      }[e[2]]
    };
}
function Ns(f, e, t, n) {
  const s = n.kind === "scale";
  return {
    name: f,
    type: "number",
    value: t,
    ...e ? { label: e } : {},
    min: s ? 0 : t - 2,
    max: s ? Math.max(2, t * 2) : t + 2,
    step: 0.01,
    inherits: !0
  };
}
var St = /* @__PURE__ */ new WeakMap();
function Us(f, e) {
  const t = St.get(f);
  if (t && t.length === e.length) return t;
  const n = /* @__PURE__ */ new Set(), s = e.map((r) => {
    const i = r.name.replace(/^:+/, "").trim() || "page";
    let o = i;
    for (let a = 2; n.has(o); a++) o = `${i} ${a}`;
    return n.add(o), o;
  });
  return St.set(f, s), s;
}
function zt(f, e) {
  const t = f.replace(/[^A-Za-z0-9]+/g, " ").trim().split(/\s+/).map((s, r) => r === 0 ? s.toLowerCase() : s[0].toUpperCase() + s.slice(1).toLowerCase()).join("") || "property";
  if (!e.has(t)) return t;
  let n = 2;
  for (; e.has(`${t}${n}`); ) n++;
  return `${t}${n}`;
}
function js(f, e, t) {
  for (const n of f) {
    const s = n.behaviors;
    if (s)
      for (const r of [...s]) r["@type"] === "Follow" ? ($s(n, r, e, t), qe(s, r)) : r["@type"] === "FollowActive" && (Hs(n, r, e, t), qe(s, r));
  }
}
function $s(f, e, t, n) {
  const s = t.resolve(e.target);
  if (!s) {
    j.warn(`[LegacyConstraints] Follow on "${f.name}" targets ${e.target}, which is not in the scene — dropped`);
    return;
  }
  const r = Dt(s, f, t, n);
  if (!r) return;
  const i = Ft(r);
  i && Vs(f.transform.position, i) || qs(f, r);
}
var Ws = [
  "Offset X",
  "Height",
  "Offset Z"
];
function Hs(f, e, t, n) {
  const s = (e.targets ?? []).map((x) => ({
    path: x,
    node: t.resolve(x)
  })).filter((x) => (x.node || j.warn(`[LegacyConstraints] FollowActive on "${f.name}" targets ${x.path}, which is not in the scene — dropped`), !!x.node));
  if (s.length === 0) return;
  const r = Zs(s.map((x) => x.node), t);
  if (!r) {
    j.warn(`[LegacyConstraints] FollowActive on "${f.name}" has no cycler over its targets — dropped`);
    return;
  }
  if (kt(f, r)) {
    j.warn(`[LegacyConstraints] FollowActive on "${f.name}" targets its own subtree — dropped`);
    return;
  }
  const i = Xs(r), o = new Set((i.shared ?? []).map((x) => x.replace(/^\.\//, ""))), a = r.transform.getChildren().map((x) => t.nodeFor(x)).filter((x) => !!x && !o.has(x.name)), l = /* @__PURE__ */ new Map();
  for (const { node: x } of s) {
    const z = a.findIndex((O) => kt(O, x));
    if (z < 0) continue;
    const B = Dt(x, f, t, n, r);
    if (!B) continue;
    let $ = Ft(B);
    $ || (j.warn(`[LegacyConstraints] "${f.name}" on page "${a[z].name}" tracks a control — pinned at the control's current value`), $ = t.positionIn(x, r).asArray()), l.set(z, $);
  }
  if (l.size === 0) return;
  const g = [...l.keys()].sort((x, z) => x - z), p = g.find((x) => a[x].active !== !1);
  p === void 0 && j.warn(`[LegacyConstraints] "${f.name}": no page of "${r.name}" is active — basing its pose on "${a[g[0]].name}"`);
  const m = l.get(p ?? g[0]), u = [
    0,
    1,
    2
  ].filter((x) => [...l.values()].some((z) => Math.abs(z[x] - m[x]) > ye));
  if (t.refresh(f.transform), f.transform.setParent(r.transform), f.transform.position.set(m[0], m[1], m[2]), i.shared = [...i.shared ?? [], `./${f.name}`], u.length === 0) return;
  const b = De(r), h = new Set(b.properties.map((x) => x.name)), v = /* @__PURE__ */ new Map();
  for (const x of u) {
    const z = zt(`${f.name} ${Ws[x]}`, h);
    h.add(z), v.set(x, z), b.properties.push({
      name: z,
      type: "number",
      value: Oe(m[x]),
      inherits: !0,
      hidden: !0
    });
  }
  const _ = De(f);
  (_.transform ??= {}).position = [
    0,
    1,
    2
  ].map((x) => v.has(x) ? `{${v.get(x)}}` : Oe(m[x]));
  const y = b.states ??= {}, R = Us(r, a), k = a.map(() => ({}));
  for (const [x, z] of l) {
    const B = R[x], $ = y[B] ??= {
      values: {},
      transition: { duration: 0 }
    };
    for (const O of u) $.values[v.get(O)] = Oe(z[O]);
    k[x] = { states: [{
      target: "$self",
      state: B
    }] };
  }
  Ys(i, k);
}
function Zs(f, e) {
  const t = (s) => (s.behaviors ?? []).some((r) => r["@type"] === "Cycler" || r["@type"] === "Pages");
  let n;
  for (const s of f) {
    const r = e.ancestorWhere(s, t);
    if (!r || n && n !== r) return;
    n = r;
  }
  return n;
}
function kt(f, e) {
  return e.transform === f.transform || e.transform.isDescendantOf(f.transform);
}
function Dt(f, e, t, n, s) {
  const r = () => (s ? t.positionIn(f, s) : t.requiredLocalPosition(f, e)).asArray(), i = [...r()];
  for (const o of n) {
    const a = (m) => {
      const u = Lt(o.node.transform, o);
      Rt(o.node.transform, o, m);
      const b = r();
      return Rt(o.node.transform, o, u), r(), b;
    }, l = a(yt), g = a(wt), p = a((yt + wt) / 2);
    for (let m = 0; m < 3; m++) {
      const u = g[m] - l[m];
      if (!(Math.abs(u) < ye)) {
        if (Math.abs(p[m] - (l[m] + u / 2)) > ye) {
          j.warn(`[LegacyConstraints] "${e.name}" tracks "${o.property}" non-linearly on axis ${m} — pinning it to the authored value instead`);
          continue;
        }
        if (typeof i[m] == "string") {
          j.warn(`[LegacyConstraints] "${e.name}" axis ${m} is driven by more than one control; keeping the first and ignoring "${o.property}"`);
          continue;
        }
        Mt(e, o, t), i[m] = Gs(l[m], u, o.property);
      }
    }
  }
  return i;
}
function Mt(f, e, t) {
  t.ancestorWhere(f, (n) => n === e.owner) || j.warn(`[LegacyConstraints] "${f.name}" binds "${e.property}", declared on "${e.owner.name}", which is not one of its ancestors — the binding will not resolve and the authored value stands`);
}
function Gs(f, e, t) {
  const n = Math.abs(e - 1) < ye ? t : `${t} * ${Oe(e)}`;
  return Math.abs(f) < ye ? `{${n}}` : `{${Oe(f)} + ${n}}`;
}
function Oe(f) {
  return Number(f.toPrecision(9));
}
function Vs(f, e) {
  return Math.abs(f.x - e[0]) < ye && Math.abs(f.y - e[1]) < ye && Math.abs(f.z - e[2]) < ye;
}
function Lt(f, e) {
  return (e.kind === "scale" ? f.scaling : f.position).asArray()[e.axis];
}
function Rt(f, e, t) {
  const n = e.kind === "scale" ? f.scaling : f.position;
  e.axis === 0 ? n.x = t : e.axis === 1 ? n.y = t : n.z = t;
}
function De(f) {
  const e = f.behaviors ?? (f.behaviors = []), t = e.find((s) => s["@type"] === "Properties");
  if (t)
    return t.properties ??= [], t;
  const n = {
    "@type": "Properties",
    properties: []
  };
  return e.push(n), n;
}
function Ks(f, e, t) {
  const n = De(f), s = n.transform ??= {}, r = e.kind === "scale" ? f.transform.scaling : f.transform.position, i = e.kind === "scale" ? s.scale ??= [...r.asArray()] : s.position ??= [...r.asArray()];
  i[e.axis] = t;
}
function qs(f, e) {
  const t = De(f);
  (t.transform ??= {}).position = e;
}
function Xs(f) {
  const e = f.behaviors ?? (f.behaviors = []), t = e.find((r) => r["@type"] === "Cycler");
  t && qe(e, t);
  const n = e.find((r) => r["@type"] === "Pages");
  if (n) return n;
  const s = { "@type": "Pages" };
  return e.push(s), s;
}
function Ys(f, e) {
  const t = [...f.pages ?? []];
  for (let n = 0; n < e.length; n++) {
    const s = e[n].states;
    if (!s) {
      t[n] ??= {};
      continue;
    }
    const r = t[n]?.states ?? [], i = s.filter((o) => !r.some((a) => a.target === o.target && a.state === o.state));
    t[n] = {
      ...t[n],
      states: [...r, ...i]
    };
  }
  f.pages = t;
}
function Js(f) {
  return f["@type"] === "Follow" || f["@type"] === "FollowActive" || f["@type"] === "Properties" && Array.isArray(f.props);
}
function qe(f, e) {
  const t = f.indexOf(e);
  t >= 0 && f.splice(t, 1);
}
var Qs = (f, e = "") => ({
  src: f,
  name: e,
  active: !0,
  transform: {},
  behaviors: []
}), Ye = class {
  async loadAsync(f, e, t, n, s) {
    const r = await this.parseSceneData(e, t, s);
    await this.loadNodes(r, f, n);
  }
  async importMeshAsync(f, e, t, n, s, r) {
    f != null && j.warn(`${this.name}: meshesNames parameter is ignored. Scene composition formats load complete scene graphs.`);
    const i = new Set(e.meshes), o = new Set(e.animationGroups), a = new Set(e.skeletons), l = new Set(e.transformNodes), g = new Set(e.geometries), p = new Set(e.lights);
    return await this.loadAsync(e, t, n, s, r), {
      meshes: e.meshes.filter((m) => !i.has(m)),
      animationGroups: e.animationGroups.filter((m) => !o.has(m)),
      skeletons: e.skeletons.filter((m) => !a.has(m)),
      transformNodes: e.transformNodes.filter((m) => !l.has(m)),
      geometries: e.geometries.filter((m) => !g.has(m)),
      lights: e.lights.filter((m) => !p.has(m)),
      particleSystems: [],
      spriteManagers: []
    };
  }
  async loadAssetContainerAsync(f, e, t, n, s) {
    const r = new vs(f), i = await this.parseSceneData(e, t, s);
    return await this.loadNodesIntoContainer(i, r, f, n), r;
  }
  async loadWithResult(f, e, t, n, s) {
    const r = await this.parseSceneData(e, t, s), i = n ? (o) => {
      n(o.loaded, o.total);
    } : void 0;
    return await this.loadNodes(r, f, i);
  }
  async loadNodes(f, e, t) {
    const n = [], s = /* @__PURE__ */ new Map(), { nodeTransforms: r, nodePaths: i } = ut(f.nodes, e);
    for (let o = 0; o < f.nodes.length; o++) {
      const a = f.nodes[o], l = r.get(a), g = i.get(a), p = {
        transform: l,
        name: a.name,
        src: a.src,
        active: a.active,
        behaviors: a.behaviors,
        resetAssetTransform: a.resetAssetTransform
      };
      n.push(p), s.set(g, p), t?.({
        lengthComputable: !0,
        loaded: o + 1,
        total: f.nodes.length
      });
    }
    return {
      nodes: n,
      rootNodes: n.filter((o) => !o.transform.parent),
      nodeMap: s,
      assetBlobs: f.assetBlobs,
      scripts: f.scripts
    };
  }
  async loadNodesIntoContainer(f, e, t, n) {
    ut(f.nodes, t, (s, r) => {
      e.transformNodes.push(r);
    });
    for (let s = 0; s < f.nodes.length; s++) n?.({
      lengthComputable: !0,
      loaded: s + 1,
      total: f.nodes.length
    });
  }
}, en = "info.json", tn = "models.json", Nt = class extends Ye {
  name = "trace-zip";
  extensions = { ".zip": { isBinary: !0 } };
  _sourceInfoFile = null;
  getSourceInfoFile() {
    return this._sourceInfoFile;
  }
  async parseSceneData(f, e, t) {
    const n = await Te.default.loadAsync(f), s = await this.extractAssets(n), r = await this.parseSceneFiles(n);
    return {
      nodes: this.convertSceneData(r),
      assetBlobs: s,
      rootUrl: e
    };
  }
  async extractAssets(f) {
    const e = /* @__PURE__ */ new Map(), t = f.folder("assets");
    if (t) {
      const n = t.filter((s, r) => !r.dir);
      for (const s of n) {
        const r = await s.async("arraybuffer"), i = s.name.replace(/^assets\//i, ""), o = he.mimeTypeFromFilename(i), a = new Blob([r], o ? { type: o } : void 0);
        e.set(`assets/${i}`, a);
      }
    }
    return e;
  }
  async parseSceneFiles(f) {
    const e = [], t = f.file(en);
    if (t) {
      const s = await t.async("string"), r = he.parseInfoJson(s);
      r && (this._sourceInfoFile = r.sourceInfoFile, r.sceneInfo.content && (this.applyMigrations(r.sceneInfo.content), e.push(...r.sceneInfo.content)));
    }
    const n = f.file(tn);
    if (n) {
      const s = await n.async("string"), r = he.parseLegacyJson(s);
      r.content && (this.applyMigrations(r.content), e.push(...r.content));
    }
    if (!t && !n) throw new Error("No info.json or models.json found in .zip trace scene");
    return e;
  }
  applyMigrations(f) {
    for (const e of f) {
      const t = e;
      t.components && !t.behaviors && (t.behaviors = t.components, delete t.components);
    }
  }
  convertSceneData(f) {
    return f.map((e) => ({
      name: e.name,
      src: e.src,
      transform: e.transform ? {
        translation: e.transform.translation,
        rotation: e.transform.rotation,
        scale: e.transform.scale
      } : void 0,
      parentName: e.transform?.parent,
      active: typeof e.active == "boolean" ? e.active : void 0,
      behaviors: e.behaviors
    }));
  }
}, sn = class extends Ye {
  name = "trace";
  extensions = { ".trace": { isBinary: !0 } };
  async parseSceneData(f, e, t) {
    const n = await Te.default.loadAsync(f), s = n.file("scene.json");
    if (!s) throw new Error("Archive does not contain scene.json");
    const r = he.parseLegacyJson(await s.async("string")), i = /* @__PURE__ */ new Map(), o = n.folder("assets");
    if (o) {
      const g = o.filter((p, m) => !m.dir);
      for (const p of g) {
        const m = await p.async("arraybuffer"), u = p.name.replace(/^assets\//, ""), b = he.mimeTypeFromFilename(u), h = new Blob([m], b ? { type: b } : void 0);
        i.set(`assets/${u}`, h);
      }
    }
    const a = parseInt(r.version ?? "0", 10), l = Number.isNaN(a) || a < 2;
    return {
      nodes: (r.content ?? []).map((g) => ({
        name: g.name,
        src: g.src,
        transform: g.transform ? {
          translation: g.transform.translation,
          rotation: g.transform.rotation,
          scale: g.transform.scale
        } : void 0,
        parentName: g.transform?.parent,
        active: g.active,
        behaviors: g.behaviors ?? g.components,
        resetAssetTransform: l && g.src ? !0 : void 0
      })),
      assetBlobs: i,
      rootUrl: e,
      scripts: r.scripts
    };
  }
}, nn = "scene.json", rn = "models.json", on = "info.json", an = "scene.gltf", cn = "scene.glxf", Me = [an, cn], fr = [
  nn,
  rn,
  on,
  ...Me
], ln = 67324752, hn = 101010256, un = 33639248, dn = 65557, Ct = 46;
function Ut(f) {
  return f instanceof Uint8Array ? f : ArrayBuffer.isView(f) ? new Uint8Array(f.buffer, f.byteOffset, f.byteLength) : new Uint8Array(f);
}
function fn(f) {
  return f.length < 4 ? !1 : new DataView(f.buffer, f.byteOffset, 4).getUint32(0, !0) === ln;
}
function pn(f) {
  if (!fn(f)) return;
  const e = new DataView(f.buffer, f.byteOffset, f.byteLength), t = Math.max(0, f.length - dn);
  let n = -1;
  for (let a = f.length - 22; a >= t; a--) if (e.getUint32(a, !0) === hn) {
    n = a;
    break;
  }
  if (n < 0) return;
  const s = e.getUint16(n + 10, !0);
  let r = e.getUint32(n + 16, !0);
  if (s === 65535 || r === 4294967295) return;
  const i = [], o = new TextDecoder();
  for (let a = 0; a < s; a++) {
    if (r + Ct > f.length || e.getUint32(r, !0) !== un) return;
    const l = e.getUint16(r + 28, !0), g = e.getUint16(r + 30, !0), p = e.getUint16(r + 32, !0), m = r + Ct;
    if (m + l > f.length) return;
    i.push(o.decode(f.subarray(m, m + l))), r = m + l + g + p;
  }
  return i;
}
function mn(f, e) {
  const t = pn(f);
  return t ? t.some((n) => e.includes(n)) : !1;
}
var jt = class extends Xe {
  name = "bundle";
  extensions = {
    ".glz": { isBinary: !0 },
    ".tracex": { isBinary: !0 }
  };
  async parseSceneData(f, e, t) {
    const n = await Te.default.loadAsync(Ut(f)), s = Me.map((g) => n.file(g)).find((g) => !!g);
    if (!s) throw new Error(`Archive does not contain ${Me.join(" or ")}`);
    const r = this.parseDocument(await s.async("string")), { assetBlobUrls: i, assetBlobs: o } = await this.extractAssets(n), a = this.parseDocumentNodes(r, e, i), l = this.migrateDocumentRoot(r, a, t);
    return this.restoreKHRInteractivity(r, a, l), {
      nodes: a,
      assetBlobUrls: i,
      assetBlobs: o,
      rootUrl: e,
      document: r,
      ...l.root ? { documentRoot: l.root } : {},
      ...l.scripts ? { scripts: l.scripts } : {}
    };
  }
  async extractAssets(f) {
    const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = f.folder("assets");
    if (n) {
      const s = n.filter((r, i) => !i.dir);
      for (const r of s) {
        const i = await r.async("arraybuffer"), o = r.name.replace(/^assets\//, ""), a = he.mimeTypeFromFilename(o), l = new Blob([i], a ? { type: a } : void 0), g = URL.createObjectURL(l);
        e.set(o, g), t.set(`assets/${o}`, l), this.trackBlobUrl(g);
      }
    }
    return {
      assetBlobUrls: e,
      assetBlobs: t
    };
  }
  convertNode(f, e, t, n, s, r, i) {
    const o = super.convertNode(f, e, t, n, s, r, i), a = o.originalAssetUri;
    return a && (a.startsWith("http://") || a.startsWith("https://") || a.startsWith("blob:") || a.startsWith("./") ? o.originalAssetPath = a : o.originalAssetPath = `./${a}`), o.resolvedSrcUrl = void 0, o;
  }
  async loadNodesWithResult(f, e, t) {
    const n = f, s = {
      meshes: [],
      animationGroups: [],
      skeletons: [],
      transformNodes: [],
      geometries: [],
      lights: [],
      particleSystems: [],
      spriteManagers: []
    }, r = async () => s, i = await fs({
      nodes: f.nodes,
      scene: e,
      onProgress: t,
      loadAsset: r,
      createLoadedNode: (o, a) => ({
        transform: o,
        name: a
      }),
      extractMetadata: (o, a) => {
        this.extractNodeMetadata(o, a);
        const l = o;
        l.originalAssetPath && (a.src = l.originalAssetPath);
      }
    });
    return this.applyDocumentData({
      ...i,
      assetBlobs: n.assetBlobs
    }, n);
  }
}, gn = "SCENE_JSON", _n = class extends Ye {
  name = "aero";
  extensions = { ".real": { isBinary: !0 } };
  async parseSceneData(f, e, t) {
    const n = await Te.default.loadAsync(f), s = n.file(gn);
    if (!s) throw new Error("Archive does not contain SCENE_JSON");
    const r = JSON.parse(await s.async("string")), i = await this.extractAssets(n), o = await this.readGlbRootTransforms(i);
    return {
      nodes: this.parseAeroScene(r, o),
      assetBlobs: i,
      rootUrl: e
    };
  }
  async extractAssets(f) {
    const e = /* @__PURE__ */ new Map(), t = f.folder("Assets");
    if (t) {
      const n = t.filter((s, r) => !r.dir);
      for (const s of n) {
        const r = await s.async("arraybuffer"), i = s.name.replace(/^Assets\//i, ""), o = he.mimeTypeFromFilename(i), a = new Blob([r], o ? { type: o } : void 0);
        e.set(`assets/${i}`, a);
      }
    }
    return e;
  }
  async readGlbRootTransforms(f) {
    const e = /* @__PURE__ */ new Map();
    for (const [t, n] of f)
      if (t.endsWith(".glb"))
        try {
          const s = await n.arrayBuffer(), r = new DataView(s);
          if (s.byteLength < 20) continue;
          const i = r.getUint32(12, !0);
          if (r.getUint32(16, !0) !== 1313821514) continue;
          const o = new Uint8Array(s, 20, i), a = new TextDecoder().decode(o), l = JSON.parse(a), g = l.scenes?.[l.scene ?? 0];
          if (!g?.nodes?.length) continue;
          let p = g.nodes[0];
          for (; p !== void 0; ) {
            const m = l.nodes?.[p];
            if (!m) break;
            const u = {};
            let b = !1;
            if (m.scale) {
              const [h, v, _] = m.scale;
              (Math.abs(h - 1) > 1e-3 || Math.abs(v - 1) > 1e-3 || Math.abs(_ - 1) > 1e-3) && (u.scale = [
                h,
                v,
                _
              ], b = !0);
            }
            if (m.rotation) {
              const [h, v, _, y] = m.rotation;
              (Math.abs(h) > 1e-3 || Math.abs(v) > 1e-3 || Math.abs(_) > 1e-3 || Math.abs(y - 1) > 1e-3) && (u.rotation = [
                h,
                v,
                _,
                y
              ], b = !0);
            }
            if (b) {
              e.set(t, u);
              break;
            }
            if (m.children?.length === 1) p = m.children[0];
            else break;
          }
        } catch {
        }
    return e;
  }
  parseAeroScene(f, e) {
    const t = f.model.properties.assetLibrary, n = f.model.properties.sceneGraph, s = /* @__PURE__ */ new Map();
    if (t.properties.assetReferences) for (const i of t.properties.assetReferences) s.set(i.id, i);
    const r = [];
    for (const i of n.properties.scenes) {
      const o = i.properties.rootNode;
      this.processNode(o, s, e, r, void 0);
    }
    return r;
  }
  processNode(f, e, t, n, s) {
    const r = f.properties.name || f.id, i = this.convertTransform(f);
    let o;
    if (f.properties.components) {
      for (const a of f.properties.components) if (a.class === "aero::FileBasedGeometryComponent" && a.properties.assetReference) {
        const l = e.get(a.properties.assetReference.$reference);
        l && (o = `assets/${l.properties.relativePath.replace(/^Assets\//i, "")}`);
      }
    }
    if (o) {
      const a = t.get(o);
      if (a) {
        if (i.scale && a.scale) {
          const [l, g, p] = a.scale;
          i.scale = [
            l !== 0 ? i.scale[0] / l : i.scale[0],
            g !== 0 ? i.scale[1] / g : i.scale[1],
            p !== 0 ? i.scale[2] / p : i.scale[2]
          ];
        }
        i.rotation && a.rotation && (i.rotation = bn(i.rotation, a.rotation));
      }
    }
    if (n.push({
      name: r,
      src: o,
      transform: i.translation || i.rotation || i.scale ? i : void 0,
      parentName: s,
      active: !0
    }), f.properties.children) for (const a of f.properties.children) this.processNode(a, e, t, n, r);
  }
  convertTransform(f) {
    const e = {}, t = f.properties.localTransform;
    if (t) {
      if (t.position && (e.translation = t.position), t.rotation) {
        const [n, s, r] = t.rotation;
        e.rotation = this.eulerToQuaternion(n * Math.PI / 180, s * Math.PI / 180, r * Math.PI / 180);
      }
      t.scale && (e.scale = t.scale);
    }
    return e;
  }
  eulerToQuaternion(f, e, t) {
    const n = Math.cos(f), s = Math.sin(f), r = Math.cos(e), i = Math.sin(e), o = Math.cos(t), a = Math.sin(t), l = r * o, g = -r * a, p = i, m = s * i * o + n * a, u = -s * i * a + n * o, b = -s * r, h = -n * i * o + s * a, v = n * i * a + s * o, _ = n * r, y = l + u + _;
    let R, k, x, z;
    if (y > 0) {
      const B = 0.5 / Math.sqrt(y + 1);
      z = 0.25 / B, R = (v - b) * B, k = (p - h) * B, x = (m - g) * B;
    } else if (l > u && l > _) {
      const B = 2 * Math.sqrt(1 + l - u - _);
      z = (v - b) / B, R = 0.25 * B, k = (g + m) / B, x = (p + h) / B;
    } else if (u > _) {
      const B = 2 * Math.sqrt(1 + u - l - _);
      z = (p - h) / B, R = (g + m) / B, k = 0.25 * B, x = (b + v) / B;
    } else {
      const B = 2 * Math.sqrt(1 + _ - l - u);
      z = (m - g) / B, R = (p + h) / B, k = (b + v) / B, x = 0.25 * B;
    }
    return [
      R,
      k,
      x,
      z
    ];
  }
};
function bn(f, e) {
  const t = -e[0], n = -e[1], s = -e[2], r = e[3], [i, o, a, l] = f;
  return [
    l * t + i * r + o * s - a * n,
    l * n - i * s + o * r + a * t,
    l * s + i * n - o * t + a * r,
    l * r - i * t - o * n - a * s
  ];
}
function vn(f) {
  switch (f) {
    case "trace":
      return {
        createPlugin: () => new sn(),
        dataType: "arraybuffer"
      };
    case "glz":
    case "tracex":
      return {
        createPlugin: () => new jt(),
        dataType: "arraybuffer"
      };
    case "zip":
      return {
        createPlugin: () => new Nt(),
        dataType: "arraybuffer"
      };
    case "real":
      return {
        createPlugin: () => new _n(),
        dataType: "arraybuffer"
      };
    case "glxf":
      return $t();
    default:
      return;
  }
}
function yn() {
  return {
    createPlugin: () => new jt(),
    dataType: "arraybuffer"
  };
}
function $t() {
  return {
    createPlugin: () => new Xe(),
    dataType: "text",
    needsRootUrl: !0
  };
}
var xt = class {
  _current;
  _lastKnownName;
  constructor(f) {
    this._current = f, this._lastKnownName = f?.name ?? "<unbound>";
  }
  get() {
    return this._current;
  }
  get lastKnownName() {
    return this._lastKnownName;
  }
  _bind(f) {
    this._current = f, f && (this._lastKnownName = f.name);
  }
}, wn = class {
  byInstance = /* @__PURE__ */ new WeakMap();
  refFor(f) {
    const e = this.byInstance.get(f);
    if (e) return e;
    const t = new xt(f);
    return this.byInstance.set(f, t), t;
  }
  allocateUnbound() {
    return new xt(null);
  }
  rebind(f, e) {
    f._bind(e), e && this.byInstance.set(e, f);
  }
}, Se = "__shadow", Sn = 2e-3, Ae = 10, We = 50, kn = class Ee {
  _scene;
  _engine;
  _anchor;
  _camera;
  _rtt;
  _ground;
  _groundHeight;
  _blurPasses = [];
  constructor(e, t, n) {
    this._scene = e, this._engine = t;
    const s = n ?? Sn;
    this._groundHeight = s, Ee._registerShaders();
    const r = new Pt(`${Se}Anchor`, e);
    r.rotationQuaternion = we.Identity(), this._anchor = r;
    const i = new ys(`${Se}Camera`, new _e(0, We, 0), e);
    i.mode = ws.ORTHOGRAPHIC_CAMERA, i.orthoLeft = -Ae, i.orthoRight = Ae, i.orthoTop = Ae, i.orthoBottom = -Ae, i.minZ = 0.1, i.maxZ = We - s, i.upVector = new _e(0, 0, -1), i.setTarget(new _e(0, s, 0)), i.parent = r, this._camera = i;
    const o = new mt(`${Se}RTT`, 512, e, !1, !0);
    o.activeCamera = i, o.clearColor = new Ge(1, 1, 1, 0), o.renderParticles = !1, o.refreshRate = mt.REFRESHRATE_RENDER_ONEVERYFRAME, o.renderList = [], o.getCustomRenderList = () => this._getRenderList(), this._rtt = o, e.customRenderTargets.push(o);
    const a = (m, u) => new Ss(`${Se}${m}`, u, 15, 1, null, void 0, t), l = [
      a("BlurH1", new xe(1, 0)),
      a("BlurV1", new xe(0, 1)),
      a("BlurH2", new xe(1, 0)),
      a("BlurV2", new xe(0, 1))
    ];
    for (const m of l) o.addPostProcess(m);
    this._blurPasses = l;
    const g = Rs(`${Se}Ground`, {
      width: 100,
      height: 100
    }, e);
    g.position.y = s, g.isPickable = !1, g.parent = r;
    const p = new ks(`${Se}GroundMat`, e, {
      vertex: "__contactShadowGround",
      fragment: "__contactShadowGround"
    }, {
      attributes: ["position", "uv"],
      uniforms: [
        "worldViewProjection",
        "shadowCenter",
        "shadowSize",
        "shadowIntensity"
      ],
      samplers: ["shadowTex"],
      needAlphaBlending: !0
    });
    p.setTexture("shadowTex", o), p.setFloat("shadowIntensity", 0.5), p.setFloat("shadowSize", Ae * 2), p.setVector2("shadowCenter", xe.Zero()), p.backFaceCulling = !1, p.alphaMode = 2, g.material = p, this._ground = g;
  }
  setGroundHeight(e) {
    this._groundHeight = e, this._ground.position.y = e, this._camera.maxZ = We - e, this._camera.setTarget(new _e(0, e, 0));
  }
  dispose() {
    const e = this._scene, t = e.customRenderTargets.indexOf(this._rtt);
    t !== -1 && e.customRenderTargets.splice(t, 1), this._rtt.dispose();
    for (const n of this._blurPasses) n.dispose();
    this._camera.dispose(), this._ground.dispose(), this._anchor.dispose();
  }
  syncToTransform(e) {
    const t = new we();
    e.getWorldMatrix().decompose(this._anchor.scaling, t, this._anchor.position);
  }
  setPosition(e) {
    this._anchor.position.copyFrom(e);
  }
  _getRenderList() {
    return this._scene.meshes.filter((e) => e.isVisible && e.isEnabled() && !Ee._shouldSkip(e));
  }
  static _shadersRegistered = !1;
  static _registerShaders() {
    Ee._shadersRegistered || (Ee._shadersRegistered = !0, gt.ShadersStore.__contactShadowGroundVertexShader = `
            precision highp float;
            attribute vec3 position;
            attribute vec2 uv;
            uniform mat4 worldViewProjection;
            uniform vec2 shadowCenter;
            uniform float shadowSize;
            varying vec2 vShadowUV;
            void main() {
                gl_Position = worldViewProjection * vec4(position, 1.0);
                float halfSize = shadowSize * 0.5;
                vShadowUV.x = (position.x - (shadowCenter.x - halfSize)) / shadowSize;
                vShadowUV.y = 1.0 - (position.z - (shadowCenter.y - halfSize)) / shadowSize;
            }
        `, gt.ShadersStore.__contactShadowGroundFragmentShader = `
            precision highp float;
            uniform sampler2D shadowTex;
            uniform float shadowIntensity;
            varying vec2 vShadowUV;
            void main() {
                if (vShadowUV.x < 0.0 || vShadowUV.x > 1.0 || vShadowUV.y < 0.0 || vShadowUV.y > 1.0) {
                    discard;
                }
                float shadow = texture2D(shadowTex, vShadowUV).a;
                gl_FragColor = vec4(0.0, 0.0, 0.0, shadow * shadowIntensity);
            }
        `);
  }
  static _shouldSkip(e) {
    const t = e.name;
    return !!(t.startsWith("__") || t.endsWith("__collider") || t.endsWith("__selection") || t === "BackgroundPlane" || t === "BackgroundSkybox" || t === "hdrSkyBox" || e.metadata?.castShadows === !1);
  }
};
function Rn(f, e) {
  const t = He(f.getMaterial()) ? 0 : 1, n = He(e.getMaterial()) ? 0 : 1;
  return t !== n ? t - n : Cs.PainterSortCompare(f, e);
}
var Cn = class {
  _scene;
  _playing = !1;
  _xrActive = !1;
  _depthOnly = !1;
  _newMaterialObserver = null;
  _markedObserver = null;
  constructor(f) {
    this._scene = f, f.setRenderingOrder(0, Rn), this._newMaterialObserver = f.onNewMaterialAddedObservable.add((e) => this._apply(e)), this._markedObserver = et.add((e) => {
      e.getScene() === f && f.materials.includes(e) && this._apply(e);
    });
  }
  get depthOnly() {
    return this._depthOnly;
  }
  setPlaying(f) {
    this._playing = f, this._recompute();
  }
  setXRActive(f) {
    this._xrActive = f, this._recompute();
  }
  dispose() {
    this._newMaterialObserver && (this._scene.onNewMaterialAddedObservable.remove(this._newMaterialObserver), this._newMaterialObserver = null), this._markedObserver && (et.remove(this._markedObserver), this._markedObserver = null);
  }
  _recompute() {
    const f = this._playing || this._xrActive;
    if (f !== this._depthOnly) {
      this._depthOnly = f;
      for (const e of this._scene.materials) this._apply(e);
    }
  }
  _apply(f) {
    He(f) && f.disableColorWrite !== this._depthOnly && (f.disableColorWrite = this._depthOnly);
  }
}, At = [
  "pointerdown",
  "touchend",
  "keydown"
], xn = class {
  _ctx = null;
  _scene;
  _listenerObserver = null;
  _unlockTarget = null;
  _gestureRetries = /* @__PURE__ */ new Set();
  constructor(f) {
    this._scene = f;
  }
  getContext() {
    return this._ctx || (this._ctx = new AudioContext(), this._startListenerSync()), this.resume(), this._ctx;
  }
  resume() {
    const f = this._ctx;
    !f || f.state === "running" || f.state === "closed" || (this._installUnlock(), f.resume().then(() => this._releaseUnlockIfDone(), () => {
    }));
  }
  retryOnGesture(f) {
    return this._gestureRetries.add(f), this._installUnlock(), () => {
      this._gestureRetries.delete(f), this._releaseUnlockIfDone();
    };
  }
  _onGesture = () => {
    this.resume();
    const f = [...this._gestureRetries];
    this._gestureRetries.clear();
    for (const e of f) e();
    this._releaseUnlockIfDone();
  };
  _installUnlock() {
    if (this._unlockTarget) return;
    const f = this._scene.getEngine().getRenderingCanvas()?.ownerDocument?.defaultView ?? (typeof window < "u" ? window : null);
    if (f) {
      for (const e of At) f.addEventListener(e, this._onGesture, { capture: !0 });
      this._unlockTarget = f;
    }
  }
  _releaseUnlockIfDone() {
    this._ctx && this._ctx.state !== "running" && this._ctx.state !== "closed" || this._gestureRetries.size > 0 || this._removeUnlock();
  }
  _removeUnlock() {
    const f = this._unlockTarget;
    if (f) {
      for (const e of At) f.removeEventListener(e, this._onGesture, { capture: !0 });
      this._unlockTarget = null;
    }
  }
  getDestination() {
    return this.getContext().destination;
  }
  _startListenerSync() {
    this._listenerObserver || (this._listenerObserver = this._scene.onBeforeRenderObservable.add(() => {
      if (!this._ctx) return;
      const f = this._scene.activeCamera;
      if (!f) return;
      const e = this._ctx.listener, t = f.position, n = f.getForwardRay().direction, s = 0, r = 1, i = 0;
      e.positionX ? (e.positionX.value = t.x, e.positionY.value = t.y, e.positionZ.value = t.z, e.forwardX.value = n.x, e.forwardY.value = n.y, e.forwardZ.value = n.z, e.upX.value = s, e.upY.value = r, e.upZ.value = i) : (e.setPosition(t.x, t.y, t.z), e.setOrientation(n.x, n.y, n.z, s, r, i));
    }));
  }
  dispose() {
    this._gestureRetries.clear(), this._removeUnlock(), this._listenerObserver && (this._scene.onBeforeRenderObservable.remove(this._listenerObserver), this._listenerObserver = null), this._ctx && (this._ctx.close().catch(() => {
    }), this._ctx = null);
  }
}, An = class {
  _traceScene;
  _registered = /* @__PURE__ */ new Map();
  _selectionHandler = null;
  _currentlySelected = null;
  constructor(f) {
    this._traceScene = f;
  }
  register(f, e) {
    const t = this._registered.size === 0;
    let n = this._registered.get(f);
    return n || (n = [], this._registered.set(f, n)), n.push(e), t && this._listenForSelection(), () => {
      const s = this._registered.get(f);
      if (!s) return;
      const r = s.indexOf(e);
      r >= 0 && s.splice(r, 1), s.length === 0 && (this._registered.delete(f), this._currentlySelected === f && (this._currentlySelected = null), this._registered.size === 0 && this._disable());
    };
  }
  unregister(f) {
    this._registered.delete(f) && (this._currentlySelected === f && (this._currentlySelected = null), this._registered.size === 0 && this._disable());
  }
  isRegistered(f) {
    return this._registered.has(f);
  }
  select(f) {
    this._traceScene.select(f);
  }
  dispose() {
    this._disable(), this._registered.clear(), this._currentlySelected = null;
  }
  _disable() {
    this._removeSelectionListener(), j.log("[RuntimeSelectionManager] Disabled (no selectables registered)");
  }
  _listenForSelection() {
    if (this._selectionHandler) return;
    const f = this._traceScene.getEventSystem();
    f && (this._selectionHandler = (e) => {
      const t = e.detail?.object ?? null, n = t && this._registered.has(t) ? t : null;
      if (n !== this._currentlySelected) {
        if (this._currentlySelected) {
          const s = this._registered.get(this._currentlySelected);
          if (s) for (const r of s) r.onDeselected?.();
        }
        if (this._currentlySelected = n, n) {
          const s = this._registered.get(n);
          if (s) for (const r of s) r.onSelected?.();
        }
      }
    }, f.addEventListener("trace-viewer:selection-changed", this._selectionHandler));
  }
  _removeSelectionListener() {
    if (!this._selectionHandler) return;
    const f = this._traceScene.getEventSystem();
    f && f.removeEventListener("trace-viewer:selection-changed", this._selectionHandler), this._selectionHandler = null;
  }
}, En = class {
  _playStartTime = null;
  _now = () => performance.now();
  _camera = null;
  setClock(f) {
    const e = this.getElapsed() * 1e3;
    this._now = f, this._playStartTime !== null && (this._playStartTime = f() - e);
  }
  setPlayMode(f) {
    f ? this._playStartTime = this._now() : this._playStartTime = null;
  }
  setCamera(f) {
    this._camera = f;
  }
  buildScope(f) {
    return {
      time: { elapsed: this.getElapsed() },
      camera: this._buildCamera(f),
      self: this._buildSelf(f)
    };
  }
  getElapsed() {
    return this._playStartTime !== null ? (this._now() - this._playStartTime) / 1e3 : 0;
  }
  _buildCamera(f) {
    if (!this._camera) return {
      distance: 0,
      position: {
        x: 0,
        y: 0,
        z: 0
      }
    };
    const e = this._camera.position, t = f.getAbsolutePosition(), n = e.x - t.x, s = e.y - t.y, r = e.z - t.z;
    return {
      distance: Math.sqrt(n * n + s * s + r * r),
      position: {
        x: e.x,
        y: e.y,
        z: e.z
      }
    };
  }
  _buildSelf(f) {
    const e = f.getAbsolutePosition();
    return { position: {
      x: e.x,
      y: e.y,
      z: e.z
    } };
  }
};
function Wt(f, e) {
  for (let t = f; t; t = t.getParent()) if (e.has(t)) return !0;
  return !1;
}
function pr(f, e) {
  const t = new Set(e ?? []);
  return t.size === 0 ? [...f] : f.filter((n) => !Wt(n, t));
}
function On(f) {
  const e = new Set(f.filter((n) => n !== null)), t = /* @__PURE__ */ new Set();
  for (let n = 0; n < f.length; n++) {
    const s = f[n];
    if (!s) {
      t.add(n);
      continue;
    }
    const r = s.getParent();
    (!r || !e.has(r)) && t.add(n);
  }
  return t;
}
function Et(f, e, t) {
  const n = new Set(t ?? []);
  if (n.size === 0) return {
    data: [...f],
    liveObjects: [...e]
  };
  const s = On(e);
  let r = 0, i = 0;
  const o = [], a = [];
  for (let l = 0; l < f.length; l++) {
    const g = e[l] ?? null, p = g !== null && s.has(l);
    p && r++, !(g && Wt(g, n)) && (p && i++, o.push(f[l]), a.push(g));
  }
  if (r > 0 && i === 0) throw new Error("export exclude: the excluded subtree(s) cover every root of this capture — excluding the document root would write an empty document. Exclude the editor subtree, not the root it is mounted under (CONTENT_MODEL_SPEC §2.9).");
  return {
    data: o,
    liveObjects: a
  };
}
var Ot = "Scene";
function Tt(f) {
  const e = {};
  for (const t of f) typeof t == "string" ? e.name ??= t : Array.isArray(t) ? e.behaviors ??= t : t && typeof t == "object" && (e.options ??= t);
  return e;
}
var mr = class ve {
  sourceInfoFile;
  get sourceFormat() {
    return this._sourceFormat;
  }
  _sourceFormat = "";
  get sceneSourceFormat() {
    return this._sceneSourceFormat;
  }
  _sceneSourceFormat = "";
  get placementRuleActive() {
    const e = this.sceneSourceFormat;
    return e === "" || !Qt(e);
  }
  get _uidMintingActive() {
    return this.placementRuleActive;
  }
  babylonScene;
  engine;
  canvas;
  camera;
  config;
  backgroundColor;
  alpha;
  sceneName;
  _sessionDocumentRoot = null;
  sceneObjects;
  resources;
  _sceneRoot = null;
  _eventSystem = null;
  _transformOwnerCache = /* @__PURE__ */ new WeakMap();
  fetchInit = null;
  _selectedObject = null;
  _playMode = !0;
  _occluderMode;
  _playModeInitialized = !1;
  _renderingStarted = !1;
  _editModeClickToSelect = !1;
  _safeAreaInsets = {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  };
  _guiFocusCount = 0;
  _scriptRegistry = new cs();
  _systemValues = new En();
  _scriptsMap;
  _foreignDocument;
  _audioManager = null;
  _runtimeSelectionManager = null;
  _objectIdentityRegistry = null;
  get objectIdentityRegistry() {
    return this._objectIdentityRegistry || (this._objectIdentityRegistry = new wn()), this._objectIdentityRegistry;
  }
  get scriptRegistry() {
    return this._scriptRegistry;
  }
  get scriptsMap() {
    return this._scriptsMap;
  }
  get foreignDocument() {
    return this._foreignDocument;
  }
  registerScript(e, t, n) {
    this._scriptsMap || (this._scriptsMap = {}), this._scriptsMap[e] = t;
    const s = t.replace(/^\.\//, "");
    this.resources.addAsset(s, new Blob([n], { type: "text/typescript" })), this._scriptRegistry.register(e, n);
  }
  _groundShadowEnabled = !1;
  _contactShadow = null;
  _reparentPolicy = null;
  setReparentPolicy(e) {
    this._reparentPolicy = e;
  }
  _topologyListeners = /* @__PURE__ */ new Set();
  _structureRevisionValue = 0;
  get structureRevision() {
    return this._structureRevisionValue;
  }
  _bumpStructureRevision() {
    this._structureRevisionValue++;
  }
  onTopologyChanged(e) {
    return this._topologyListeners.add(e), () => this._topologyListeners.delete(e);
  }
  _emitTopologyChanged(e) {
    this._bumpStructureRevision(), this._armStartFlush();
    for (const t of this._topologyListeners) try {
      t(e);
    } catch (n) {
      j.warn("[TraceScene] topology listener threw:", n);
    }
  }
  _pendingStartEvents = /* @__PURE__ */ new Set();
  _startFlushTimer = null;
  _startFlushDeadline = null;
  _constructionDepth = 0;
  _beginConstruction() {
    this._constructionDepth++;
  }
  _endConstruction() {
    this._constructionDepth = Math.max(0, this._constructionDepth - 1), this._constructionDepth === 0 && this._armStartFlush();
  }
  static START_FLUSH_MAX_MS = 1e3;
  _deferStartEvent(e) {
    this._pendingStartEvents.add(e), this._armStartFlush(), this._startFlushDeadline === null && (this._startFlushDeadline = setTimeout(() => {
      this._startFlushDeadline = null, this._flushStartEvents(!0);
    }, ve.START_FLUSH_MAX_MS));
  }
  _armStartFlush() {
    this._pendingStartEvents.size !== 0 && (this._startFlushTimer !== null && clearTimeout(this._startFlushTimer), this._startFlushTimer = setTimeout(() => this._flushStartEvents(), 0));
  }
  _flushStartEvents(e = !1) {
    if (this._pendingStartEvents.size === 0) {
      this._clearStartFlushTimers();
      return;
    }
    if (this._constructionDepth > 0 && !e) {
      this._startFlushTimer !== null && (clearTimeout(this._startFlushTimer), this._startFlushTimer = null);
      return;
    }
    this._clearStartFlushTimers();
    const t = [...this._pendingStartEvents];
    this._pendingStartEvents.clear();
    for (const n of t) try {
      n();
    } catch (s) {
      j.warn("[TraceScene] deferred start event threw:", s);
    }
  }
  _cancelStartEvents() {
    this._clearStartFlushTimers(), this._pendingStartEvents.clear();
  }
  _clearStartFlushTimers() {
    this._startFlushTimer !== null && (clearTimeout(this._startFlushTimer), this._startFlushTimer = null), this._startFlushDeadline !== null && (clearTimeout(this._startFlushDeadline), this._startFlushDeadline = null);
  }
  _behaviorsLoadedListeners = /* @__PURE__ */ new Set();
  onBehaviorsLoaded(e) {
    return this._behaviorsLoadedListeners.add(e), () => this._behaviorsLoadedListeners.delete(e);
  }
  _emitBehaviorsLoaded(e) {
    for (const t of this._behaviorsLoadedListeners) try {
      t(e);
    } catch (n) {
      j.warn("[TraceScene] behaviors-loaded listener threw:", n);
    }
  }
  _reparentListeners = /* @__PURE__ */ new Set();
  onObjectReparented(e) {
    return this._reparentListeners.add(e), () => this._reparentListeners.delete(e);
  }
  _emitObjectReparented(e, t) {
    const n = t ? this.findSceneObjectByTransform(t) ?? null : null;
    for (const s of this._reparentListeners) try {
      s(e, n);
    } catch (r) {
      j.warn("[TraceScene] reparent listener threw:", r);
    }
  }
  _layoutSolvedListeners = /* @__PURE__ */ new Set();
  _layoutSolveEmitStreak = 0;
  _layoutSolveStreakResetScheduled = !1;
  static _LAYOUT_SOLVE_RUNAWAY_THRESHOLD = 100;
  onLayoutSolved(e) {
    return this._layoutSolvedListeners.add(e), () => this._layoutSolvedListeners.delete(e);
  }
  _emitLayoutSolved(e) {
    j.level >= qt.DEBUG && (this._layoutSolveEmitStreak++, this._layoutSolveEmitStreak === ve._LAYOUT_SOLVE_RUNAWAY_THRESHOLD && j.warn(`[TraceScene] ${this._layoutSolveEmitStreak} layout solves without a macrotask — an onLayoutSolved listener is re-invalidating unconditionally (runaway microtask chain).`), this._layoutSolveStreakResetScheduled || (this._layoutSolveStreakResetScheduled = !0, setTimeout(() => {
      this._layoutSolveStreakResetScheduled = !1, this._layoutSolveEmitStreak = 0;
    }, 0)));
    for (const t of this._layoutSolvedListeners) try {
      t(e);
    } catch (n) {
      j.warn("[TraceScene] layout-solve listener threw:", n);
    }
  }
  _layoutSizeBakedListeners = /* @__PURE__ */ new Set();
  onLayoutSizeBaked(e) {
    return this._layoutSizeBakedListeners.add(e), () => this._layoutSizeBakedListeners.delete(e);
  }
  _emitLayoutSizeBaked(e) {
    for (const t of this._layoutSizeBakedListeners) try {
      t(e);
    } catch (n) {
      j.warn("[TraceScene] layout size-bake listener threw:", n);
    }
  }
  canParentUnder(e) {
    let t = e;
    for (; t; ) {
      if (t.isSceneReference) return !1;
      t = t.getParent();
    }
    return !0;
  }
  _vetoReferenceSubtreeParent(e, t) {
    const n = `Cannot add "${e}" under "${t.name}": children of an imported scene reference are derived from the referenced file and would be lost on export. Choose a parent outside the imported subtree instead.`;
    return this._notifyReparentVetoed(e, t, n), new Error(n);
  }
  _notifyReparentVetoed(e, t, n) {
    this._eventSystem?.dispatchEvent(new CustomEvent("trace-viewer:reparent-vetoed", {
      detail: {
        childName: e,
        parent: t,
        message: n
      },
      bubbles: !0,
      composed: !0
    }));
  }
  _isReparentAllowed(e, t) {
    return t && !this.canParentUnder(t) ? (this._vetoReferenceSubtreeParent(e.name, t), !1) : this._reparentPolicy ? this._reparentPolicy(e, t) : !0;
  }
  constructor(e) {
    this.babylonScene = new ps(e.engine), this.engine = e.engine, this.canvas = e.canvas, this.camera = null, this.config = e.config, this.backgroundColor = e.config.color, this.alpha = e.config.alpha || null, this.sceneObjects = [], this.resources = new Bs(), this.sceneName = "Scene", this._eventSystem = e.traceViewer || null, this.camera = st.setupCamera(this.babylonScene), this._systemValues.setCamera(this.camera), this.setupLights(), this.config.groundShadow !== !1 && (this._groundShadowEnabled = !0), e.config.playMode === !1 && (this._playMode = !1), this._occluderMode = new Cn(this.babylonScene), this._occluderMode.setPlaying(this._playMode);
  }
  getEventSystem() {
    return this._eventSystem;
  }
  getBabylonScene() {
    return this.babylonScene;
  }
  getSceneRoot() {
    return this._sceneRoot;
  }
  getDocumentRoot() {
    const e = this._sceneRoot?.getChildren() ?? [];
    return e.length === 1 ? e[0] : null;
  }
  _importMountParent() {
    return this.getSessionDocumentRoot() ?? void 0;
  }
  getSessionDocumentRoot() {
    const e = this._sessionDocumentRoot;
    return !e || !this.sceneObjects.includes(e) ? null : e.getParent() === this._sceneRoot ? e : null;
  }
  async ensureDocumentRoot(e) {
    this.initializeSceneRoot();
    const t = this._sceneRoot.getChildren(), [n] = t, s = !!n?.src && n !== this.getSessionDocumentRoot();
    return t.length === 1 && !s ? (this._sessionDocumentRoot = n, n) : this._createDocumentRoot(t, e);
  }
  _createDocumentRoot(e, t) {
    const n = this._sceneRoot, s = this.getSiblingNamesByTransform(n.transform);
    for (const o of e) s.delete(o.name);
    const r = he.generateUniqueName(t ?? this.sceneName ?? "Scene", s), i = fe.initializeSceneObject({
      name: r,
      src: void 0,
      active: !0,
      transform: {},
      behaviors: []
    }, this.babylonScene, this.resources, this.config, this, this._eventSystem || void 0);
    this.sceneObjects.push(i), this._stampNodeUid(i, "created"), i.setParent(n);
    for (const o of e) this.reparentSceneObjectPreservingWorld(o, i);
    return j.log(`[TraceScene] ensureDocumentRoot: "${r}" now holds ${e.length} top-level object(s) (SCENE_ROOT_SPEC D8)`), this._sessionDocumentRoot = i, this._emitTopologyChanged(), this._emitSceneChanged([r]), i;
  }
  async _applyExternalRootBehaviors(e) {
    e?.length && (this._sessionDocumentRoot || this._sceneRoot && await this._replaceRootBehaviors(this._sceneRoot, e));
  }
  async _replaceRootBehaviors(e, t) {
    for (const n of [...e.getBehaviors()]) e.removeBehavior(n.name);
    e._setBehaviorData(structuredClone(t)), await fe.applyComponents(e, e.name), e._attachBehaviors(), j.log(`[TraceScene] external root behaviors applied to "${e.name}": ${t.map((n) => n["@type"]).join(", ")} (SCENE_ROOT_SPEC §5.2, whole-set replace)`);
  }
  initializeSceneRoot() {
    if (this._sceneRoot) {
      j.log("[TraceScene] Scene root already initialized");
      return;
    }
    const e = {
      name: Ot,
      src: void 0,
      active: !0,
      transform: {},
      behaviors: []
    };
    this._sceneRoot = fe.initializeSceneObject(e, this.babylonScene, this.resources, this.config, this, this._eventSystem || void 0), this.sceneObjects.push(this._sceneRoot), this._ensureContactShadow(), j.log("[TraceScene] Initialized scene root");
  }
  select(e, t) {
    const n = this._selectedObject;
    e === null ? this._selectedObject = null : typeof e == "string" ? this._selectedObject = this.resolveSceneObject(e) ?? null : this._selectedObject = e, this._emitSelectionChanged(this._selectedObject, n, t), j.log(`[TraceScene] Selection changed: ${n?.name ?? null} -> ${this._selectedObject?.name ?? null}`);
  }
  getSelectedObject() {
    return this._selectedObject;
  }
  _emitSelectionChanged(e, t, n) {
    const s = this._eventSystem;
    if (!s) return;
    const r = new CustomEvent("trace-viewer:selection-changed", {
      detail: {
        object: e,
        previousObject: t,
        additive: n?.additive ?? !1
      },
      bubbles: !0,
      composed: !0
    });
    s.dispatchEvent(r), j.log("[TraceScene] Emitted trace-viewer:selection-changed event");
  }
  setPlayMode(e) {
    const t = this._playMode;
    if (this._playMode = e, this._systemValues.setPlayMode(e), this._occluderMode.setPlaying(e), j.log(`[TraceScene] Play mode: ${e ? "enabled" : "disabled"}`), e && !t && this.select(null), this._updateMeshPickability(e), this._applyClickToSelect(), e && !t) for (const n of this.sceneObjects) n.getBehavior(Ne)?.setEditorState(void 0, !0);
    if (e && (!t || !this._playModeInitialized) && (this._playModeInitialized = !0, this._fireStartInteractions()), !e && t) {
      this._cancelStartEvents(), this._fireStopScripts();
      for (const n of this.sceneObjects) {
        n.cancelTransformTransition();
        const s = n.getBehavior(Ne);
        s?.stopAllTransitions(), s?.resetStates();
      }
      os(this.babylonScene).cancelAll();
    }
    this._updateUnmanagedAnimations(e), this._emitPlayModeChanged(e), e && this._flushStartEvents();
  }
  _updateUnmanagedAnimations(e) {
    for (const t of this.sceneObjects) {
      const n = t.ownAnimationClips;
      if (n.size !== 0 && !t.getBehavior("Animation"))
        if (e) {
          const s = n.values().next().value;
          s && s.start(!0);
        } else for (const s of n.values())
          s.stop(), s.reset();
    }
  }
  refreshMeshPickability(e) {
    this._updateMeshPickability(this._playMode, e);
  }
  _updateMeshPickability(e, t) {
    const n = /* @__PURE__ */ new Set();
    for (const s of this.sceneObjects)
      n.add(s.transform), s.animationRoot && n.add(s.animationRoot);
    for (const s of t ? [t] : this.sceneObjects) {
      const r = s.transform.getChildMeshes(!1).filter((h) => {
        let v = h.parent;
        for (; v && v !== s.transform; ) {
          if (n.has(v) && v !== s.animationRoot) return !1;
          v = v.parent;
        }
        return !0;
      }), i = s.getBehavior(ts)?._getResolvedData().pickThrough === !0, o = s.getBehavior(ot), a = s.getBehavior(rt), l = r.some((h) => h.name.endsWith(it)), g = o !== null || a !== null || l, p = e && this._isGraphHost(s), m = e && (s.getBehavior(Ne)?.hasPseudoStates() ?? !1), u = e && (s.getBehavior("Moveable") !== null || s.getBehavior("Rotatable") !== null), b = e && !g && !p && !m && !u && this._hasDescendantPointerListener(s);
      j.log(`[TraceScene] _updateMeshPickability for "${s.name}": hasCollider=${g}, meshCount=${r.length}`);
      for (const h of r) {
        const v = h.name.endsWith(it), _ = h.name.endsWith(ls), y = h.name.endsWith(as);
        h.enablePointerMoveEvents = !1, e ? i ? h.isPickable = !1 : y ? h.isPickable = !0 : _ ? h.isPickable = !1 : g ? (h.isPickable = v, v && (j.log(`[TraceScene]   Collider mesh "${h.name}" isPickable=true`), (m || p) && (h.enablePointerMoveEvents = !0))) : p || m ? (h.isPickable = !0, h.enablePointerMoveEvents = !0) : u || b ? h.isPickable = !0 : h.isPickable = !1 : _ ? h.isPickable = !0 : (h.isPickable = !v, h.enablePointerMoveEvents = !1);
      }
    }
  }
  setCollidersDebugVisible(e) {
    for (const t of this.sceneObjects) {
      const n = t.getBehavior(ot), s = t.getBehavior(rt);
      n && (n.setDebugVisible(e), j.log(`[TraceScene] "${t.name}" BoxCollider debug visible: ${e}`)), s && (s.setDebugVisible(e), j.log(`[TraceScene] "${t.name}" SphereCollider debug visible: ${e}`));
    }
  }
  isPlayMode() {
    return this._playMode;
  }
  getSystemValues() {
    return this._systemValues;
  }
  setEditModeClickToSelect(e) {
    this._editModeClickToSelect = e;
  }
  _applyClickToSelect() {
    const e = this._playMode || this._editModeClickToSelect;
    this._eventSystem?.applyClickRouting?.(e);
  }
  handlePointerEvent(e, t, n, s) {
    if (this._emitPointerEvent(e, t.name, n), this._playMode) {
      if (e === "select" && n) {
        const i = this._eventSystem?.isXRActive?.() ?? !1, o = this.getRuntimeSelectionManager().isRegistered(t) || i;
        this.select(o ? t : null);
      }
      const r = t.getBehaviors();
      for (const i of r) i instanceof Ie ? e === "select" ? i.fireSelect(n) : e === "hover" && i.fireHover(n) : i.onPointerEvent(e, n);
      e === "select" && n && this._bubbleUnclaimedTap(t);
      return;
    }
    e === "select" && n && this.select(t, s);
  }
  handlePointerMiss() {
    this.select(null);
  }
  _isGraphHost(e) {
    return this._hostsLoaderGraph(e) || e.getBehavior(nt) !== null;
  }
  _hostsLoaderGraph(e) {
    return e.extensionsUsed?.includes("KHR_interactivity") === !0;
  }
  _selectGraphTargets() {
    const e = /* @__PURE__ */ new Set();
    for (const t of this.sceneObjects) {
      this._hostsLoaderGraph(t) && e.add(t);
      for (const n of t.getBehavior(nt)?.selectTargets() ?? []) e.add(n);
    }
    return e;
  }
  _claimsOwnTap(e, t) {
    return t.has(e) || this.getRuntimeSelectionManager().isRegistered(e) ? !0 : e.getBehaviors().some((n) => n instanceof Ie || n.claimsSelect());
  }
  _walkDescendantPointerListeners(e, t, n) {
    for (let s = e; s !== null; s = s.getParent()) {
      if (s !== e && t(s)) return !0;
      for (const r of s.getBehaviors()) if (r.wantsDescendantPointerEvents() && n(r, s)) return !0;
    }
    return !1;
  }
  _bubbleUnclaimedTap(e) {
    const t = this._selectGraphTargets();
    this._claimsOwnTap(e, t) || this._walkDescendantPointerListeners(e, (n) => t.has(n), (n) => n.onDescendantPointerEvent("select", !0, e));
  }
  _hasDescendantPointerListener(e) {
    return this._walkDescendantPointerListeners(e, (t) => this._isGraphHost(t), () => !0);
  }
  _fireStartInteractions() {
    j.log("[TraceScene] Firing start events");
    for (const e of this.sceneObjects) for (const t of e.getBehaviors()) t instanceof Ie && t.fireStart();
  }
  _fireStopScripts() {
    j.log("[TraceScene] Stopping script behaviors");
    for (const e of this.sceneObjects) for (const t of e.getBehaviors()) t instanceof Ie && t.fireStop();
  }
  _emitPlayModeChanged(e) {
    const t = this._eventSystem;
    if (!t) return;
    const n = new CustomEvent("trace-viewer:playmode-changed", {
      detail: { playMode: e },
      bubbles: !0,
      composed: !0
    });
    t.dispatchEvent(n), j.log(`[TraceScene] Emitted trace-viewer:playmode-changed: ${e}`);
  }
  get safeAreaInsets() {
    return this._safeAreaInsets;
  }
  setSafeAreaInsets(e) {
    this._safeAreaInsets = {
      left: e.left ?? 0,
      top: e.top ?? 0,
      right: e.right ?? 0,
      bottom: e.bottom ?? 0
    }, this._emitSafeAreaChanged();
  }
  get hasGUIFocus() {
    return this._guiFocusCount > 0;
  }
  guiFocusAcquired() {
    this._guiFocusCount++;
  }
  guiFocusReleased() {
    this._guiFocusCount = Math.max(0, this._guiFocusCount - 1);
  }
  _emitSafeAreaChanged() {
    const e = this._eventSystem;
    if (!e) return;
    const t = new CustomEvent("trace-viewer:safe-area-changed", {
      detail: { safeArea: { ...this._safeAreaInsets } },
      bubbles: !0,
      composed: !0
    });
    e.dispatchEvent(t);
  }
  _emitPointerEvent(e, t, n) {
    const s = this._eventSystem;
    if (!s) return;
    const r = new CustomEvent("trace-viewer:pointer", {
      detail: {
        type: e,
        object: t,
        isEnter: n
      },
      bubbles: !0,
      composed: !0
    });
    s.dispatchEvent(r);
  }
  getCamera() {
    return this.camera;
  }
  getAudioManager() {
    return this._audioManager || (this._audioManager = new xn(this.babylonScene)), this._audioManager;
  }
  getRuntimeSelectionManager() {
    return this._runtimeSelectionManager || (this._runtimeSelectionManager = new An(this)), this._runtimeSelectionManager;
  }
  getSceneObjects() {
    return [...this.sceneObjects];
  }
  resolveSceneObject(e, t) {
    return e ? e === "$self" ? t ?? null : e === "$parent" ? t ? t.getParent() : null : e === "$root" ? this._sceneRoot ?? null : e.startsWith("/") ? this.resolveAbsolutePath(e.slice(1)) : e.startsWith("./") ? this.resolveRelativePath(e.slice(2), t) : e.startsWith("../") ? this.resolveParentRelativePath(e, t) : this.resolveLegacyPath(e, t) : null;
  }
  getParentOf(e) {
    return e.getParent();
  }
  getFullPath(e) {
    const t = [];
    let n = e;
    for (; n; )
      t.unshift(n.name), n = n.getParent();
    return t.join("/");
  }
  getRelativePath(e, t) {
    if (!t) return e.name;
    if (e === t) return "$self";
    const n = this.getAncestorChain(t), s = this.getAncestorChain(e);
    if (s.length > n.length) {
      let o = !0;
      for (let a = 0; a < n.length; a++) if (s[a] !== n[a]) {
        o = !1;
        break;
      }
      if (o) return "./" + s.slice(n.length).map((a) => a.name).join("/");
    }
    let r = 0;
    for (let o = 0; o < Math.min(n.length, s.length) && n[o] === s[o]; o++) r = o + 1;
    const i = n.length - r;
    return "../".repeat(i) + s.slice(r).map((o) => o.name).join("/");
  }
  getAncestorChain(e) {
    const t = [];
    let n = e;
    for (; n; )
      t.unshift(n), n = n.getParent();
    return t;
  }
  resolveAbsolutePath(e) {
    if (!e) return this._sceneRoot ?? null;
    const t = e.split("/").filter((r) => r !== "");
    if (t.length === 0) return this._sceneRoot ?? null;
    let n = this._sceneRoot ?? null, s = 0;
    n && t[0] === n.name && (s = 1);
    for (let r = s; r < t.length; r++) {
      const i = this.findChildSceneObject(n, t[r]);
      if (i) n = i;
      else return null;
    }
    return n;
  }
  resolveRelativePath(e, t) {
    if (!t) return null;
    if (!e) return t;
    const n = e.split("/").filter((r) => r !== "");
    if (n.length === 0) return t;
    let s = t;
    for (const r of n) {
      const i = this.findChildSceneObject(s, r);
      if (i) s = i;
      else return null;
    }
    return s;
  }
  resolveParentRelativePath(e, t) {
    if (!t) return null;
    const n = e.split("/");
    let s = t, r = 0;
    for (; r < n.length && n[r] === ".."; ) {
      if (s = s.getParent(), !s) return null;
      r++;
    }
    if (r < n.length) {
      const i = n.slice(r).join("/");
      return this.resolveRelativePath(i, s);
    }
    return s;
  }
  resolveLegacyPath(e, t) {
    const n = this.sceneObjects.find((i) => i.name === e);
    if (n) return n;
    const s = e.split("/");
    if (s.length === 1) return null;
    const r = s[s.length - 1];
    for (const i of this.sceneObjects) if (i.name === r && this.verifyHierarchyPath(i, s))
      return i;
    return null;
  }
  findChildSceneObject(e, t) {
    if (!e) {
      for (const n of this.sceneObjects) if (n.name === t && !n.transform.parent) return n;
      return null;
    }
    for (const n of this.sceneObjects) if (n.name === t) {
      const s = n.transform.parent;
      if (s === e.transform || e.animationRoot && s === e.animationRoot) return n;
    }
    return null;
  }
  verifyHierarchyPath(e, t) {
    let n = e;
    const s = [...t].reverse();
    for (let r = 0; r < s.length; r++)
      if (!n || n.name !== s[r] || r < s.length - 1 && (n = n.getParent(), !n))
        return !1;
    return !0;
  }
  findSceneObjectByTransform(e) {
    if (!e) return;
    const t = this._transformOwnerCache.get(e);
    if (t && (t.transform === e || t.isAnimationRoot(e) || t.isAnimationLayer(e))) return t;
    for (const n of this.sceneObjects) if (n.transform === e || n.isAnimationRoot(e) || n.isAnimationLayer(e))
      return this._transformOwnerCache.set(e, n), n;
  }
  getSiblings(e) {
    return e.getSiblings();
  }
  getSiblingNames(e) {
    return new Set(e.getSiblings().map((t) => t.name));
  }
  renameSceneObject(e, t) {
    if (!t || t.includes("/") || e === this._sceneRoot) return !1;
    const n = e.name;
    if (n === t) return !0;
    const s = new Set(e.getSiblings().map((i) => i.name));
    if (s.delete(n), s.has(t)) return !1;
    e._setName(t);
    const r = this._eventSystem;
    return r && r.dispatchEvent(new CustomEvent("trace-viewer:object-renamed", {
      detail: {
        object: e,
        oldName: n,
        newName: t
      },
      bubbles: !0,
      composed: !0
    })), this._emitSceneChanged([t]), this._emitTopologyChanged(), !0;
  }
  reparentSceneObjectPreservingWorld(e, t) {
    if (!this.canParentUnder(t)) throw this._vetoReferenceSubtreeParent(e.name, t);
    const n = e.name, s = e.transform.parent, r = t.animationRoot ?? t.transform;
    if (s === r) return {
      moved: !0,
      renamed: !1,
      newName: n
    };
    if (e.transform.setParent(r), e.transform.parent === s && s !== r) return {
      moved: !1,
      renamed: !1,
      newName: n
    };
    e.refreshSceneData();
    const i = e.name;
    return {
      moved: !0,
      renamed: i !== n,
      newName: i
    };
  }
  reparentSceneObject(e, t) {
    if (!this.canParentUnder(t)) throw this._vetoReferenceSubtreeParent(e.name, t);
    const n = e.name, s = /* @__PURE__ */ new Set();
    for (const o of t.getChildren()) o !== e && s.add(o.name);
    const r = he.generateUniqueName(n, s), i = r !== n;
    if (i && e._setName(r), e.setParent(t), i) {
      const o = this._eventSystem;
      o && o.dispatchEvent(new CustomEvent("trace-viewer:object-renamed", {
        detail: {
          object: e,
          oldName: n,
          newName: r
        },
        bubbles: !0,
        composed: !0
      })), this._emitSceneChanged([r]);
    }
    return {
      renamed: i,
      newName: r
    };
  }
  _dedupeSiblingNames(e) {
    const t = new Set(e), n = new Set(e.map((s) => s.getParent()));
    for (const s of n) {
      if (!s || !this.canParentUnder(s)) continue;
      const r = s.getChildren(), i = new Set(r.map((a) => a.name)), o = new Set(r.filter((a) => !t.has(a)).map((a) => a.name));
      for (const a of r)
        t.has(a) && (o.has(a.name) && (a._setName(he.generateUniqueName(a.name, i)), i.add(a.name)), o.add(a.name));
    }
  }
  getSiblingNamesByTransform(e) {
    if (!e) return new Set(this.sceneObjects.filter((r) => !r.transform.parent).map((r) => r.name));
    const t = this.findSceneObjectByTransform(e);
    if (t) return new Set(t.getChildren().map((r) => r.name));
    const n = e.getChildren(), s = /* @__PURE__ */ new Set();
    for (const r of n) {
      const i = this.findSceneObjectByTransform(r);
      i && s.add(i.name);
    }
    return s;
  }
  async pushSceneData(e) {
    const t = this.resolveSceneObject(e.name);
    if (t) {
      j.log("Pushed scene data to scene object:", e);
      const n = await t.setData(e);
      return this._emitSceneChanged([e.name]), n;
    }
    return null;
  }
  _notifyObjectRenamed(e, t, n) {
    const s = this._eventSystem;
    s && s.dispatchEvent(new CustomEvent("trace-viewer:object-renamed", {
      detail: {
        object: e,
        oldName: t,
        newName: n
      },
      bubbles: !0,
      composed: !0
    })), this._emitSceneChanged([n]), this._emitTopologyChanged();
  }
  _emitSceneChanged(e) {
    const t = this._eventSystem;
    if (!t) return;
    let n;
    const s = () => n ??= this.getSceneDataList(), r = new CustomEvent("trace-viewer:scene-changed", {
      detail: {
        get sceneData() {
          return s();
        },
        changedObjectNames: e
      },
      bubbles: !0,
      composed: !0
    });
    t.dispatchEvent(r), j.log("[TraceScene] Emitted trace-viewer:scene-changed event");
  }
  getSceneDataList() {
    const e = [];
    return this.sceneObjects.forEach((t) => {
      const n = t.getSceneObjectData();
      e.push(n);
    }), e;
  }
  getFullExportData(e = {}) {
    const t = this._buildDocumentExportData();
    return Et(t.data, t.sceneObjects, e.exclude).data;
  }
  _buildDocumentExportData() {
    const e = this._buildExportData(), t = e.data, n = [...e.sceneObjects];
    ve.stripSceneRootPrefix(t);
    const s = this._ensureDocumentRootRecord(t);
    return s && (t.unshift(s), n.unshift(null)), this._emitStrandedRootBehaviors(t[0]), this._clearAnchorHostPose(t, n), {
      data: t,
      sceneObjects: n
    };
  }
  _clearAnchorHostPose(e, t) {
    const n = e.findIndex((o) => !o.transform?.parent), s = n >= 0 ? t[n] : null;
    if (!s) return;
    const r = new Set(s.getBehaviors().filter(ss).map((o) => o.serialize()["@type"]));
    if (r.size === 0) return;
    const i = e[n];
    i.behaviors = (i.behaviors ?? []).filter((o) => !r.has(o["@type"])), r.has("ImageAnchor") && (i.transform = {
      ...i.transform,
      translation: [
        0,
        0,
        0
      ],
      rotation: [
        0,
        0,
        0,
        1
      ],
      scale: [
        1,
        1,
        1
      ]
    });
  }
  _emitStrandedRootBehaviors(e) {
    if (!e) return;
    const t = this.getSceneRoot();
    if (!t) return;
    t.refreshSceneData();
    const n = t.serializeBehaviors({ excludeCmsManaged: !0 }) ?? [];
    n.length !== 0 && (j.warn(`[TraceScene] export: ${n.length} behavior(s) are attached to the ENGINE root (${n.map((s) => s["@type"]).join(", ")}), which is a runtime mount point and is never serialized (SCENE_ROOT_SPEC D8). Writing them on the document root "${e.name}" instead; an editor should author them there.`), e.behaviors = [...e.behaviors ?? [], ...n]);
  }
  _ensureDocumentRootRecord(e) {
    const t = e.filter((r) => !r.transform?.parent);
    if (t.length === 1) return;
    const n = new Set(e.map((r) => r.name));
    let s = this.sceneName || "Scene";
    for (let r = 2; n.has(s); r++) s = `${this.sceneName || "Scene"}_${r}`;
    j.warn(`[TraceScene] export: this session has ${t.length} top-level object(s), but a Trace document has exactly one root node (SCENE_ROOT_SPEC D8). Grouping them under "${s}" in the EXPORTED document; the live scene is unchanged. An editor should call ensureDocumentRoot() so the session and the file agree.`);
    for (const r of e) r.transform?.parent ? r.transform.parent = `${s}/${r.transform.parent}` : r.transform = {
      ...r.transform ?? {},
      parent: s
    };
    return {
      name: s,
      active: !0,
      transform: {},
      behaviors: []
    };
  }
  getExportData(e = {}) {
    const t = this._buildExportData();
    return Et(t.data, t.sceneObjects, e.exclude).data;
  }
  _buildExportData() {
    const e = this.getSceneRoot();
    if (!e) return {
      data: [],
      sceneObjects: []
    };
    const t = ve._filterDescendantsOfReferenceNodes(e.getDescendants());
    for (const r of t) r.refreshSceneData && r.refreshSceneData();
    const n = this.topologicalSortForExport(t), s = [];
    for (const r of n) {
      const i = r.getSceneObjectData();
      if (i.transform) {
        const o = r.getParent();
        o ? i.transform.parent = this.getFullPath(o) : delete i.transform.parent;
      }
      s.push(i);
    }
    return {
      data: s,
      sceneObjects: n
    };
  }
  getExportDataForSubtree(e) {
    return this._buildExportDataForSubtree(e).data;
  }
  _buildExportDataForSubtree(e) {
    const t = [e, ...ve._filterDescendantsOfReferenceNodes(e.getDescendants())], n = new Set(t);
    for (const l of t) l.refreshSceneData && l.refreshSceneData();
    const s = this.topologicalSortForExport(t), r = this.getFullPath(e), i = r.lastIndexOf("/"), o = i >= 0 ? r.slice(0, i + 1) : "", a = [];
    for (const l of s) {
      const g = l.getSceneObjectData();
      if (g.transform) {
        const p = l.getParent();
        if (p && n.has(p)) {
          const m = this.getFullPath(p);
          g.transform.parent = o ? m.slice(o.length) : m;
        } else delete g.transform.parent;
      }
      a.push(g);
    }
    return {
      data: a,
      sceneObjects: s
    };
  }
  _buildExportDataForSubtrees(e, t) {
    const n = e.filter((a, l) => e.indexOf(a) === l && !e.some((g) => g !== a && ve._isDescendantOf(a, g)));
    if (n.length === 0) throw new Error("Nothing to export: the subtree list is empty.");
    const s = [], r = [];
    t && (s.push({
      name: t,
      transform: {
        translation: [
          0,
          0,
          0
        ],
        rotation: [
          0,
          0,
          0,
          1
        ],
        scale: [
          1,
          1,
          1
        ]
      }
    }), r.push(null));
    const i = this.getSceneRoot(), o = /* @__PURE__ */ new Set();
    for (const a of n) {
      const l = this._buildExportDataForSubtree(a), g = l.sceneObjects.indexOf(a);
      if (g === -1) continue;
      const p = l.data[g], m = p.name, u = he.generateUniqueName(m, o);
      o.add(u);
      for (let b = 0; b < l.data.length; b++) {
        const h = l.data[b], v = h.transform?.parent;
        if (v !== void 0) {
          const _ = v.slice(m.length);
          h.transform.parent = t ? `${t}/${u}${_}` : `${u}${_}`;
        } else b === g && (t && (h.transform = {
          ...h.transform ?? {},
          parent: t
        }), (n.length > 1 || t) && this._writeSceneRootFrameTransform(h, a, i));
      }
      p.name = u, s.push(...l.data), r.push(...l.sceneObjects);
    }
    return {
      data: s,
      sceneObjects: r
    };
  }
  static _isDescendantOf(e, t) {
    for (let n = e.getParent(); n; n = n.getParent()) if (n === t) return !0;
    return !1;
  }
  _writeSceneRootFrameTransform(e, t, n) {
    let s = Ze.Identity();
    for (let l = t.getParent(); l && l !== n; l = l.getParent()) s = s.multiply(ve._authoredMatrix(l));
    const r = ve._authoredMatrix(t).multiply(s), i = _e.Zero(), o = we.Identity(), a = _e.One();
    r.decompose(a, o, i), e.transform = {
      ...e.transform ?? {},
      translation: [
        i.x,
        i.y,
        i.z
      ],
      rotation: [
        o.x,
        o.y,
        o.z,
        o.w
      ],
      scale: [
        a.x,
        a.y,
        a.z
      ]
    };
  }
  static _authoredMatrix(e) {
    e.refreshSceneData?.();
    const t = e.getSceneObjectData().transform, n = t?.translation ?? [
      0,
      0,
      0
    ], s = t?.rotation ?? [
      0,
      0,
      0,
      1
    ], r = t?.scale ?? [
      1,
      1,
      1
    ];
    return Ze.Compose(new _e(r[0], r[1], r[2]), new we(s[0], s[1], s[2], s[3]), new _e(n[0], n[1], n[2]));
  }
  static _filterDescendantsOfReferenceNodes(e) {
    const t = new Set(e), n = /* @__PURE__ */ new Set(), s = [];
    for (const r of e) {
      let i = r.getParent(), o = !1;
      for (; i && t.has(i); ) {
        if (n.has(i) || i.isSceneReference) {
          o = !0;
          break;
        }
        i = i.getParent();
      }
      o ? n.add(r) : s.push(r);
    }
    return s;
  }
  static stripSceneRootPrefix(e, t = Ot) {
    for (const n of e) n.transform?.parent === t ? delete n.transform.parent : n.transform?.parent?.startsWith(t + "/") && (n.transform.parent = n.transform.parent.slice(t.length + 1));
  }
  topologicalSortForExport(e) {
    const t = [], n = /* @__PURE__ */ new Set(), s = new Set(e), r = (i) => {
      if (n.has(i)) return;
      n.add(i);
      const o = i.getParent();
      o && s.has(o) && r(o), t.push(i);
    };
    for (const i of e) r(i);
    return t;
  }
  setupLights() {
    const e = new gs("keyLight", new _e(-0.5, -0.766, -0.406), this.babylonScene);
    e.diffuse = new ft(1, 0.96, 0.84), e.intensity = 3, this._applyEnvironmentImage();
  }
  _applyEnvironmentImage() {
    const e = this.config.environmentImage ?? "https://storageacceausprod.blob.core.windows.net/trace-cms-assets/environment/neutral.hdr", t = this.babylonScene.environmentTexture, n = !!e && t instanceof pt && t.url === e;
    if (t && !n && this.disposeEnvironmentTexture(t), e) {
      if (!n) {
        let s;
        s = new pt(e, this.babylonScene, 512, !1, !0, !0, !1, null, () => {
          this.babylonScene.environmentTexture === s && this.disposeEnvironmentTexture(s);
        }), this.babylonScene.environmentTexture = s;
      }
      this.babylonScene.iblIntensity = 0.5;
    }
  }
  disposeEnvironmentTexture(e) {
    const t = e.getInternalTexture();
    t && !t.isReady && this.babylonScene.removePendingData(t), e.dispose(), this.babylonScene.environmentTexture === e && (this.babylonScene.environmentTexture = null);
  }
  setEnvironmentImage(e) {
    this.config.environmentImage = e ?? void 0, this._applyEnvironmentImage();
  }
  setGroundShadowEnabled(e) {
    this._groundShadowEnabled = e, e ? this._ensureContactShadow() : (this._contactShadow?.dispose(), this._contactShadow = null);
  }
  get groundShadowEnabled() {
    return this._groundShadowEnabled;
  }
  setGroundHeight(e) {
    this._contactShadow?.setGroundHeight(e);
  }
  setShadowPosition(e) {
    this._contactShadow?.setPosition(e);
  }
  _ensureContactShadow() {
    if (!(!this._groundShadowEnabled || this._contactShadow) && (this._contactShadow = new kn(this.babylonScene, this.engine, this.config.groundHeight), this._sceneRoot)) {
      const e = this._contactShadow;
      this._sceneRoot.transform.onAfterWorldMatrixUpdateObservable.add(() => {
        e.syncToTransform(this._sceneRoot.transform);
      });
    }
  }
  _alignShadowToContentBottom() {
    if (!this._contactShadow || !this._sceneRoot) return;
    let e = 1 / 0;
    for (const t of this._sceneRoot.getChildren()) for (const n of t.transform.getChildMeshes(!1)) {
      if (n.name.startsWith("__shadow") || n.name.endsWith("__collider") || n.name.endsWith("__selection") || !n.isVisible || !n.isEnabled()) continue;
      n.computeWorldMatrix(!0);
      const s = n.getBoundingInfo().boundingBox;
      s.minimumWorld.equals(s.maximumWorld) || s.minimumWorld.y < e && (e = s.minimumWorld.y);
    }
    isFinite(e) && this.setGroundHeight(e - 2e-3);
  }
  _stampNodeUid(e, t) {
    if (!this._uidMintingActive) {
      e._setUidInternal(void 0), this._mintedHere.delete(e);
      return;
    }
    const n = e.uid, s = n !== void 0 && dt(n) && (t === "loaded" || !this._uidIsLive(n, e));
    e._setUidInternal(s ? n : ht()), s ? this._mintedHere.delete(e) : this._mintedHere.add(e);
  }
  _mintedHere = /* @__PURE__ */ new WeakSet();
  _copiesBuilding = /* @__PURE__ */ new WeakSet();
  _isInCopyBeingBuilt(e) {
    for (let t = e; t; t = t.getParent()) if (this._copiesBuilding.has(t)) return !0;
    return !1;
  }
  _uidIsLive(e, t) {
    return this.sceneObjects.some((n) => n !== t && n.uid === e);
  }
  _remintPromotedUids(e) {
    if (!this._uidMintingActive) return [];
    const t = [];
    for (const n of e) {
      const s = this._mintedHere.has(n) ? void 0 : n.uid, r = ht();
      n._setUidInternal(r), this._mintedHere.add(n), t.push({
        object: n,
        uid: r,
        ...s !== void 0 ? { sourceUid: s } : {}
      });
    }
    return t;
  }
  _placedUidsFor(e) {
    if (e.length === 0) return;
    const t = new Set(e.map((i) => i.object)), n = new Map(e.map((i) => [i.object, i.sourceUid])), s = (i) => {
      const o = [];
      let a = i, l = -1;
      for (; a && t.has(a); )
        o.push(a), a.isSceneReference && (l = o.length - 1), a = a.getParent();
      const g = o.slice(0, l >= 0 ? l + 1 : 1), p = [];
      for (let m = g.length - 1; m >= 0; m--) {
        const u = n.get(g[m]);
        if (!u) return "";
        p.push(u);
      }
      return p.join("/");
    }, r = {};
    for (const { object: i, uid: o } of e) {
      const a = s(i);
      a && (r[o] = a);
    }
    return Object.keys(r).length > 0 ? r : void 0;
  }
  _nameSceneAfter(e, t) {
    t && this.sceneName === "Scene" && e && !this.getSessionDocumentRoot() && (this.sceneName = e);
  }
  async loadSceneObjects(e, t, n, s = !1) {
    if (t?.length && e.length > 0) {
      const i = e[0];
      i.behaviors = [...i.behaviors ?? [], ...t];
    }
    fe.migrateV1CrossObjectBehaviors(e);
    const r = [];
    for (const i of e) {
      const o = fe.initializeSceneObject(i, this.babylonScene, this.resources, this.config, this, this._eventSystem || void 0);
      this._stampNodeUid(o, "loaded"), this._nameSceneAfter(i.name, s), this.sceneObjects.push(o), r.push(o);
    }
    for (const i of r) {
      const o = i._getParentPath();
      if (o) {
        const a = this.resolveSceneObject(o);
        a && i.setParent(a);
      } else {
        const a = n ?? this._sceneRoot;
        a && i.setParent(a);
      }
    }
    this._beginConstruction();
    try {
      await Promise.all(r.map((i) => fe.applyComponents(i, i.name)));
      for (const i of r) i._attachBehaviors();
    } finally {
      this._endConstruction();
    }
    return this._emitTopologyChanged(), r;
  }
  _applyAssetKeyRemap(e, t) {
    for (const n of e.nodes)
      n.src = ze(n.src, t), Bt(n.behaviors, t);
    if (e.scripts) for (const [n, s] of Object.entries(e.scripts)) e.scripts[n] = ze(s, t);
  }
  async loadFromPluginResult(e, t, n, s, r = !1, i = !1) {
    this._beginConstruction();
    try {
      return await this._loadFromPluginResultInner(e, t, n, s, r, i);
    } finally {
      this._endConstruction();
    }
  }
  async _loadFromPluginResultInner(e, t, n, s, r = !1, i = !1) {
    const o = e.documentRoot ?? (e.rootNodes?.length === 1 ? e.rootNodes[0] : void 0);
    s?.length && o && (o.behaviors = s, j.log(`[TraceScene] loadFromPluginResult: external behaviors replaced on ${o.name}: ${s.map((g) => g["@type"]).join(", ")}`)), zs(e.nodes);
    const a = [];
    for (let g = 0; g < e.nodes.length; g++) {
      const p = e.nodes[g], m = Xt(p.src, p.behaviors, this, p.name, p.uid), u = Jt.fromLoadedTransform(p.transform, p.name, this.babylonScene, this.resources, this.config, this, {
        behaviors: p.behaviors,
        active: p.active,
        src: m,
        resetAssetTransform: p.resetAssetTransform,
        sceneRef: p.sceneRef,
        srcName: p.srcName,
        assetInstantiated: p.assetInstantiated,
        foreign: p.foreign,
        uid: p.uid,
        animationBinding: p.animationBinding
      }, this._eventSystem || void 0);
      this._stampNodeUid(u, "loaded"), this._nameSceneAfter(p.name, i), p.srcUrl && m && m === p.src && this.resources.registerAssetUrl(m, p.srcUrl), p.srcName && m && this.resources.registerAssetName(m, p.srcName);
      for (const [b, h] of p.animationSourceUrls ?? []) this.resources.registerAssetUrl(b, h);
      p.assetInstantiated && p.animationGroups?.length && u.setAnimationClips(p.animationGroups), this.sceneObjects.push(u), a.push(u);
    }
    const l = n ?? this._sceneRoot;
    if (l)
      for (const g of a) g.transform.parent || (g.setParent(l), r && this._preserveAuthoredWorldRotation(g, l));
    this._playMode || this._dedupeSiblingNames(a);
    for (const g of a) g._beginBehaviorLoad();
    try {
      const g = a.filter((b) => b.isSceneReference), p = 2, m = g.length * p + a.length;
      t?.onStart(m);
      let u = 0;
      for (const b of g) {
        try {
          j.log(`[TraceScene] Loading nested scene asset: ${b.src} for ${b.name}`);
          const h = t ? {
            onStart: (v) => {
            },
            onProgress: (v, _) => {
              const y = _ > 0 ? v / _ : 0, R = u + 1 + y;
              t.onProgress(R, m);
            },
            onComplete: () => {
            }
          } : void 0;
          await this._loadFromURL(b.src, void 0, b, t ? (v, _) => {
            const y = _ > 0 ? Math.min(1, v / _) : 0;
            t.onProgress(u + y, m);
          } : void 0, h);
        } catch (h) {
          j.error(`[TraceScene] Failed to load nested scene asset ${b.src} for ${b.name}:`, h);
        }
        u += p, t?.onProgress(u, m);
      }
      fe.migrateV1CrossObjectBehaviorsOnObjects(a), await Promise.all(a.map((b) => fe.applyComponents(b, b.name).then(() => {
        u++, t?.onProgress(u, m);
      })));
      for (const b of a) b._attachBehaviors();
    } finally {
      for (const g of a) g._endBehaviorLoad();
    }
    return this._emitTopologyChanged(), t?.onComplete(), a;
  }
  async _registerImportedFile(e, t, n, s) {
    const r = await this.resources.addAssetWithDedup(`assets/${e}`, t);
    return this.resources.registerAssetName(r, e), n && this.resources.registerUrlMapping(n, r), s && (this.resources.registerAssetBaseUrl(r, s), this.resources.registerAssetSourceUrl(r, `${s}${e}`)), r;
  }
  async _fillReferenceWithFile(e, t, n, s, r, i) {
    const o = await this._registerImportedFile(t, s, r, i);
    return i && this.resources.registerAssetUrl(o, `${i}${t}`), e._standInFileSrc = `./${o}`, rs(n, e), j.log(`[TraceScene] Reference ${e.name} resolved to a file (${t}) — the placement owns it`), e;
  }
  async loadSingle3DAsset(e, t, n, s, r, i, o, a, l, g = !1, p, m = !1) {
    i?.onStart(1);
    const u = await this._registerImportedFile(n, s, o, l), b = o ?? `./${u}`, h = {
      transform: new Pt(t, this.babylonScene),
      name: t,
      src: b,
      active: !0
    }, v = {
      nodes: [h],
      rootNodes: [h],
      nodeMap: /* @__PURE__ */ new Map([[t, h]])
    }, _ = Yt(a, tt(r));
    j.log(`[TraceScene] loadSingle3DAsset: ${t} passing ${_?.length ?? 0} behaviors to loadFromPluginResult`);
    const y = await this.loadFromPluginResult(v, i, p, _, g, m);
    return j.log(`[TraceScene] Loaded single ${r} asset: ${t} (src: ${b})`), y[0] ?? null;
  }
  async fetchAsset(e, t) {
    const { blob: n, fileName: s, assetBaseUrl: r } = await this.fetchAssetWithProgress(e, void 0, t);
    return {
      blob: n,
      fileName: s,
      extension: he.getFileExtensionFromSrc(s),
      assetBaseUrl: r
    };
  }
  async attachDocumentFromUrl(e, t, n) {
    const s = this._documentMountParent(t, "attachDocumentFromUrl"), { blob: r, fileName: i, assetBaseUrl: o } = await this.fetchAsset(e), a = e.startsWith("http") ? e : void 0, { sceneObject: l, documentRoot: g } = await this._loadFromBlob(r, i, n, void 0, s, a, void 0, o, !1, !1);
    return g ?? l;
  }
  async attachDocumentFromBlob(e, t, n) {
    const s = this._documentMountParent(n, "attachDocumentFromBlob"), { sceneObject: r, documentRoot: i } = await this._loadFromBlob(e, t, void 0, void 0, s, void 0, void 0, void 0, !1, !0);
    return i ?? r;
  }
  _documentMountParent(e, t) {
    this.initializeSceneRoot();
    const n = e ?? this._importMountParent() ?? this._sceneRoot ?? void 0;
    if (!n) throw new Error(`${t}: the scene has no root to mount the document under`);
    return n;
  }
  async loadAsset(e, t, ...n) {
    if (typeof e == "string") {
      const s = t, { behaviors: r, options: i } = Tt(n), { blob: o, fileName: a, assetBaseUrl: l } = await this.fetchAsset(e), g = e.startsWith("http") ? e : void 0, { sceneObject: p, wrapsFile: m } = await this._loadFromBlob(o, a, s, void 0, void 0, g, r, l, !1, !0, !0);
      return this._unpackImportedScene(p, a, s, r, i, m);
    } else {
      const s = t;
      if (!s) throw new Error("fileName is required when loading from Blob");
      const { name: r, behaviors: i, options: o } = Tt(n), { sceneObject: a, wrapsFile: l } = await this._loadFromBlob(e, s, r, void 0, void 0, void 0, i, void 0, !1, !0, !0);
      return this._unpackImportedScene(a, s, r, i, o, l);
    }
  }
  async _unpackImportedScene(e, t, n, s, r, i) {
    return !e || !r?.unpack || !es(t) && !e.isSceneReference && !e.contentRef || !i ? e : (await this._dissolveReference(e, {
      ...n !== void 0 ? { name: n } : {},
      ...s ? { behaviors: s } : {},
      ...r.intoFolder ? { intoFolder: r.intoFolder } : {}
    })).object;
  }
  async unpackReference(e, t = {}) {
    return !e.isSceneReference && !e.contentRef ? (j.warn(`[TraceScene] unpackReference: "${e.name}" is not a reference — nothing to unpack.`), {
      object: e,
      unpacked: !1,
      copied: /* @__PURE__ */ new Map(),
      orphaned: []
    }) : this._dissolveReference(e, t);
  }
  async placeCopy(e, t, n = {}) {
    if (!/^https?:\/\//i.test(e)) throw new Error(`placeCopy: "${e}" is not an absolute asset URL`);
    if (n.uid !== void 0 && !dt(n.uid)) throw new Error(`placeCopy: "${n.uid}" is not a valid uid`);
    if (!this.canParentUnder(t)) throw this._vetoReferenceSubtreeParent(n.name ?? e, t);
    const s = {
      parent: t,
      made: []
    }, r = () => {
      for (const a of s.made) a.transform.isDisposed() || this.deleteSceneObject(a);
    };
    let i;
    try {
      const { blob: a, fileName: l, assetBaseUrl: g } = await this.fetchAsset(e);
      ({ sceneObject: i } = await this._loadFromBlob(a, l, n.name, void 0, void 0, e, void 0, g, !1, !0, !1, s));
    } catch (a) {
      throw r(), a;
    }
    if (!i || !i.isSceneReference || i.getParent() !== t)
      throw r(), new Error(`placeCopy: "${e}" did not resolve to a document`);
    const o = i.getDescendants().filter((a) => a.isSceneReference && a._standInFileSrc === void 0 && a.getChildren().length === 0);
    if (o.length > 0)
      throw r(), new Error(`placeCopy: ${o.map((a) => `"${a.name}"`).join(", ")} in "${e}" did not load`);
    s.made.push(...i.getChildren()), this._copiesBuilding.delete(i);
    try {
      const a = await this._dissolveReference(i, {
        ...n.name !== void 0 ? { name: n.name } : {},
        ...n.intoFolder ? { intoFolder: n.intoFolder } : {}
      }, !1);
      if (!a.unpacked || !a.object) throw new Error(`placeCopy: a reparent policy refused to unpack "${e}"`);
      const l = a.object;
      l._beginBehaviorLoad();
      try {
        n.uid !== void 0 && this._uidMintingActive && l._setUidInternal(n.uid);
        for (const g of n.behaviors ?? []) {
          const { "@type": p, ...m } = g;
          await l.setBehavior(p, m);
        }
      } finally {
        l._endBehaviorLoad();
      }
      return l;
    } catch (a) {
      throw r(), a;
    }
  }
  async _hydrateReference(e) {
    if (!e.src || e.getChildren().length > 0) return !0;
    e._setSceneRefInternal(!0), e._beginBehaviorLoad();
    try {
      return await this._loadFromURL(e.src, void 0, e), !0;
    } catch (t) {
      j.error(`[TraceScene] Failed to rebuild reference ${e.src} for ${e.name}:`, t);
      for (const n of e.getChildren()) this.deleteSceneObject(n);
      return !1;
    } finally {
      e._endBehaviorLoad();
    }
  }
  async _dissolveReference(e, t = {}, n = !0) {
    const s = /* @__PURE__ */ new Map(), r = [], i = e.getParent(), o = e.getChildren(), a = /^https?:\/\//i.test(e.src) ? e.src : void 0, l = new Set((t.behaviors ?? []).map((b) => b["@type"])), g = e.getBehaviors().every((b) => b.name === "Provenance" || l.has(b.name));
    if (i && o.length === 1 && g) {
      const b = o[0], h = b.name, { moved: v } = this.reparentSceneObjectPreservingWorld(b, i);
      if (!v)
        return j.warn(`[TraceScene] unpack: a reparent policy refused to move "${b.name}" out of its file wrapper — leaving the import as a reference`), {
          object: e,
          unpacked: !1,
          copied: s,
          orphaned: r
        };
      this.deleteSceneObject(e), b.name !== h && !b.getSiblings().some((R) => R !== b && R.name === h) && this.renameSceneObject(b, h);
      for (const R of t.behaviors ?? []) {
        const { "@type": k, ...x } = R;
        await b.setBehavior(k, x);
      }
      if (t.name) {
        const R = new Set(b.getSiblings().map((k) => k.name));
        R.delete(b.name), this.renameSceneObject(b, he.generateUniqueName(t.name, R));
      }
      this._dedupeSiblingNames(b.getDescendants());
      const _ = this._remintPromotedUids([b, ...b.getDescendants()]), y = n ? this._placedUidsFor(_) : void 0;
      return (a || y) && await b.setBehavior("Provenance", {
        ...a ? { placedFrom: a } : {},
        ...y ? { placedUids: y } : {}
      }), await this._adoptReferencedFolderFiles(b, t.intoFolder, s, r), {
        object: b,
        unpacked: !0,
        copied: s,
        orphaned: r
      };
    }
    const p = e._standInFileSrc;
    await this._adoptReferencedFolderFiles(e, t.intoFolder, s, r);
    const m = this._remintPromotedUids(e.getDescendants()), u = n ? this._placedUidsFor(m) : void 0;
    if (p !== void 0 && s.has(p) || e._setSrcInternal(""), e._setSceneRefInternal(!1), this._dedupeSiblingNames(e.getDescendants()), (a || u) && await e.setBehavior("Provenance", {
      ...a ? { placedFrom: a } : {},
      ...u ? { placedUids: u } : {}
    }), t.name && e.name !== t.name) {
      const b = new Set(e.getSiblings().map((h) => h.name));
      b.delete(e.name), this.renameSceneObject(e, he.generateUniqueName(t.name, b));
    }
    return {
      object: e,
      unpacked: !0,
      copied: s,
      orphaned: r
    };
  }
  async _adoptReferencedFolderFiles(e, t, n, s) {
    const r = [], i = (o, a) => {
      const l = !a && (o.isSceneReference || o.contentRef !== null || o._standInFileSrc !== void 0), g = l ? o.src : o._standInFileSrc || o.src;
      if (g && r.push({
        object: o,
        source: g
      }), !l)
        for (const p of o.getChildren()) i(p, !1);
    };
    i(e, !0);
    for (const { object: o, source: a } of r) {
      const l = this.resources.resolveAssetUrl(a);
      if (!l) continue;
      if (!t) {
        s.includes(a) || s.push(a);
        continue;
      }
      let g = n.get(a);
      if (g === void 0) {
        try {
          const p = await fetch(l);
          if (!p.ok) throw new Error(`${p.status} ${p.statusText}`);
          const m = this.resources.getAssetName(a), u = m ?? a.slice(a.lastIndexOf("/") + 1);
          g = await t.upload(await p.blob(), u), this.resources.registerAssetName(g, m);
        } catch (p) {
          j.warn(`[TraceScene] unpack: could not copy "${a}" (${l}) into this scene's folder`, p), s.includes(a) || s.push(a);
          continue;
        }
        n.set(a, g);
      }
      o._setSrcInternal(g), a === o._standInFileSrc && (o._standInFileSrc = void 0), this.resources.registerAssetUrl(g, l);
    }
    s.length > 0 && j.warn(`[TraceScene] unpack: ${s.length} file(s) belong to the referenced folder and were not copied into this scene, so this scene cannot save them. Pass \`intoFolder\` (the "Copy to scene" uploader) to bring the bytes across: ${s.join(", ")}`);
  }
  async _loadFromURL(e, t, n, s, r) {
    const i = this.resources.isLocal(e) ? this.resources.getAsset(e) : void 0, o = this.resources.resolveAssetUrl(e) ?? e, { blob: a, fileName: l, assetBaseUrl: g } = i ? {
      blob: i,
      fileName: e.substring(e.lastIndexOf("/") + 1),
      assetBaseUrl: void 0
    } : s ? await this.fetchAssetWithProgress(o, s) : await this.fetchAsset(o), p = o.startsWith("http") ? o : void 0, { sceneObject: m } = await this._loadFromBlob(a, l, t, r, n, p, void 0, g, !1, !0).finally(() => {
      n?.transform.isDisposed() && this._deleteBeneath(n);
    });
    return m;
  }
  _deleteBeneath(e) {
    const t = (n) => {
      for (let s = n.transform.parent; s; s = s.parent) if (s === e.transform) return !0;
      return !1;
    };
    for (const n of this.sceneObjects.filter(t)) n.transform.isDisposed() || this.deleteSceneObject(n);
  }
  async _placeReferencedDocument(e, t, n, s, r, i, o = !1, a) {
    const l = a?.parent ?? this._importMountParent() ?? this._sceneRoot ?? void 0, g = s ?? (e.rootNodes.length === 1 ? e.rootNodes[0].name : void 0) ?? t.replace(/\.[^/.]+$/, ""), p = he.generateUniqueName(g, this.getSiblingNamesByTransform(l?.transform ?? null)), m = fe.initializeSceneObject({
      name: p,
      src: "",
      active: !0,
      transform: {},
      behaviors: i ? structuredClone(i) : []
    }, this.babylonScene, this.resources, this.config, this, this._eventSystem || void 0);
    this.sceneObjects.push(m), this._stampNodeUid(m, "created"), l && m.setParent(l), a?.made.push(m), a && this._copiesBuilding.add(m), m._setSceneRefInternal(!0), m._beginBehaviorLoad();
    try {
      await this.loadFromPluginResult(e, r, m, void 0, !1), await fe.applyComponents(m, m.name);
    } finally {
      m._endBehaviorLoad();
    }
    return m._attachBehaviors(), o && l && this._preserveAuthoredWorldRotation(m, l), m._setSrcInternal(n), j.log(`[TraceScene] Placed reference "${p}" → ${n} with ${e.rootNodes.length} document root(s) beneath it`), this._emitTopologyChanged(), {
      sceneObject: m,
      wrapsFile: !0
    };
  }
  async _loadFromBlob(e, t, n, s, r, i, o, a, l, g, p = !1, m) {
    j.log(`[TraceScene] _loadFromBlob: ${t} with ${o?.length ?? 0} extra behaviors`), this.initializeSceneRoot();
    const u = he.getFileExtensionFromSrc(t);
    this._sourceFormat = u.toLowerCase();
    const b = !r && !g;
    b && (this._sceneSourceFormat = this._sourceFormat);
    let h = vn(u), v, _;
    if (!h && is(u) && (v = await ds(e), v && hs(v) ? h = $t() : v = void 0), (!h || u === "zip") && (_ = Ut(await e.arrayBuffer()), mn(_, Me) && (h && j.log(`[TraceScene] "${t}" is a bundle (scene document at the archive root), not a legacy .${u}`), h = yn(), this._sourceFormat = "glz", b && (this._sceneSourceFormat = "glz"))), h) {
      const O = h.createPlugin(), q = v ?? _ ?? (h.dataType === "text" ? await e.text() : await e.arrayBuffer()), J = h.needsRootUrl && a || "";
      if (v && J && Array.isArray(v.files)) for (const te of v.files) {
        const oe = te?.uri;
        if (typeof oe != "string" || !this.resources.isLocal(oe)) continue;
        const ne = us(oe, J);
        ne !== oe && this.resources.registerAssetUrl(oe, ne);
      }
      const C = O instanceof Xe ? O : null;
      C?.setExternalAssetLookup((te) => this.resources.resolveExternalAssetBlob(te)), C?.setOpenAsScene(!!l);
      const F = await O.loadWithResult(this.babylonScene, q, J, void 0, t);
      if (O instanceof Nt && (this.sourceInfoFile = O.getSourceInfoFile() ?? void 0), F.assetBlobs) {
        if (g) {
          const te = this.resources.mergeSceneAssets(F.assetBlobs, n ?? t, i);
          this._applyAssetKeyRemap(F, te), await Fs(F.nodes, this.resources, te);
        } else for (const [te, oe] of F.assetBlobs) this.resources.addAsset(te, oe);
        j.log(`[TraceScene] Stored ${F.assetBlobs.size} assets in ResourceManager`);
      }
      if (!r && !g && F.foreignDocument && (this._foreignDocument = F.foreignDocument), F.scripts) {
        this._scriptsMap = F.scripts;
        for (const [te, oe] of Object.entries(F.scripts)) {
          const ne = this.resources.getAsset(oe);
          if (ne) {
            const ie = await ne.text();
            this._scriptRegistry.register(te, ie);
          } else j.warn(`[TraceScene] Script asset not found: ${oe} for @type "${te}"`);
        }
      }
      const d = r ?? (l ? void 0 : this._importMountParent());
      if (!r && !l && i && (this.placementRuleActive || m)) return await this._placeReferencedDocument(F, t, i, n, s, o, p, m);
      const D = !r && F.rootNodes.length === 1 ? F.rootNodes[0] : void 0, ee = !!D && !D.src, U = ee || !!D && !ee && v !== void 0, se = !l && U, W = !!i && se, Q = !!D?.src && (!F.documentRoot && !U || F.nodes.length === 1), P = l && Q ? void 0 : o, T = await this.loadFromPluginResult(F, s, d, P, p, b);
      r && ns(r), j.log(`[TraceScene] Loaded .${u} with ${F.nodes.length} nodes via plugin`);
      const X = F.documentRoot ?? (F.rootNodes.length === 1 ? F.rootNodes[0] : void 0), V = X ? F.nodes.indexOf(X) : -1, H = V >= 0 ? T[V] ?? null : null;
      if (l && H && !Q && (this._sessionDocumentRoot = H), l && Q && H && o?.length) {
        const te = this._createDocumentRoot([H]);
        await this._replaceRootBehaviors(te, o);
      }
      if (n && !r && !l && !i && H && this.renameSceneObject(H, he.generateUniqueName(n, new Set(H.getSiblings().map((te) => te.name)))), W && i) {
        const te = T[0];
        te && te.src && te.src !== i && (te._standInFileSrc = te.src), te?._setSrcInternal(i), te?._setSceneRefInternal(!0);
      }
      return {
        sceneObject: T[0] ?? null,
        documentRoot: H,
        wrapsFile: se
      };
    }
    if (m) throw new Error(`placeCopy: "${i ?? t}" did not resolve to a document`);
    if (!at.has(u)) throw new Error(`Unsupported file type: ${u}. Supported: ${[...at].join(", ")}`);
    const y = r ?? (l ? void 0 : this._importMountParent()), R = this.getSiblingNamesByTransform((y ?? this._sceneRoot)?.transform ?? null), k = he.generateUniqueName(n || t.replace(/\.[^/.]+$/, ""), R);
    if (r && (this.placementRuleActive || !ct.has(u) || this._isInCopyBeingBuilt(r))) return { sceneObject: await this._fillReferenceWithFile(r, t, u, e, i, a) };
    if (ct.has(u)) {
      const O = URL.createObjectURL(e);
      try {
        return { sceneObject: await this.loadSingle3DAsset(O, k, t, e, u, s, i, o, a, p, y, b) };
      } finally {
        URL.revokeObjectURL(O);
      }
    }
    const x = await this._registerImportedFile(t, e, i, a), z = Qs(i ?? `./${x}`, k);
    z.behaviors = tt(u);
    const B = (await this.loadSceneObjects([z], o, y, b))[0], $ = y ?? this._sceneRoot;
    return p && B && $ && B.getParent() === $ && this._preserveAuthoredWorldRotation(B, $), j.log(`Loaded ${u} asset: ${t} as ${k}`), { sceneObject: B ?? null };
  }
  async loadFromURL(e, t, n) {
    if (!e) throw new Error("Please provide a valid URL");
    try {
      const { blob: s, fileName: r, assetBaseUrl: i } = await this.fetchAsset(e);
      await this._loadFromBlob(s, r, void 0, t, void 0, void 0, n, i, !0), await this._applyExternalRootBehaviors(n), await this.startScene();
    } catch (s) {
      throw this.babylonScene.isDisposed || j.error("Error loading from URL:", s), s;
    }
  }
  async loadFromBlob(e, t, n, s, r) {
    if (!e || !t) throw new Error("Please provide a valid blob and fileName");
    try {
      await this._loadFromBlob(e, t, void 0, n, void 0, void 0, s, r, !0), await this._applyExternalRootBehaviors(s), await this.startScene();
    } catch (i) {
      throw this.babylonScene.isDisposed || j.error("Error loading from Blob:", i), i;
    }
  }
  async fetchAssetWithProgress(e, t, n) {
    const s = n?.revalidate ? {
      ...this.fetchInit ?? {},
      cache: "no-cache"
    } : this.fetchInit ?? void 0, r = await fetch(e, s);
    if (this.babylonScene.isDisposed) throw lt();
    if (!r.ok) throw new Error(`Failed to fetch asset: ${r.status} ${r.statusText} (${e})`);
    const i = (r.url || new URL(e, window.location.href).href).split("?")[0], o = i.lastIndexOf("/"), a = o >= 0 ? i.substring(0, o + 1) : "", l = r.headers.get("Content-Length"), g = l ? parseInt(l, 10) : 0, p = performance.now();
    let m;
    if (t && r.body) {
      const h = r.body.getReader();
      let v = 0;
      const _ = [];
      try {
        for (; ; ) {
          const { done: R, value: k } = await h.read();
          if (R) break;
          _.push(k), v += k.length, t(v, g);
        }
      } finally {
        h.releaseLock();
      }
      const y = r.headers.get("Content-Type");
      m = new Blob(_, y ? { type: y } : void 0), g > 0 && v !== g && j.debug(`[TraceScene] Decoded ${v} bytes vs Content-Length ${g} for ${e} (likely compressed transfer)`);
    } else m = await r.blob();
    const u = i.split("/").pop() || "asset", b = (performance.now() - p) / 1e3;
    if (j.log(`[TraceScene] Downloaded ${u}: ${(m.size / 1048576).toFixed(1)} MB in ${b.toFixed(1)}s`), this.babylonScene.isDisposed) throw lt();
    return {
      blob: m,
      fileName: u,
      assetBaseUrl: a
    };
  }
  async createSceneObject(e, t, n) {
    this.initializeSceneRoot();
    const s = t ?? this._sceneRoot;
    if (s && !this.canParentUnder(s)) throw this._vetoReferenceSubtreeParent(e || "NewObject", s);
    const r = this.getSiblingNamesByTransform(s?.transform ?? null), i = he.generateUniqueName(e || "NewObject", r), o = fe.initializeSceneObject({
      name: i,
      src: n || "",
      active: !0,
      transform: { parent: s?.name },
      behaviors: []
    }, this.babylonScene, this.resources, this.config, this, this._eventSystem || void 0);
    return this.sceneObjects.push(o), this._stampNodeUid(o, "created"), s && (o.setParent(s), this._preserveAuthoredWorldRotation(o, s)), o._attachBehaviors(), this._emitSceneChanged([i]), this._emitTopologyChanged([o]), j.log(`[TraceScene] Created new SceneObject: ${i}${s ? ` (child of ${s.name})` : ""}`), o;
  }
  async createSceneObjectFromData(e, t) {
    if (t && !this.canParentUnder(t)) throw this._vetoReferenceSubtreeParent(e.name, t);
    return this._restoreSceneObjectFromData(e, t);
  }
  async _restoreSceneObjectFromData(e, t) {
    this.initializeSceneRoot();
    const n = structuredClone(e);
    if (n.name = he.generateUniqueName(n.name, this.getSiblingNamesByTransform((t ?? this._sceneRoot)?.transform ?? null)), n.uid !== void 0 && this.sceneObjects.some((r) => r.uid === n.uid))
      for (const r of n.behaviors ?? []) r["@type"] === "Provenance" && delete r.placedUids;
    const s = fe.initializeSceneObject(n, this.babylonScene, this.resources, this.config, this, this._eventSystem || void 0);
    this.sceneObjects.push(s), this._stampNodeUid(s, "created"), t ? s.setParent(t) : this._sceneRoot && s.setParent(this._sceneRoot), this._beginConstruction();
    try {
      await s.reload();
    } finally {
      this._endConstruction();
    }
    return this._emitTopologyChanged([s]), s;
  }
  _preserveAuthoredWorldRotation(e, t) {
    t.transform.computeWorldMatrix(!0);
    const n = t.transform.absoluteRotationQuaternion;
    if (we.IsIdentity(n)) return;
    const s = e.transform.rotationQuaternion ?? we.FromEulerVector(e.transform.rotation);
    e.transform.rotationQuaternion = we.Inverse(n).multiply(s);
  }
  deleteSceneObject(e) {
    const t = typeof e == "string" ? this.resolveSceneObject(e) : e;
    if (!t)
      return j.warn("[TraceScene] Cannot delete: object not found"), !1;
    const n = [t, ...t.getDescendants()], s = t.getParent(), r = n.some((i) => i._reparentPending) || !s && t.transform.parent ? void 0 : s ? [s] : [];
    this._selectedObject && n.includes(this._selectedObject) && this.select(null);
    for (let i = n.length - 1; i >= 0; i--) {
      const o = n[i];
      o.destroy();
      const a = this.sceneObjects.indexOf(o);
      a !== -1 && this.sceneObjects.splice(a, 1), j.log(`[TraceScene] Deleted SceneObject: ${o.name}`);
    }
    return this._emitSceneChanged(n.map((i) => i.name)), this._emitTopologyChanged(r), !0;
  }
  getDescendants(e) {
    return e.getDescendants();
  }
  getChildren(e) {
    return e.getChildren();
  }
  async openAsRoot(e, t, n, s, r, i) {
    j.log(`[TraceScene] openAsRoot: ${e} with ${t?.length ?? 0} extra behaviors: ${t?.map((g) => g["@type"]).join(", ") ?? "none"}`);
    const { blob: o, fileName: a, assetBaseUrl: l } = r ?? (n ? await this.fetchAssetWithProgress(e, n, i) : await this.fetchAsset(e, i));
    this.clearScene(), await this._loadFromBlob(o, a, void 0, s, void 0, void 0, t, l, !1), await this.startScene(), j.log(`[TraceScene] Opened asset as root: ${a}`);
  }
  clearScene() {
    this._playModeInitialized = !1, this._renderingStarted = !1, this.select(null);
    const e = this.sceneObjects.map((s) => s.name);
    for (let s = this.sceneObjects.length - 1; s >= 0; s--) this.sceneObjects[s].destroy();
    this._sceneRoot = null, this._sessionDocumentRoot = null, this.sceneObjects = [], this.resources.clearAssets(), this._scriptRegistry.clear(), this._scriptsMap = void 0, this._foreignDocument = void 0, this._sceneSourceFormat = "", this._runtimeSelectionManager && (this._runtimeSelectionManager.dispose(), this._runtimeSelectionManager = null), this._audioManager && (this._audioManager.dispose(), this._audioManager = null), this._contactShadow && (this._contactShadow.dispose(), this._contactShadow = null), [...this.babylonScene.effectLayers].forEach((s) => s.dispose()), [...this.babylonScene.particleSystems].forEach((s) => s.dispose()), [...this.babylonScene.animationGroups].forEach((s) => s.dispose()), [...this.babylonScene.meshes].forEach((s) => s.dispose()), [...this.babylonScene.transformNodes].forEach((s) => s.dispose()), [...this.babylonScene.materials].forEach((s) => s.dispose());
    const t = this.babylonScene.environmentTexture;
    [...this.babylonScene.textures].filter((s) => s !== t).forEach((s) => s.dispose()), [...this.babylonScene.lights].forEach((s) => s.dispose());
    const n = this.babylonScene._depthRenderer;
    if (n) for (const s of Object.keys(n)) delete n[s];
    this.babylonScene.environmentBRDFTexture = null, this.babylonScene.resetCachedMaterial(), this.babylonScene.freeProcessedMaterials(), this.babylonScene.freeActiveMeshes(), this.babylonScene.freeRenderingGroups(), this.setupLights(), this.initializeSceneRoot(), e.length > 0 && this._emitSceneChanged(e), j.log(`[TraceScene] Cleared scene (removed ${e.length} objects)`);
  }
  dispose() {
    this._cancelStartEvents(), this.clearScene(), this._occluderMode.dispose(), this.babylonScene.dispose();
  }
  setXRSessionActive(e) {
    this._occluderMode.setXRActive(e);
  }
  isOccluderDepthOnly() {
    return this._occluderMode.depthOnly;
  }
  frameScene() {
    this.camera && st.calculateSceneBoundingBox(this.babylonScene, this.camera, this.config, this._safeAreaInsets);
  }
  startRendering() {
    this._renderingStarted || (this._renderingStarted = !0, this.camera && this.camera.attachControl(this.canvas, !0), this.babylonScene.render(), this.engine.stopRenderLoop(), this.engine.runRenderLoop(() => {
      if (this.babylonScene && this.camera) {
        const e = this.babylonScene.activeCamera;
        e !== this.camera && e?.name.startsWith("__") && (this.babylonScene.activeCamera = this.camera), this.babylonScene.render();
      }
    }));
  }
  async startScene() {
    if (this.initializeSceneRoot(), j.log("Files loaded successfully!"), j.log(`alpha is ${this.alpha}`), this.backgroundColor) {
      this.alpha || (this.alpha = 1);
      const e = ft.FromHexString(this.backgroundColor);
      this.babylonScene.clearColor = new Ge(e.r, e.g, e.b, this.alpha);
    } else
      this.alpha = this.alpha || 0.01, this.babylonScene.clearColor = new Ge(0, 0, 0, this.alpha);
    this._updateMeshPickability(this._playMode), this._applyClickToSelect(), this._flushStartEvents(), this._playMode && !this._playModeInitialized && (this._playModeInitialized = !0, this._fireStartInteractions()), this._alignShadowToContentBottom();
  }
};
export {
  Ts as _,
  pr as a,
  xs as b,
  _n as c,
  pn as d,
  an as f,
  dr as g,
  ur as h,
  Et as i,
  jt as l,
  Bs as m,
  mr as n,
  An as o,
  sn as p,
  Tt as r,
  vn as s,
  Ot as t,
  Ut as u,
  Ve as v,
  hr as y
};

//# sourceMappingURL=TraceScene-CTdK35pV.js.map